export default {
	common: {
		appName: 'Hela',
		poweredBy: 'Powered by:',
		// The entity picker asks the same question wherever it is opened from:
		// which case entity should this standalone result belong to.
		entityLink: {
			searchLabel: 'Search entities',
			searchPlaceholder: 'Search by name, document or registration number',
			noResults: 'No matching entities found.',
			recentResultsTitle: 'Recently updated',
			recentEmpty: 'No recently updated entities found.',
			confirmAction: 'Link selected entity',
		},
		links: {
			login: 'Login',
			sendEmail: 'Send email',
		},
		boolean: {
			yes: 'Yes',
			no: 'No',
		},
		actions: {
			add: 'Add',
			addNewNote: 'Add new note',
			addNote: 'Add Note',
			edit: 'Edit',
			view: 'View',
			create: 'Create',
			save: 'Save',
			reset: 'Reset',
			resetToDefault: 'Reset to default',
			cancel: 'Cancel',
			confirm: 'Confirm',
			continue: 'Continue',
			close: 'Close',
			back: 'Back',
			next: 'Next',
			previous: 'Previous',
			finish: 'Finish',
			search: 'Search',
			select: 'Select',
			deselect: 'Deselect',
			retry: 'Retry',
			show: 'Show',
			hide: 'Hide',
			expandAll: 'Expand All',
			collapseAll: 'Collapse All',
			update: 'Update',
			discard: 'Discard',
			dismiss: 'Dismiss',
			ignore: 'Ignore',
			delete: 'Delete',
			copy: 'Copy',
			print: 'Print',
			download: 'Download',
			zoomIn: 'Zoom in',
			rotate: 'Rotate',
			logout: 'Logout',
			openNewTab: 'Open in new tab',
			openAsPage: 'Open as page',
			goToCase: 'Go to Case Entity',
			releaseNotes: 'Release Notes',
			visitArritech: 'Visit Arritech',
		},
		labels: {
			actions: 'Actions',
			total: 'Total',
			default: 'Default',
			details: 'Details',
			name: 'Name',
			group: 'Group',
			title: 'Title',
			all: 'All',
			unknown: 'Unknown',
			id: 'ID',
			entityId: 'Entity ID',
			reference: 'Reference',
			summary: 'Summary',
			date: 'Date',
			country: 'Country',
			source: 'Source',
			users: 'Users',
			members: 'Members',
			document: 'Document',
			notes: 'Notes',
			tags: 'Tags',
			hits: 'Hits',
			history: 'History',
			checkTypes: 'Check Types',
			status: 'Status',
			type: 'Type',
			version: 'Version',
			merchantId: 'Organisation ID',
			createdAt: 'Created At',
			createdOn: 'Created On',
			createdBy: 'Created By',
			modifiedAt: 'Modified At',
			modifiedBy: 'Modified By',
			revision: 'Revision',
			content: 'Content',
			mockComponent: 'Mock Component',
			description: 'Description',
		},
		placeholders: {
			select: 'Select...',
			search: 'Search',
			typeToFilter: 'Type to filter...',
		},
		features: {
			cases: 'Cases',
			aml: 'AML',
			forms: 'Smart Forms',
			poa: 'Proof of Address',
			entity: 'Entity',
			system: 'System',
		},
		form: {
			label: 'Label',
		},
		breadcrumb: {
			dashboard: 'Dashboard',
			reports: 'Reports',
			billing: 'Billing',
			webhooks: 'Webhooks',
			merchants: 'Merchants',
			caseDetails: 'Case Details',
		},
		aria: {
			breadcrumb: 'breadcrumb',
			pagination: 'Pagination',
			closeNotification: 'Close notification',
			togglePasswordVisibility: 'Toggle password visibility',
			removeSelection: 'Remove selection',
			clearSelections: 'Clear selections',
			clearInput: 'Clear input',
		},
		tooltips: {
			copyIdToClipboard: 'Copy ID to clipboard',
			copied: 'Copied',
		},
		messages: {
			copySuccess: 'Successfully copied',
			deleteCancelled: 'Delete cancelled.',
		},
		branding: {
			byArritech: 'by Arritech',
			anArritechProductPrefix: 'An',
			anArritechProductSuffix: 'product.',
		},
		table: {
			noData: 'No data found',
			noResults: 'No results',
			selectedCount: '{count} selected',
			selectedItems: 'Selected items',
			selectAllPage: 'Select all on page',
			clearSelection: 'Deselect all',
			moreSelected: 'more selected',
			pagination: 'Showing {from} to {to} of {total} entries',
		},
		footer: {
			allRightsReserved: 'All Rights Reserved',
		},
		pagination: {
			itemsPerPage: 'Items per page',
			goTo: 'Go to',
		},
		validation: {
			invalidIpAddress: 'Invalid IP address',
			localIpNotAllowed: 'Local and reserved IP addresses are not allowed.',
			ipMustBeUnique: 'Sorry, IP must be unique',
			invalidPhoneNumber: 'Invalid phone number',
			numberOutOfRange: 'Must be between {min} and {max}',
			numberBelowMin: 'Must be {min} or more',
			numberAboveMax: 'Must be {max} or less',
		},
		sidebar: {
			appInformation: 'App Information',
			defaults: {
				appName: 'QGen Online',
				versionDevelopment: 'Version: Development',
				description:
					'QGen helps teams monitor cases, screening, API workflows, and reporting in one workspace.',
			},
			tooltips: {
				aboutQgen: 'About QGen',
				expand: 'Expand sidebar',
				collapse: 'Collapse sidebar',
			},
			menu: {
				dashboard: 'Dashboard',
				overview: 'Overview',
				batch: 'Batch',
				templates: 'Templates',
				roles: 'Roles',
				agents: 'Agents',
				trigger: 'Trigger',
				settings: 'Settings',
				billingOverview: 'Billing',
				manageOrganisation: 'Manage',
				suConfig: 'SU Config',
				newSubmission: 'New submission',
				amlScreening: 'AML Screening',
				flows: 'Flows',
				organization: 'Organisation',
				pricing: 'Pricing',
				merchants: 'Merchants',
				api: 'API',
			},
		},
		richText: {
			headings: {
				h1: 'H1',
				h2: 'H2',
				h3: 'H3',
			},
			actions: {
				bold: 'Bold',
				italic: 'Italic',
				strike: 'Strike',
				bulletList: 'Bullet list',
				orderedList: 'Ordered list',
				blockquote: 'Blockquote',
				horizontalRule: 'Horizontal rule',
				undo: 'Undo',
				redo: 'Redo',
				link: 'Link',
				unlink: 'Unlink',
				image: 'Image',
				alignLeft: 'Align left',
				alignCenter: 'Align center',
				alignRight: 'Align right',
				insertTable: 'Insert table',
				deleteTable: 'Delete table',
			},
		},
		loading: {
			default: 'Loading...',
			downloading: 'Downloading...',
			credentials: 'Trying to load your credentials, please wait a second...',
		},
		userMenu: {
			myProfile: 'My Profile',
			support: 'Support',
		},
		permissions: {
			requiresRole: 'Requires the {role} role.',
			requiresRoles: 'Requires the {roles} roles.',
			viewOnly: 'View only — editing requires the {role} role.',
			primaryOwnerOnly: 'Only the Primary Owner can do this.',
			primaryOwnerCeiling:
				'The Primary Owner always keeps the {role} role. Transfer primary ownership to change it.',
			valueHidden: 'Not shown — requires the {role} role.',
			sectionRequiresRole: 'This section requires the {role} role.',
			notInPlan: 'Not included in your plan.',
		},
	},
	home: {
		nav: {
			overview: 'Overview',
			capabilities: 'Capabilities',
			benefits: 'Benefits',
			experience: 'Experience',
			industries: 'Industries',
			contact: 'Book a demo',
			releaseNotes: 'Release notes',
		},
		hero: {
			eyebrow: 'QGen Online',
			title: 'One platform for end-to-end compliance and verification',
			description:
				'QGen Online helps businesses manage onboarding, KYC, KYB, screening, monitoring, and case management in one streamlined platform, with a mix of automated and manual checks designed to support regulatory compliance and reduce operational friction.',
			primaryAction: 'Book a demo',
			secondaryActionLoggedOut: 'Sign in',
			secondaryActionLoggedIn: 'Open dashboard',
			points: {
				lifecycle: {
					title: 'Customer lifecycle ready',
					description:
						'Built for complete customer lifecycle management from onboarding to ongoing monitoring.',
				},
				automation: {
					title: 'Automation with control',
					description:
						'Automated where it should be, controlled where it matters for higher-confidence compliance operations.',
				},
				regulated: {
					title: 'Made for regulated teams',
					description:
						'Designed for businesses that need speed, accuracy, and confidence without weakening oversight.',
				},
			},
		},
		capabilities: {
			eyebrow: 'What QGen Online does',
			title: 'Everything you need to verify, screen, and manage risk',
			description:
				'QGen Online brings together the core parts of modern compliance into a single solution. From identity and business verification to ongoing monitoring and compliance management, it gives teams one place to manage the full verification journey more efficiently and with greater consistency.',
			cards: {
				kycKyb: {
					title: 'KYC and KYB',
					description:
						'Verify individuals and businesses with accurate data extraction and validation from official data and registry sources.',
				},
				screening: {
					title: 'Screening and monitoring',
					description:
						'Run real-time screening on companies, UBOs, and directors for political exposure, adverse media, and related risk indicators, while supporting ongoing monitoring over time.',
				},
				caseManagement: {
					title: 'Case management',
					description:
						'Manage compliance tasks and client records in a CRM-style environment built for end-to-end lifecycle oversight.',
				},
				automation: {
					title: 'Automation and integrations',
					description:
						'Use cloud-based workflows for faster onboarding, with optional API integration for deeper connection to existing systems.',
				},
			},
		},
		benefits: {
			eyebrow: 'Why teams choose it',
			title: 'Built to reduce friction without reducing control',
			description:
				'Many compliance processes are still slowed down by fragmented tools, manual handling, and poor user experience. QGen Online is positioned as a more modern alternative: scalable, easier to use, and designed to reduce manual effort while improving security, transparency, and operational efficiency.',
			cards: {
				complexity: {
					title: 'Lower operational complexity',
					description:
						'Consolidate multiple compliance tasks into one solution instead of relying on separate providers and disconnected workflows.',
				},
				onboarding: {
					title: 'Faster onboarding',
					description:
						'Accelerate verification with AI-supported features such as document recognition, liveness, and face match, alongside automated and manual checks.',
				},
				accuracy: {
					title: 'Better accuracy',
					description:
						'Reduce transcription errors and false positives by combining trusted data sources with human oversight where needed.',
				},
				scale: {
					title: 'Secure and scalable',
					description:
						'Support businesses from smaller firms to larger institutions, with broader customisation available for more complex verification flows.',
				},
			},
		},
		experience: {
			eyebrow: 'Customer experience',
			title: 'Make KYC feel easy for the people going through it',
			description:
				'QGen Online helps teams turn onboarding into a guided, trustworthy experience instead of a task customers want to abandon. Faster checks, clearer steps, and fewer dead ends make verification feel like progress for your customers, not a hassle.',
		},
		industries: {
			eyebrow: 'Who it is for',
			title: 'Designed for regulated industries',
			description:
				'QGen Online is positioned for businesses that need strong compliance controls without slowing down customer or client onboarding. Arritech highlights its use across multiple regulated sectors, making it suitable for organisations with different risk models, workflows, and regulatory demands.',
			items: {
				fintech: 'Fintech',
				banks: 'Banks',
				igaming: 'iGaming',
				csp: 'Corporate Service Providers',
				paymentProviders: 'Payment Providers and EMI',
				realEstate: 'Real Estate',
				notaries: 'Notaries and Accountants',
				crypto: 'Crypto',
			},
			closingLine:
				'Wherever compliance is critical, QGen Online helps teams reduce fraud, improve trust, and maintain control across the customer lifecycle.',
		},
		finalCta: {
			eyebrow: 'Ready when you are',
			title: 'Ready to modernise your compliance operations?',
			description:
				'QGen Online combines verification, screening, monitoring, and case management in one platform so your team can work faster, stay compliant, and scale with confidence. Whether you are improving an existing process or replacing fragmented tools, QGen Online is built to support the next generation of compliance workflows.',
			primaryAction: 'Book a demo',
		},
		demoPopup: {
			title: 'Request a QGen Online demo',
			description:
				'Share a few details about your team and we will follow up with a tailored walkthrough.',
			eyebrow: 'Book a demo',
			body: 'Tell us about your onboarding flow, compliance priorities, or the systems you want QGen Online to fit into.',
			signalLabel: 'Best fit for',
			signalCopy:
				'Compliance teams evaluating onboarding, screening, monitoring, or full lifecycle verification workflows.',
			note: 'If you prefer a direct intro, email us at',
			submit: 'Send request',
			fields: {
				fullName: {
					label: 'Full name',
					placeholder: 'Jane Smith',
				},
				workEmail: {
					label: 'Work email',
					placeholder: "jane{'@'}company.com",
				},
				companyName: {
					label: 'Company',
					placeholder: 'Arritech',
				},
				message: {
					label: 'What would you like to discuss?',
					placeholder:
						'Share your onboarding flow, current tooling, regions, or any specific compliance needs.',
				},
			},
			validation: {
				fullName: 'Full name is required.',
				workEmail: 'Work email is required.',
				workEmailInvalid: 'Enter a valid work email.',
				companyName: 'Company is required.',
				message: 'Message is required.',
			},
		},
		footer: {
			description:
				'QGen Online unifies verification, screening, monitoring, and case management in a single compliance workspace.',
		},
	},
	errors: {
		title: 'Error',
		defaultMessage: 'Something went wrong.',
		fillRequiredFields: 'Please fill in all required fields.',
		connection: {
			title: 'We cannot connect to the server.',
			tryAgainLater: 'Please wait a few minutes before you try again.',
		},
		loadDownloadHistory: 'Failed to load download history.',
		loadBatchHistory: 'Failed to load batch history',
		setWhitelistStatus: 'Failed to set whitelist status',
		addNote: 'Failed to add note',
		downloadPdf: 'Failed to download PDF.',
		loadCheckCategories: 'Failed to load check categories.',
		search: 'Failed to search',
		updateWhitelist: 'Failed to update whitelist.',
		loadMerchants: 'Failed to load merchants.',
		createSearch: 'Failed to create search',
		loadSearch: 'Failed to load search',
		updateStatus: 'Failed to update status',
		reviewUpdate: 'Failed to review update',
		deleteSearchResult: 'Failed to delete search result.',
		downloadCsv: 'Failed to download CSV',
		downloadXslxFile: 'Failed to download XLSX file',
		changeMonitor: 'Failed to change monitor',
		loadSearchResults: 'Failed to load search results',
		submitBatchSearch: 'Failed to submit batch search',
		createBatch: 'Failed to create batch',
		uploadBatchRecords: 'Failed to upload batch records',
		startBatchProcessing: 'Failed to start batch processing',
		loadBatchRecords: 'Failed to load batch records',
		retryBatchSearch: 'Failed to retry batch search',
		startBatchDeleteJob: 'Failed to start batch delete job.',
		startCertificatePreparation: 'Failed to start certificate preparation.',
		generateDownloadLink: 'Failed to generate download link.',
		startCertificateDownloadTryAgain:
			'Failed to start certificate download. Please try again.',
		startCertificateDownload: 'Failed to start certificate download.',
		loadCheckTypes: 'Failed to load check types.',
		loadUsers: 'Failed to load users.',
		logout: 'Failed to log you out',
		extendSession: 'Failed to extend session.',
	},
	maintenance: {
		title: 'System Maintenance in Progress',
		intro:
			'Thank you for visiting QGen Online. We are currently performing scheduled system enhancements to improve your experience.',
		upgradeNotice:
			'While these necessary upgrades are underway, our service will be temporarily unavailable. We are making every effort to keep this disruption as brief as possible and to restore full service swiftly.',
		apology:
			'We apologise for any inconvenience this may cause and thank you for your patience and understanding.',
		supportLead:
			'For updates or further assistance, please contact our support team at',
		supportEmail: "support{'@'}arritech.com",
		signoff: 'The QGen Online Team, Arritech',
	},
	noAccess: {
		title: "You don't have access to this page",
		noAccess:
			'Your role does not include this part of QGen Online. If you need it, ask your organisation admin to update your permissions.',
		unavailableForAccount:
			"This page is not available for your organisation's account setup.",
		notInPlan:
			"This feature is not included in your organisation's plan. If you need it, ask your organisation admin about adding it.",
		hint: 'You can head back to the dashboard and carry on from there.',
		backCta: 'Back to dashboard',
	},
	notFound: {
		title: 'Page Not Found',
		body: 'Oops! It seems that this page does not exist.',
		backCta: 'to main page',
		backLead: 'You can navigate back',
	},
	uBlock: {
		title: 'Unblock Account',
		emailLabel: 'Email:',
		activationCodeLabel: 'Activation Code:',
		submit: 'Submit',
		successTitle: 'Success',
		successBody: 'Please check your email for your new password.',
		errorTitle: 'Failed to unblock the user',
		errorBody: 'Failed to unblock user',
	},
	filters: {
		title: 'Filter By',
		clear: 'Clear',
		toggle: 'Filters',
	},
	downloads: {
		retryFailed: 'Retry All Failed Downloads',
		downloadSuccessfulZip: 'Download Successful Files as ZIP',
		download: 'Download',
		downloadZip: 'Download as ZIP',
	},
	notifications: {
		common: {
			actions: {
				send: 'Send',
				delete: 'Delete',
				markAsRead: 'Mark As Read',
				markAsUnread: 'Mark As Unread',
				openRelated: 'Go to item',
			},
			tooltips: {
				markAsRead: 'Mark as read',
				markAsUnread: 'Mark as unread',
				delete: 'Delete',
				toggleReadStatus: 'Toggle read status',
				deleteNotification: 'Delete notification',
			},
			messages: {
				deleted: 'Notification deleted successfully',
			},
			errors: {
				loadNotification: 'Failed to load notification',
				loadNotificationHistory: 'Failed to load notification history.',
				deleteNotification: 'Failed to delete the notification.',
				deleteNotificationShort: 'Failed to delete notification',
				markAsRead: 'Failed to mark as read',
				markAsUnread: 'Failed to mark as unread',
			},
			breadcrumb: {
				notifications: 'Inbox',
			},
		},
		templateDetails: {
			labels: {
				notification: 'Notification',
				variables: 'Available variables',
			},
			ownerPlatform:
				'You are viewing the platform template. Saving a change will create your own copy for this notification.',
			ownerMerchant: 'You are viewing your own customized template.',
			saved: 'Template saved.',
			smsBudget: '{used} of {limit} characters used by the fixed text.',
			smsUnicode:
				'A character outside the standard SMS alphabet (such as ş, ğ or an emoji) reduces the limit from 160 to 70.',
			saveFailed: 'Failed to save the template.',
			loadFailed: 'Failed to load the template.',
			missingKey: 'No notification was specified.',
			htmlOnly:
				'This template uses formatting the visual editor cannot keep, such as table layout or styled buttons. It opens as HTML so nothing is lost.',
			drift:
				'The platform template has been updated since you customized this one. Your version is still the one being sent.',
			revert: {
				action: 'Revert to platform default',
				confirmTitle: 'Revert to the platform template?',
				confirmMessage:
					'This notification will go back to using the platform template. Your customized version is kept in the history and can be recreated by editing again.',
				confirm: 'Revert',
				done: 'Reverted to the platform template.',
				failed: 'Failed to revert the template.',
			},
		},
		history: {
			title: 'Inbox',
			groups: {
				new: 'New',
				today: 'Today',
				yesterday: 'Yesterday',
				unknown: 'Undated',
			},
			panel: {
				empty: 'Select a notification to read it here.',
			},
			filters: {
				title: 'Filter',
				show: 'Show',
				all: 'All',
				onlyNew: 'Only new',
				category: 'Category',
			},
			empty: {
				none: 'No notifications found',
			},
		},
	},
	dashboard: {
		layout: {
			navbar: {
				actions: {
					switchMerchant: 'Switch Merchant',
					resetImpersonation: 'Reset Impersonation',
				},
				popups: {
					merchantSwitcher: {
						title: 'Switch Merchant',
						searchPlaceholder: 'Search merchant by name or ID',
						empty: 'No linked merchants available',
						loading: 'Loading merchants...',
						currentMerchant: 'Current merchant',
					},
				},
				tooltips: {
					switchToLightMode: 'Switch to light mode',
					switchToDarkMode: 'Switch to dark mode',
				},
				dialogs: {
					discardChanges: {
						title: 'Discard changes?',
						body: 'You have unsaved data. It will be lost if you go to another page.',
					},
				},
				errors: {
					impersonateMerchant: 'Failed to impersonate merchant',
					findLinkedMerchants: 'Failed to find linked merchants',
					resetImpersonation: 'Failed to reset impersonation',
				},
			},
		},
		downloadBiRecords: {
			title: 'Liveness Logs',
			placeholders: {
				startDate: 'Start date',
				endDate: 'End date',
			},
			actions: {
				downloadRecords: 'Download Records',
			},
			errors: {
				invalidDateRange: 'Please select a valid date range.',
			},
		},
		charts: {
			titles: {
				executionTime: 'Execution Time Distribution',
				statusCode: 'Status Code',
				resolution: 'Resolution Distribution',
				osDistribution: 'OS Distribution',
				probabilities: 'Probabilities Distribution',
				failedValidations: 'Failed Validations Distribution',
			},
			failedValidations: {
				faceLarge: 'Face Large',
				faceClose: 'Face Close',
				occluded: 'Occluded',
			},
			amlMonitoring: {
				monitored: 'Monitored',
				unmonitored: 'Unmonitored',
			},
			users2fa: {
				enabled: 'MFA Enabled',
				disabled: 'MFA Disabled',
			},
			errors: {
				amlTotalUnavailable:
					'Chart for AML total searches cannot be displayed.',
				loadCounts: 'Failed to load dashboard counts.',
				loadTotalUsers: 'Failed to load total users.',
			},
		},
		main: {
			labels: {
				lastLogin: 'Last Login:',
				company: 'Company',
				managedUsers: 'Managed Users',
				roles: 'Roles',
			},
			cards: {
				recentActivity: 'Recent Activity',
				notifications: 'Inbox',
				recentSearches: 'Recent Searches',
				statistics: 'Statistics',
				nameScreeningStatistics: 'Name Screening Statistics',
				users2faUsage: 'Users MFA Usage',
				faceLivenessChecks: 'Face Liveness Checks',
			},
			actions: {
				today: 'Today',
				thisWeek: 'This week',
				allCases: 'All Cases',
				allSearches: 'All Searches',
				goToNotifications: 'Go to Notifications',
			},
			empty: {
				nothingHappenedToday: 'Nothing happened today',
				noNewNotifications: 'No new notifications',
			},
			table: {
				searchType: 'Search Type',
			},
			statCards: {
				cases: 'Cases',
				aml: 'AML',
				users: 'Users',
				notifications: 'Notifications',
			},
			messages: {
				welcomeUser: 'Welcome {name}',
				settingsUpdated: 'Dashboard settings updated successfully.',
			},
			errors: {
				loadSearches: 'Failed to load searches.',
				loadLatestCases: 'Failed to load latest cases.',
				loadSettings: 'Failed to load dashboard settings.',
				updateSettings: 'Failed to update dashboard settings.',
			},
		},
	},
	api: {
		common: {
			breadcrumb: {
				dashboard: 'Dashboard',
				details: 'Details',
			},
			tooltips: {
				copyLogDetails: 'Copy log details',
			},
			messages: {
				logDetailsCopied: 'Log details copied successfully',
			},
			errors: {
				loadWebhooks: 'Failed to load webhooks.',
				loadModules: 'Failed to load modules.',
			},
		},
		logPanel: {
			title: 'Log Details',
			fields: {
				correlationId: 'Correlation ID',
				host: 'Host',
				method: 'Method',
				actionName: 'Action Name',
				path: 'Path',
				fullPath: 'Full Path',
				timestamp: 'Timestamp',
				userName: 'User Name',
				merchantId: 'Merchant ID',
				module: 'Module',
				responseCode: 'Response Code',
				refId: 'Ref. ID',
				clientId: 'Client ID',
			},
		},
		eventLogDetails: {
			title: 'Event Log Details',
			breadcrumb: {
				eventLogs: 'Event Logs (Webhooks)',
			},
		},
		analyser: {
			title: 'Logs',
			retentionNotice:
				'Logs are retained for 90 days and then permanently deleted.',
			filters: {
				advancedSearch: 'Advanced Search',
				labels: {
					keyName: 'Key Name',
					selectDate: 'Select Date',
				},
			},
			actions: {
				resetFilters: 'Reset Filters',
				downloadLogs: 'Download Logs',
				sidebarLayout: 'Sidebar view',
				topLayout: 'Top to bottom view',
			},
			columns: {
				action: 'Action',
				actionTime: 'Action Time',
			},
			empty: {
				noLogs: 'No previous logs found',
			},
			shortcuts: {
				today: 'Today',
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				lastThreeMonths: 'Last 3 months',
				lastSixMonths: 'Last 6 months',
			},
			download: {
				limitTooltip:
					'You need to narrow the search to less than {limit} records',
				filePrefix: 'Logs',
			},
			csvHeaders: {
				requestBody: 'Request Body',
				time: 'Time',
			},
			errors: {
				loadLogs: 'Failed to load API Keys Logs.',
				downloadLogs: 'Failed to download API Keys Logs.',
				loadFilters: 'Failed to load logs filters.',
			},
		},
		eventLogs: {
			retentionNotice:
				'Event logs are retained for 90 days and then permanently deleted.',
			filters: {
				labels: {
					statusCode: 'Status Code',
					caseType: 'Case Type',
					caseId: 'Case ID',
					sessionId: 'Session ID',
					entityId: 'Entity ID',
					selectDate: 'Select Date',
				},
				placeholders: {
					caseId: 'Enter Case ID',
					sessionId: 'Enter Session ID',
					entityId: 'Enter Entity ID',
				},
			},
			actions: {
				applyFilter: 'Apply Filter',
				downloadCsv: 'Download Logs as CSV',
				downloadJson: 'Download Logs as JSON',
			},
			download: {
				limitTooltip:
					'You need to narrow the search to less than {limit} records',
				limitSuffix: '(Limit: {limit})',
				filePrefix: 'Logs',
			},
			table: {
				columns: {
					caseId: 'Case ID',
					caseType: 'Case Type',
					statusCode: 'Status Code',
				},
				deletedWebhook: '(deleted webhook)',
			},
			panel: {
				title: 'Log Details',
				labels: {
					id: 'ID',
					applicantId: 'Applicant ID',
					caseId: 'Case ID',
					createdAt: 'Created At',
					eventType: 'Event Type',
					merchantId: 'Merchant ID',
					referenceId: 'Reference ID',
					status: 'Status',
					statusCode: 'Status Code',
					webhookId: 'Webhook ID',
					endpoint: 'Endpoint',
				},
			},
			empty: {
				noLogs: 'No previous logs found',
			},
			statuses: {
				new: 'New',
				succeed: 'Succeed',
				failed: 'Failed',
			},
			caseTypes: {
				otherGroup: 'Other',
			},
			errors: {
				loadCaseTypes: 'Failed to load case types',
				load: 'Failed to load Event Type Logs.',
			},
		},
		dialogs: {
			expire: {
				warning:
					'Are you sure you want to expire this key? Once expired this key cannot be used again. Make sure that this will not impact any of your ongoing calls. Please proceed with caution.',
				confirmationText:
					'You confirm that by expiring this API key, you are aware that all ongoing API calls and integrations will be disabled.',
				messages: {
					success: 'API Key expired successfully.',
				},
				errors: {
					expire: 'Failed to expire API Key.',
				},
			},
			keyGenerateSuccess: {
				labels: {
					clientId: 'Client ID',
					clientSecret: 'Client Secret',
					signingSecret: 'Signing Secret',
				},
				warning:
					'This is your unique API key that only you can see. It cannot be recovered. If you lose your API key you will have to reset it.',
				clientSecretWarning:
					'This client secret is only shown here. Copy it before closing this window.',
				messages: {
					copySuccess: 'API key copied successfully.',
				},
			},
		},
		webhooks: {
			common: {
				labels: {
					webhookName: 'Webhook Name',
					endpoint: 'Endpoint',
					module: 'Module',
					eventType: 'Event Type',
				},
				tooltips: {
					deleteWebhook: 'Delete webhook',
				},
				dialogs: {
					delete: {
						title: 'Delete!',
						body: 'Are you sure you want to delete the webhook?',
					},
				},
				messages: {
					deleted: 'Webhook deleted successfully.',
				},
				errors: {
					delete: 'Failed to delete the webhook.',
				},
			},
			list: {
				title: 'Webhooks',
				empty: {
					noWebhooks: 'No webhook found',
				},
				tooltips: {
					toggleStatus: 'Enable or disable this webhook',
				},
				dialogs: {
					updateStatus: {
						title: 'Update!',
						body: 'Are you sure you want to update the status?',
					},
				},
				messages: {
					statusUpdated: 'Webhook status updated successfully.',
				},
				errors: {
					updateStatus: 'Failed to update webhook status.',
				},
			},
			form: {
				labels: {
					signingSecret: 'Signing Secret',
				},
				tooltips: {
					signingSecret:
						'You can use this secret to verify that webhook requests were sent by QGen Online and were not changed in transit.',
				},
				placeholders: {
					selectModule: 'Select module',
					selectEvent: 'Select Event',
				},
				actions: {
					create: 'Create Webhook',
					update: 'Update',
				},
				validation: {
					validUrl: 'Requires a valid url',
					eventTypeRequired: 'The event type is required',
				},
				messages: {
					created: 'Webhook created successfully',
					updated: 'Webhook updated successfully.',
				},
				errors: {
					loadDetails: 'Failed to load webhook details.',
					loadModules: 'Failed to load modules.',
					create: 'Failed to create webhook.',
					update: 'Failed to update webhook.',
				},
			},
		},
		keys: {
			common: {
				labels: {
					expiration: 'Expiration',
					whitelistedIps: 'Whitelisted IPs',
					ips: "IP's",
					moduleAccessQuestion: 'Which module do you want this key to access?',
				},
				placeholders: {
					optional: 'optional',
					expiryDuration: 'Expiry duration',
				},
				durations: {
					unlimited: 'Unlimited',
					days: '{days} days',
				},
				durationOptions: {
					unlimited: 'Unlimited',
					oneMonth: '1 month',
					threeMonths: '3 months',
					sixMonths: '6 months',
					oneYear: '1 year',
					twoYears: '2 years',
				},
				errors: {
					loadModuleRoles: 'Failed to load module roles.',
					pendingIpAddress:
						'Add the typed IP address to the list before saving.',
				},
			},
			create: {
				title: 'Create API Key',
				description:
					'To connect securely to QGen Online API, your application needs an API key with permission to access the data and resources.',
			},
			list: {
				title: 'API Keys',
				actions: {
					createApiKey: 'Create API Key',
					documentation: 'Documentation',
				},
				columns: {
					expiryDuration: 'Expiry Duration',
					modules: 'Modules',
					expirationDate: 'Expiration Date',
				},
				chips: {
					expired: 'Expired',
				},
				labels: {
					noExpiry: 'No expiry',
				},
				empty: {
					noKeys: 'No previous keys found',
				},
				tooltips: {
					alreadyExpired: 'Already expired',
					expireKey: 'Expire API Key',
					deleteKey: 'Delete API Key',
				},
				dialogs: {
					expire: {
						title: 'Expire API key',
					},
					delete: {
						title: 'Delete!',
						body: 'Are you sure you want to delete the API Key?',
					},
				},
				messages: {
					deleted: 'API Key deleted successfully.',
				},
				errors: {
					load: 'Failed to load API Keys.',
					delete: 'Failed to delete API Key.',
				},
			},
			form: {
				labels: {
					friendlyKeyName: 'Friendly Key Name',
				},
				actions: {
					createApiKey: 'Create API Key',
				},
				dialogs: {
					generated: {
						title: 'API key generated successfully',
					},
				},
				errors: {
					create: 'Failed to create API Key.',
					noModuleAccess:
						'You do not have any module access to create an API Key.',
					minOneRole: 'Select at least one module role for the API key.',
				},
			},
			details: {
				title: 'Details',
				labels: {
					id: 'ID',
					status: 'Status',
					createdBy: 'Created by',
					createdAt: 'Created at',
				},
				status: {
					active: 'Active',
					expired: 'Expired',
					noExpiry: 'No Expiry',
					expiresOn: 'Expires {date}',
				},
				modules: {
					title: 'API Modules',
					description:
						'Select which modules this API key is permitted to access. Each module grants the key specific permissions within that area of the platform.',
				},
				actions: {
					updateKey: 'Update Key',
					expire: 'Expire',
				},
				dialogs: {
					updateConfirm: {
						title: 'Update API key',
						message:
							'You are about to update this API key. Changes to expiry, whitelisting, or module permissions will take effect immediately and may impact live integrations. Are you sure you want to continue?',
					},
				},
				messages: {
					updated: 'API Key updated successfully.',
					expiredReadOnly: 'This key has expired and can no longer be edited.',
				},
				errors: {
					invalidKey: 'Not a valid API Key.',
					update: 'Failed to update API Key.',
				},
			},
		},
	},
	cases: {
		common: {
			breadcrumb: {
				dashboard: 'Dashboard',
				caseManagement: 'Case Management',
				cases: 'Cases',
			},
			labels: {
				cases: 'Cases',
				caseId: 'Case ID',
				caseStatus: 'Case Status',
				caseType: 'Case Type',
				type: 'Type',
				priority: 'Priority',
				description: 'Description',
				expiryDate: 'Expiry Date',
				files: 'Files',
				history: 'History',
				timeline: 'Timeline',
				journeys: 'Journeys',
				entities: 'Entities',
				notAvailable: 'N/A',
				summary: 'Summary',
			},
			placeholders: {
				caseId: 'Case ID',
				caseReference: 'Case reference',
				caseDescription: 'Case description',
				caseSummary: 'Case summary',
				optional: 'Optional',
			},
		},
		create: {
			labels: {
				newCase: 'New Case',
			},
			actions: {
				createNewCase: 'Create New Case',
			},
			messages: {
				created: 'Case created successfully',
			},
			errors: {
				loadConstants: 'Failed to load case types, statuses and priorities',
				create: 'Failed to create case.',
			},
		},
		update: {
			messages: {
				updated: 'Case details updated successfully',
			},
			errors: {
				updateCaseDetails: 'Failed to update case details',
			},
		},
		summary: {
			description: 'Case overview, status, and details.',
			buttons: {
				exportCase: 'Export Case',
			},
			messages: {
				exportTriggered:
					'Case export triggered. The download link will be sent by email shortly.',
			},
			errors: {
				loadStatusesAndPriorities: 'Failed to load statuses and priorities',
				loadCaseStatuses: 'Failed to load case statuses',
				loadCasePriorities: 'Failed to load case priorities',
				exportFailed: 'Failed to trigger case export.',
			},
			statusCard: {
				labels: {
					statusNote: 'Status Notes',
				},
				messages: {
					updated: 'Case status updated successfully',
				},
				warnings: {
					missingStatusSetTitle: 'Status set no longer exists',
					missingStatusSet:
						'The status set configured on this case is no longer in the system. Change the status to one of the available statuses.',
					missingStatusTitle: 'Current status no longer exists',
					missingStatus:
						'The current status "{status}" is no longer available in this case status set. Select another status and save the case.',
				},
				errors: {
					update: 'Failed to update case status',
				},
			},
			entities: {
				description: 'The individuals and companies linked to this case.',
				empty: 'No entities',
				actions: {
					addNewEntity: 'Add new entity',
				},
				table: {
					entityName: 'Entity Name',
				},
				errors: {
					loadEntities: 'Failed to load entities.',
				},
			},
		},
		exports: {
			title: 'Exports',
			details: {
				title: 'Export Details',
				readyTitle: 'Your export is ready!',
				readyMessage:
					'The exported file has been successfully generated and is now available for download in the Cases Exports screen.',
				passwordLabel: 'Archive Password',
				downloadButton: 'Download File',
				pendingTitle: 'Export in progress...',
				pendingMessage:
					'Your export request is currently being processed by our system. This may take a few minutes depending on the size of the data.',
				refreshHelp: 'This page will automatically refresh every 10 seconds.',
				expiredTitle: 'Export Expired',
				expiredMessage:
					'This export file is no longer available. For security reasons, generated exports are automatically deleted after 14 days.',
				failedTitle: 'Export Failed',
				failedMessage:
					'An error occurred while generating your export. Please try requesting a new export or contact support if the issue persists.',
				notFound: 'Export not found or you do not have permission to view it.',
			},
			table: {
				id: 'Export ID',
				status: 'Status',
				expiresAt: 'Expires At',
				createdAt: 'Requested At',
				createdBy: 'Requested By',
				empty: 'No exports found',
			},
			statuses: {
				unknown: 'Unknown',
				completed: 'Completed',
				pending: 'Pending',
				expired: 'Expired',
			},
			errors: {
				loadExports: 'Failed to load case exports.',
				loadDetails: 'Failed to load case export details.',
			},
		},
		fileUpload: {
			dialogTitle: 'Add Files',
			count: '{count} file(s) added',
			dropzone: {
				dropHere: 'Drop file here or',
				clickToUpload: 'click to upload',
				acceptedTypes: 'Accepted file types: {types}',
			},
			actions: {
				clearAll: 'Clear All',
				upload: 'Upload',
			},
			messages: {
				infoTitle: 'Info',
				uploaded: 'case Document(s) uploaded successfully',
				cannotCloseUploading: 'Cannot close the window. Uploading file(s)...',
				maxFilesPerBatch:
					'Only 10 files can be uploaded at a time.  You can add more files once this batch has been uploaded.',
			},
			errors: {
				selectFiles: 'Please select file(s)',
				uploadDocuments: 'Failed to upload document(s)',
				cannotUpload: "case Document(s) can't not be uploaded",
				fileSizeExceededTitle: 'File Size Exceeded',
				fileSizeExceededBody:
					'The selected file exceeds the maximum size of 25MB. Please choose a smaller file.',
				unsupportedFileTypeTitle: 'Unsupported File Type',
				unsupportedFileTypeBody:
					'This file type is not supported. Accepted types: {types}',
			},
		},
		editFile: {
			labels: {
				fileName: 'File name',
			},
			messages: {
				updated: 'Document updated successfully.',
			},
			errors: {
				updateDocument: 'Failed to update document',
				updateFileDetails: 'Failed to update file details.',
			},
		},
		filesTable: {
			description: 'Documents and attachments uploaded to this case.',
			actions: {
				addFiles: 'Add File(s)',
				downloadAll: 'Download All',
				downloadSelected: 'Download Selected',
				selectAllVisibleFiles: 'Select all visible files',
				link: 'Link',
				unlink: 'Unlink',
			},
			table: {
				empty: 'No files attached to the case',
			},
			tooltips: {
				editFileInformation: 'Edit File Information',
				openFileInNewTab: 'Open file in new tab',
				sortFiles: 'Sort files',
				visibility: 'Show or hide file badges',
			},
			sort: {
				byFileName: 'Order by filename',
				byUploadDate: 'Order by upload date',
				byUploadedBy: 'Order by uploaded by user',
			},
			linkDialog: {
				title: 'Link/Unlink Entity',
				entityLabel: 'Entity',
			},
			preview: {
				unavailable: 'Preview not available for this format',
			},
			download: {
				dialogTitle: 'File download',
			},
			groups: {
				amlShort: 'AML',
				manualUploads: 'Manually Uploaded Files',
				nameScreeningAml: 'Name Screening (AML)',
			},
			labels: {
				entityType: 'Entity Type',
				entityName: 'Entity Name',
				sessionId: 'Session ID',
				uploadedBy: 'Uploaded by',
				created: 'Created',
				unknown: 'Unknown',
			},
			entityTypes: {
				company: 'Company',
				person: 'Person',
			},
			messages: {
				fileLinked: 'File linked to entity successfully',
				documentsUnlinked: 'Document(s) unlinked successfully',
				documentsDeleted: 'Document(s) deleted successfully',
			},
			errors: {
				loadDocuments: 'Failed to load documents',
				loadDocumentsDot: 'Failed to load documents.',
				linkDocumentToEntity: 'Failed to link document to entity',
				linkDocumentToEntityDot: 'Failed to link document to entity.',
				unlinkDocumentFromEntity: 'Failed to unlink document from entity',
				unlinkDocumentFromEntityDot: 'Failed to unlink document from entity.',
				downloadFile: 'Failed to download file.',
				deleteDocuments: 'Failed to delete document(s)',
				deleteDocumentsDot: 'Failed to delete document(s).',
			},
			unlink: {
				confirmTitle: 'Unlink!',
				confirmBody: 'Are you sure you want to unlink the document(s)?',
			},
			delete: {
				confirmTitle: 'Delete!',
				confirmSelected:
					'You have selected {count} of files. Are you sure you want to delete?',
				confirmSelectedWithNested:
					'You have selected {count} of files including the nested ones. Are you sure you want to delete?',
			},
		},
		history: {
			advancedSearch: {
				title: 'Advanced Search',
			},
			filters: {
				entityName: 'Entity Name',
				entityId: 'Entity ID',
				entityFilter: 'Entity Filter',
				entityProperty: 'Entity Property',
				entityCountry: 'Entity Country',
				modifiedOn: 'Modified On',
				entityPropertyOptions: {
					nationality: 'Nationality',
					residence: 'Residence',
					registrationCompany: 'Registration Company',
				},
			},
			placeholders: {
				searchCases: 'Search',
				selectStatus: 'Select Status',
				selectType: 'Select Type',
				entityName: 'Entity Name',
				selectPropertyCountry: 'Select Property / Country',
				searchCountry: 'Search',
				selectUser: 'Select User',
			},
			actions: {
				newCase: 'New Case',
				clearFilters: 'Clear Filters',
				downloadAsCsv: 'Download as CSV',
				sidebarLayout: 'Sidebar view',
				topLayout: 'Top to bottom view',
			},
			dialogs: {
				deleteCases: {
					title: 'Delete Cases',
					body: 'Are you sure you want to delete {count} case(s)?',
				},
			},
			table: {
				entities: 'Entities',
				files: 'Files',
			},
			dateShortcuts: {
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				last3Months: 'Last 3 months',
			},
			empty: 'No cases found',
			messages: {
				noCasesToDownload: 'No cases available to download.',
				csvGenerated: 'CSV generated successfully',
				noCasesToDelete: 'No cases selected to delete.',
				casesDeleted: 'Case(s) deleted successfully',
			},
			tooltips: {
				statusUnavailable:
					'This case status is no longer available in the status set configured for this case type.',
			},
			errors: {
				downloadCsv: 'Failed to download CSV',
				loadStatusesAndTypes: 'Failed to load statuses and types',
				loadCaseStatuses: 'Failed to load case statuses',
				loadCaseTypes: 'Failed to load case types',
				loadCountries: 'Failed to load countries',
				loadUsers: 'Failed to load users.',
				loadCases: 'Failed to load cases.',
				deleteCases: 'Failed to delete case(s).',
			},
			validation: {
				searchMinLength: 'Needs to be at least 3 characters long to match.',
				invalidCaseId: 'Case ID must be a valid BSON ObjectId.',
				invalidEntityId: 'Entity ID must be a valid BSON ObjectId.',
			},
		},
		details: {
			errors: {
				loadCaseDetails: 'Failed to get case details',
				loadCaseEntities: 'Failed to load case entities',
				loadDocumentTypes: 'Failed to load document types',
			},
			history: {
				description:
					"Compare different versions of this case or entity's details over time.",
				compareWithCurrent: 'Compare with current record',
				actions: {
					compare: 'Compare',
					compareToCurrent: 'Compare to current version',
				},
				table: {
					revision: 'Revision',
					empty: 'No history',
				},
				defaults: {
					medium: 'Medium',
				},
				messages: {
					maxCompareSelection: 'You can only compare 2 items.',
				},
				errors: {
					load: 'Failed to load case history.',
				},
			},
			compare: {
				dialogTitle: 'History',
			},
		},
		amlTab: {
			actions: {
				newSearch: 'New Search',
			},
			dialogs: {
				searchTitle: 'AML Search',
			},
			messages: {
				searchCreated: 'Search created successfully',
			},
		},
		sessions: {
			actions: {
				new: 'New',
			},
			messages: {
				messageSent: 'Message sent successfully',
			},
		},
		newSession: {
			title: 'New Session',
			steps: {
				choose: 'Choose',
				selectFlow: 'Select Flow',
				buildFlow: 'Build Flow',
				review: 'Review',
				send: 'Send',
			},
			actions: {
				next: 'Next',
				saveAndContinue: 'Save & Continue',
			},
			errors: {
				createFlow: 'Failed to create flow',
				sendFailed: 'Failed to send session',
			},
			confirm: {
				title: 'Discard changes?',
				message: 'You have unsaved changes. Are you sure you want to close?',
				discard: 'Discard',
			},
			validation: {
				flowNameRequired: 'Flow name is required',
				atLeastOneCheck: 'Please add at least one check',
				selectCheckFirst: 'Please select a check before adding a new one',
				countriesRequired: 'Please select at least one country',
				invalidUrl: 'Please enter a valid URL',
				allStepsMustHaveCheck: 'All steps must have a check selected',
				termsVersionRequired: 'Terms version is required',
				duplicateCheckType:
					'Each check type can only be used once (except Smart Forms and Upload Document)',
			},
			choose: {
				title: 'Start your session',
				subtitle: 'Choose how to set up this verification',
				existing: {
					title: 'Use existing flow',
					description: "Select from flows you've already set up",
				},
				new: {
					title: 'Create new flow',
					description: 'Build a new verification flow from scratch',
				},
			},
			selectFlow: {
				title: 'Select a flow',
				subtitle: 'Choose the verification flow for this session',
				entityKindHint: 'Showing {entityType} flows only',
				searchPlaceholder: 'Search',
				stepCount: '{count} step | {count} steps',
				noResults: 'No flows found',
				created: 'Created',
				info: 'Flows are made up of pre-configured checks. To add new checks or modify existing ones, go to Flows > Overview > Steps',
			},
			buildFlow: {
				title: 'Build your flow',
				subtitle: 'Name it and add the checks that will run',
				flowName: 'Flow name',
				flowNamePlaceholder: 'e.g. Standard KYC',
				description: 'Description',
				descriptionPlaceholder: 'Optional',
				steps: 'Steps',
				dragToReorder: 'Drag to reorder',
				selectCheck: 'Select a check...',
				addCheck: 'Add a check',
				checksInfo:
					'Checks must be created in Settings before they can be added here. Only pre-configured checks appear in the dropdown above.',
				checksLink: 'Go to Settings → CFM → Checks',
				advancedSettings: 'Advanced settings',
				caseType: 'Case Type',
				caseTypeNone: 'None',
				caseTypeHelp:
					"CaseType is only needed if you're going to initiate a session via the Integration API. Once set, it cannot be changed.",
				geoAccess: 'Geographical Access Control',
				allowedCountries: 'Allowed countries',
				blockedCountries: 'Blocked countries',
				selectCountriesToAllow: 'Select countries to allow',
				selectCountriesToBlock: 'Select countries to block',
				geoAllowAll: 'Allow from all countries',
				geoAllowSpecific: 'Allow from specific countries only',
				geoBlockSpecific: 'Block specific countries',
				returnURL: 'Return URL',
				termsRequired: 'Terms Accepted Required',
				termsVersion: 'Terms version',
				termsVersionPlaceholder: 'e.g. v1.0',
			},
			review: {
				title: 'Review your flow',
				subtitle: 'Confirm the steps before sending',
				info: 'Advanced check settings are managed in Flows > Overview > Steps',
				settings: {
					supportedDocuments: 'Supported Documents',
					supportedCountries: 'Supported Countries',
					allowMobile: 'Mobile Continuation',
					allowUpload: 'Allow Upload',
					onOutcome: 'Automated Verification',
					maxAttempts: 'Maximum Attempts',
					overrideEntityDetails: 'Override Entity Details',
					livenessCheck: 'Liveness Check',
					allowMultiple: 'Allow Multiple',
					blockFraud: 'Block Fraud',
					fuzziness: 'Fuzziness Level',
					monitoring: 'Monitoring',
					onExactMatch: 'On Exact Match',
					onPotentialMatch: 'On Potential Match',
					pageTitle: 'Page Title',
					documents: 'Documents',
					openUpload: 'Open Upload',
					showLiveScore: 'Show Live Score',
				},
			},
			send: {
				title: 'Send via',
				subtitle: 'Choose how to deliver this session to the entity',
				flow: 'Flow:',
				change: 'Change',
				sendingTo: 'Sending to {value}',
				linkWarning:
					'Do not open this link yourself. It locks to the first device that opens it — if you open it before the customer does, they are blocked and have to wait for a replacement link.',
				channels: {
					email: 'Email',
					emailDescription: 'Send a secure link by email',
					emailNoAddress: 'No email on entity',
					link: 'Link',
					linkDescription: 'Generate a shareable link',
					sms: 'SMS',
					smsDescription: 'Send via text message',
					smsNoNumber: 'No phone number on entity',
				},
			},
		},
		timeline: {
			description: 'Important notes and key events logged for this case.',
			labels: {
				relatedTo: 'Related to',
				documentRelatedTo: 'Document related to:',
				latestNote: 'Latest note',
				documentType: 'Document type',
				unknown: 'Unknown',
				case: 'Case',
			},
			relatedTypes: {
				case: 'Case',
				company: 'Company',
				person: 'Person',
				document: 'Document',
			},
			errors: {
				loadCaseStatus: 'Failed to load case status',
				loadCaseStatusDot: 'Failed to load case status.',
				loadCaseDocuments: 'Failed to load case documents.',
				loadEntities: 'Failed to load entities.',
				loadEntitiesConsole: 'Failed to load entities:',
			},
		},
		entityDetails: {
			common: {
				labels: {
					addressLine1: 'Address Line 1',
					addressLine2: 'Address Line 2',
					postCode: 'Post Code',
					unknown: 'Unknown',
				},
				placeholders: {
					phoneNumber: 'Enter the phone number',
				},
				validation: {
					phoneInternationalFormat:
						'Use the following international format: +[Country Code][Phone Number] example: +18776967786',
				},
			},
			person: {
				cardTitle: 'Person',
				defaults: {
					titleMr: 'Mr',
					titleMrs: 'Mrs',
					genderMale: 'Male',
					genderFemale: 'Female',
				},
				labels: {
					documentNumber: 'Document Number',
					firstName: 'First Name',
					lastName: 'Last Name',
					gender: 'Gender',
					mobile: 'Mobile',
					dateOfBirth: 'Date of Birth',
					nationality: 'Nationality',
				},
				placeholders: {
					firstNameRequired: 'Name is required field',
					lastNameRequired: 'Last name is required field',
					email: 'Enter the email address',
					dateOfBirth: 'Date of birth',
				},
				validation: {
					validEmail: 'Please provide a valid e-mail',
					validMobilePhone: 'Please provide a valid mobile phone number',
				},
				messages: {
					created: 'Entity created successfully',
					updated: 'Person entity updated successfully',
				},
				errors: {
					create: 'Failed to create entity',
					update: 'Failed to update entity',
					updateFallback: 'Failed to updated entity.',
				},
			},
			company: {
				cardTitle: 'Company',
				labels: {
					tradeName: 'Trade Name',
					registrationNumber: 'Registration Number',
					registrationDate: 'Registration Date',
					registrationCountry: 'Registration Country',
					businessType: 'Business Type',
					companyType: 'Company Type',
					vatNumber: 'Vat Number',
					representativeName: "Representative's Name",
					representativeEmail: "Representative's Email",
					representativePhone: "Representative's Phone",
					companyEmail: "Company's Email",
					companyPhone: "Company's Phone",
					companyStatus: "Company's Status",
				},
				placeholders: {
					nameRequired: 'Name is required field',
					tradeName: 'Trade Name',
					registrationNumber: 'Registration Number',
					registrationDate: 'Date of registration',
				},
				validation: {
					representativeEmail:
						'Please provide a valid e-mail for Representative',
					companyEmail: 'Please provide a valid e-mail for Company',
				},
				messages: {
					created: 'Entity created successfuly',
					updated: 'Company entity updated successfully',
				},
				errors: {
					create: 'Failed to create entity',
					createDot: 'Failed to create entity.',
					update: 'Failed to update entity',
					updateDot: 'Failed to updated entity.',
					loadConfig: 'Failed to load config',
				},
			},
		},
		entityTabs: {
			tabs: {
				details: 'Details',
				files: 'Entity Files',
				checks: 'Verifications',
				results: 'Results',
				history: 'History',
			},
			personHistory: {
				table: {
					surname: 'Surname',
					gender: 'Gender',
					phone: 'Phone',
				},
			},
			companyHistory: {
				table: {
					registrationCountryShort: 'Reg. Country',
					phone: 'Phone',
				},
			},
			history: {
				emptyPerson: 'There is no history yet for this person.',
				emptyCompany: 'There is no history yet for this company.',
				errors: {
					loadPersonHistory: 'Failed to load person history.',
					loadCompanyHistory: 'Failed to load company history.',
				},
			},
			compare: {
				referenceLabel: 'Entity unique reference: ',
			},
		},
		checks: {
			poa: {
				noSubmissionId: 'No submission ID',
				actions: {
					viewSubmission: 'View full submission',
				},
				details: {
					entity: 'Case value',
					extracted: 'Extracted',
					confidence: 'Match confidence',
				},
			},
			results: {
				filterLabel: 'Select verification type:',
				pills: {
					aml: 'AML',
					form: 'Smart Forms',
					id: 'ID Verification',
					poa: 'Proof of address',
					selfie: 'Selfie',
					sms: 'SMS',
				},
				sectionTitles: {
					aml: 'AML Verifications',
					form: 'Smart Form Verifications',
					id: 'ID Verifications',
					poa: 'Proof of address verifications',
					selfie: 'Selfie Verifications',
					sms: 'SMS Verifications',
				},
				source: {
					cfm: 'From CFM',
					linkedAml: 'Linked AML Verification',
					linkedForm: 'Linked Smart Form Verification',
					linkedPoa: 'Linked proof of address submission',
				},
				actions: {
					linkFormSubmission: 'Link to existing submission',
					linkAmlSearch: 'Link to existing search',
					linkPoaSubmission: 'Link to existing submission',
					viewPoaResult: 'View Proof of Address result',
					unlink: 'Unlink',
					submitLink: 'Link submission',
					submitAmlLink: 'Link search',
				},
				dialogs: {
					linkFormTitle: 'Link smart form submission to entity',
					linkAmlTitle: 'Link AML search to entity',
					linkPoaTitle: 'Link proof of address submission to entity',
					submissionId: 'Submission ID',
					submissionSearchLabel: 'Search submissions',
					submissionSearchPlaceholder: 'Search by name or submission ID',
					submissionNoResults: 'No matching submissions found.',
					submissionRecentEmpty:
						'No recently submitted proof of address results found.',
					complySearchId: 'Search ID',
				},
				messages: {
					linkFormSuccess: 'Smart form submission linked.',
					unlinkFormSuccess: 'Smart form submission unlinked.',
					linkAmlSuccess: 'AML search linked.',
					unlinkAmlSuccess: 'AML search unlinked.',
					linkPoaSuccess: 'Proof of address submission linked.',
					unlinkPoaSuccess: 'Proof of address submission unlinked.',
					unlinkPartial:
						'Unlinked, but some of the clean-up did not finish. Check the entity files.',
				},
				amlHitStatus: {
					noHits: 'No hits',
					exactMatch: 'Exact match',
					potentialMatch: 'Potential match',
				},
				empty: 'No results for the selected check type.',
				errors: {
					loadResults: 'Failed to load results.',
					linkForm: 'Failed to link smart form submission.',
					unlinkForm: 'Failed to unlink smart form submission.',
					linkAml: 'Failed to link AML search.',
					unlinkAml: 'Failed to unlink AML search.',
					linkPoa: 'Failed to link proof of address submission.',
					unlinkPoa: 'Failed to unlink proof of address submission.',
				},
			},
			mainSession: {
				notAvailable: 'Not available',
				metadata: {
					title: 'Metadata',
				},
				sections: {
					session: 'Session',
					duration: 'Duration',
					device: 'Device',
				},
				labels: {
					sessionId: 'Session id',
					sessionLink: 'Session Link',
					sessionLinkExpiry: 'Expires {date}',
					journeyId: 'Journey id',
					riskLevelId: 'Risk level id',
					riskLevelName: 'Risk level name',
					terminatedBy: 'Terminated By',
					terminatedAt: 'Terminated At',
					terminationState: 'Termination State',
					terminationReason: 'Termination Reason',
					sessionInitiatedAt: 'Session initiated at',
					sessionCompletedAt: 'Session completed at',
					sessionExpiresAt: 'Session expires at',
					duration: 'Duration',
					ip: 'Ip',
					browser: 'Browser',
					os: 'OS',
					device: 'Device',
				},
				status: {
					completed: 'Completed',
					inprogress: 'In Progress',
					expired: 'Expired',
					pending: 'Pending',
					terminated: 'Terminated',
				},
				// Keyed by the backend's session terminationState value.
				terminationStates: {
					UserGeoBlocked: 'Geo Blocked',
					UserDeniedTerms: 'Terms Declined',
					FastFailInconclusive: 'Fast Fail Inconclusive',
					TerminatedByOperator: 'Terminated by Operator',
				},
				geoBlock: {
					detail:
						'Access blocked from {ip} (country code {country}) by risk level {riskLevel}.',
					detailWithoutRiskLevel:
						'Access blocked from {ip} (country code {country}) by the risk level.',
				},
				errors: {
					countryDataFormat: 'Country data is not in expected format:',
					loadCountryCodesConsole: 'Failed to load country codes:',
					fetchDocumentsConsole: 'Failed to fetch documents:',
				},
			},
			document: {
				decisionPills: {
					tags: {
						skipped: 'Skipped',
						ignored: 'Ignored',
					},
					labels: {
						reason: 'Reason',
						entity: 'Entity',
						extracted: 'Extracted',
						entityDob: 'Entity DOB',
						extractedDob: 'Extracted DOB',
						form: 'Smart Form',
						riskLevel: 'Risk Level',
						score: 'Score',
						expirationDate: 'Expiration Date',
						rejectReason: 'Reject Reason',
						captureLiveness: 'Capture Liveness',
						faceLiveness: 'Face Liveness',
					},
					ruleNames: {
						authenticitySecurity: 'Authenticity / Security',
						imageQuality: 'Image Quality',
					},
					step: 'Step {step}',
					messages: {
						checkFailed:
							'Check failed. See automation results for more details.',
					},
				},
				verification: {
					labels: {
						currentStatus: 'Current status:',
						noStatus: 'No status',
						image: 'Image',
					},
					tabs: {
						manualReview: 'Manual',
						automatedResults: 'Automated',
					},
					actions: {
						changeStatus: 'Change Status',
						updateStatus: 'Update Status',
						seeDocument: 'See the document',
					},
					empty: {
						noDocumentsFound: 'No documents found',
					},
					statusDialog: {
						title: 'Change Status',
						placeholders: {
							notes: 'Add notes regarding the status update',
						},
					},
					historyDialog: {
						title: 'History',
						empty: 'No history yet',
						actions: {
							addComment: 'Add Comment',
						},
						placeholders: {
							comment: 'Leave a comment on this verification',
						},
					},
					comparisonDialog: {
						title: 'Update person details',
						heading:
							'Are you sure you want to override the original Person Entity Details with the values from this tab?',
						changesLead:
							'This will update the data on Person Entity Details tab as follows:',
						footer:
							'Click "Confirm" to proceed or "Cancel" to leave without any changes.',
					},
					comparisonFields: {
						firstName: 'First Name',
						lastName: 'Last name',
						dateOfBirth: 'Date of birth',
						country: 'Country',
					},
					messages: {
						statusUpdated: 'Status updated',
						personEntityUpdated: 'Person entity updated successfully',
						imageSaved: 'Image is saved sucessfully',
					},
					errors: {
						loadAutomationImages: 'Problem with loading automation images',
						loadFilePreview: 'Problem with loading the file preview',
						saveRotation: 'Failed to save the rotated image',
						updateEntity: 'Failed to update entity',
						updateEntityFallback: 'Failed to update entity.',
						updateStatus: 'Failed to update status',
					},
				},
				manualReview: {
					actions: {
						viewDocument: 'View Document',
					},
					fields: {
						documentName: 'Document Name',
						firstName: 'First Name',
						lastName: 'Last Name',
						gender: 'Gender',
						dateOfBirth: 'Date Of Birth',
						dateOfIssue: 'Date Of Issue',
						documentNumber: 'Document Number',
						expirationDate: 'Expiration Date',
						issuingAuthority: 'Issuing Authority',
						mothersName: "Mother's Name",
						issuingCountry: 'Issuing Country',
						placeOfIssue: 'Place Of Issue',
						address: 'Address',
						personalNumber: 'Personal Number',
						placeOfBirthCode: 'Place of birth code',
						addressCountry: 'Address Country',
						fathersName: "Father's name",
						nationalityCode: 'Nationality Code',
						nationality: 'Nationality',
					},
					placeholders: {
						missingData: 'Missing data',
						selectField: 'Select {field}',
					},
					tooltips: {
						fieldExcluded: 'Field excluded',
						entityDetails: 'Entity details: {value}',
					},
					defaults: {
						notSpecified: 'Not Specified',
					},
					options: {
						gender: {
							male: 'Male',
							female: 'Female',
							nonBinary: 'Non-Binary',
							preferNotToSay: 'Prefer not to say',
						},
					},
					messages: {
						documentUpdated: 'Document updated',
					},
				},
			},
			sessionList: {
				empty: 'There are no verifications yet.',
				labels: {
					terminatedBy: 'Terminated by {actor} on {date}.',
					linkOwnership: 'Do not open this link yourself.',
				},
				tabs: {
					latest: 'Latest',
				},
				actions: {
					terminate: 'Terminate',
				},
				dialogs: {
					terminate: {
						pending: {
							title: 'Terminate this session?',
							body:
								'This link has not been opened yet, so no verification is in progress and nothing is lost.\n\n' +
								'The link stops working immediately. If the customer opens it later they are told the session was terminated and asked to contact you. To verify them you will need to send a new link.',
							confirm: 'Terminate',
						},
						inProgress: {
							title: 'Terminate a verification in progress?',
							body:
								'The customer has already started this verification. Terminating cuts them off immediately and without warning: their next action fails and they are told the session was terminated and asked to contact you.\n\n' +
								'Steps they have already completed stay on the case, but the verification will never finish. This cannot be undone — they will have to start over from a new link.',
							confirm: 'Terminate anyway',
						},
					},
				},
				pending: {
					noSteps: 'No steps configured for this pending session.',
				},
				tooltips: {
					linkOwnershipDetail:
						'A verification link locks to the first device that opens it. If you open it before the customer does, they are blocked and have to wait for a replacement link.',
				},
				messages: {
					terminated: 'Session terminated successfully.',
				},
				errors: {
					loadFailed: 'Failed to load sessions.',
					terminate: 'Failed to terminate the session. Please try again later.',
				},
			},
			smsVerification: {
				labels: {
					status: 'Status',
					entityPhoneNumber: 'Entity phone number',
					submittedPhoneNumber: 'Submitted phone number',
					overrodeEntityNumber: 'Overrode entity number',
					allowOverridingEntityNumber: 'Allow overriding entity number',
					attempts: 'Attempts',
					submittedCodes: 'Submitted codes',
					completedAt: 'Completed at',
				},
			},
			formCheck: {
				actions: {
					viewFormResult: 'View Smart Form Result',
				},
				labels: {
					formName: 'Smart Form Name',
					finalScore: 'Final Score',
					noSubmission: 'No linked Smart Form submission',
				},
				certificate: {
					unavailable: 'Unable to load certificate',
				},
				defaults: {
					unknownForm: 'Unknown Smart Form',
					unknown: 'Unknown',
				},
				errors: {
					loadCertificate: 'Failed to load certificate.',
				},
			},
			amlScreening: {
				labels: {
					searchTerm: 'Search term',
					fuzziness: 'Fuzziness',
					exactMatch: 'Exact match',
					totalHits: 'Total hits',
					exactMatches: 'Exact matches',
					potentialMatches: 'Potential matches',
					whitelisted: 'Whitelisted',
					yearOfBirth: 'Year of birth',
					complySearchId: 'AML search ID',
					amlStatus: 'AML status',
					categories: 'Categories',
				},
				statuses: {
					notSet: 'Not set',
					allClear: 'All clear',
					possibleHit: 'Possible hit',
					positiveHit: 'Positive hit',
				},
				categories: {
					sanctions: 'Sanctions & Warnings',
					peps: 'PEPs',
					adverseMedia: 'Adverse Media (legacy)',
					adverseMediaV2: 'Adverse Media',
					notSearched: 'Not searched',
				},
				notices: {
					certificateSnapshot:
						'The certificate is a point-in-time record produced when the customer completed the verification flow; the underlying search may have changed since. To obtain the current certificate, open the AML search and download it there.',
				},
				liveResult: {
					loading: 'Loading the live AML result…',
					notCompleted:
						'The live AML result is available once the search has completed.',
					unavailable:
						'The live AML result could not be loaded. Showing the result recorded when the search ran.',
				},
				actions: {
					retrySearch: 'Retry search',
					retryCertificate: 'Retry certificate',
					seeCertificate: 'See the certificate',
					viewAmlSearch: 'View AML Search',
				},
				messages: {
					retrySearchSuccess: 'AML search retried successfully.',
					retryCertificateSuccess: 'Certificate retried successfully.',
				},
				errors: {
					downloadFile: 'Failed to download file.',
					retrySearch: 'Failed to retry AML search.',
					retryCertificate: 'Failed to retry certificate.',
				},
			},
			automatedDecision: {
				pages: {
					front: 'Front',
					back: 'Back',
					numbered: 'Page {number}',
				},
			},
			automatedResults: {
				table: {
					fieldName: 'Field Name',
					value: 'Value',
				},
				selfie: {
					similarity: 'Similarity',
					liveness: 'Liveness',
					takenOn: 'Taken on',
					lowSimilarity: 'Low',
					lowSimilarityTooltip:
						'The selfie and the document photo did not match closely enough to produce an exact score, so the match is shown as Low.',
				},
				tooltips: {
					copyJson: 'Copy this json',
				},
				messages: {
					copySuccess: 'Copied successfully',
				},
			},
			entitiesStatus: {
				messages: {
					updated: 'Entity status is updates successfully',
				},
			},
		},
	},
	merchants: {
		common: {
			breadcrumb: {
				dashboard: 'Dashboard',
			},
			actions: {
				back: 'Back',
				new: 'New',
			},
			durationOptions: {
				unlimited: 'Unlimited',
				oneMonth: '1 month',
				threeMonths: '3 months',
				sixMonths: '6 months',
				oneYear: '1 year',
				twoYears: '2 years',
			},
			empty: {
				noPreviousSearches: 'No previous searches found',
			},
			errors: {
				loadStats: 'Failed to load stats',
				loadMerchants: 'Failed to load merchants.',
			},
		},
		agents: {
			breadcrumb: {
				userManagement: 'SU Config',
				agents: 'Agents',
			},
			title: 'Assign agents',
			filters: {
				selectAgent: 'Select Agent',
				filterMerchant: 'Filter Merchant',
				placeholders: {
					selectAgent: 'Select agent',
					filterMerchant: 'Filter Merchant',
				},
			},
			table: {
				columns: {
					merchants: 'Merchants',
					assignStatus: 'Assign status',
					notifications: 'Notifications',
				},
			},
			messages: {
				assignBeforeNotifications:
					'You need to assign the merchant first before enabling notification',
			},
			errors: {
				updateNotifications:
					'Failed to handle notifications for agents from merchant.',
				unlink: 'Failed to unlink agents from merchant.',
				link: 'Failed to link agent to merchant.',
				loadAgents: 'Failed to load agents details.',
				findLinkedMerchants: 'Failed to find linked merchants.',
				loadMerchants: 'Failed to load merchants',
			},
		},
		profile: {
			breadcrumb: {
				profile: 'Profile',
			},
		},
		new: {
			breadcrumb: {
				newMerchant: 'New',
			},
		},
		package: {
			currentPackage: 'Pricing Package',
			subtitle:
				'Select a commercial package to apply structured pricing and availability rules.',
			changePackage: 'Change Package',
			noPackage: 'Pay-per-use (Catalog Pricing)',
			noPackageDescription:
				'No package restrictions — all metrics available at catalog prices.',
			active: 'Active',
			monthlyMinimum: 'Monthly minimum',
			unavailableMetric: 'Not in package',
			overridesPackage: 'Overrides package',
			assignWarning:
				'This change takes effect immediately. In-flight reservations will finalize at the previous package price.',
			assignReasonPlaceholder:
				'Reason for change (optional) - This note may appear on the customer invoice.',
			assignConfirm: 'Confirm Change',
			assignSuccess: 'Pricing package changed successfully.',
			assignSuccessCatalog:
				'Pricing package changed to Pay-per-use (Catalog Pricing).',
			assignError: 'Failed to assign package. Please try again.',
			catalogPrice: 'Pay-per-use',
			unavailablePrice: 'N/A',
			moreMetrics: 'more',
			detailsTitle: 'Package details',
		},
		newForm: {
			title: 'New Subscription with Merchant',
			labels: {
				merchantName: 'Merchant Name',
				userFirstName: 'User First Name',
				userLastName: 'User Last Name',
				userEmail: 'User Email',
				duration: 'Duration',
				phoneNumber: 'Phone Number',
				designation: 'Description',
			},
			placeholders: {
				phoneNumber: 'Enter the phone number',
			},
			billing: {
				title: 'Billing Configuration',
				description:
					'Choose the merchant billing model, currency and billable unit pricing at creation time.',
				billableUnitsDescription:
					'Leave a field empty to inherit the package/catalog price. Enter a value to create a merchant-specific add-on override for this metric.',
				requiresCaseManagement: 'Requires Case Management',
				billingTypes: {
					prepaid: 'Prepaid',
					postpaid: 'Postpaid',
					trial: 'Trial',
					manual: 'Manual',
				},
				paymentMethods: {
					card: 'Card',
					bankTransfer: 'Bank Transfer',
				},
				currencies: {
					eur: 'Euro (EUR)',
				},
				services: {
					managedServices: 'Managed Services',
					managedServicesTooltip:
						"This customer will be using Arritech's consulting services",
				},
				billableUnits: {
					defaultPrice: 'Default price',
					defaultPriceTooltip: 'Default price: {price}',
					defaultPriceTooltipEmpty: 'No default price is currently set.',
					packagePriceTooltip:
						'Package price: {price}. Enter a value to override.',
					disable: 'Disable',
					inheritedFromPackage: 'Inherited from package',
					usingPpu: 'Using PPU',
					groups: {
						caseManagement: 'Case Management',
						aml: 'AML',
						forms: 'Forms',
						proofOfAddress: 'Proof of Address',
						idVerification: 'ID Verification',
						faceAuthentication: 'Face Authentication',
						smsVerification: 'SMS Verification',
					},
					metrics: {
						newCase: 'New Case',
						newSession: 'New Session',
						newSessionBySms: 'New Session by SMS',
						newAmlSearch: 'New AML Search',
						renewedAmlSearch: 'Renewed AML Search',
						formSubmission: 'Form Submission',
						addressVerification: 'Address Verification',
						issuerLegitimacy: 'Issuer Legitimacy',
						documentFraudAnalysis: 'Document Fraud Analysis',
						verifiedId: 'Verified ID',
						livenessCheck: 'Liveness Check',
						smsVerified: 'SMS Verified',
					},
				},
			},
			permissions: {
				title: 'Permissions',
			},
			dialogs: {
				errorTitle: 'Error!',
			},
			messages: {
				subscriptionCreated: 'Subscription created successfully',
			},
			errors: {
				permissionRequired:
					'At least 1 permission must be selected to create a merchant',
				invalidPhoneNumber: 'Invalid phone number',
				createSubscription: 'Failed to create subscription.',
			},
		},
		list: {
			title: 'Merchants',
			columns: {
				slug: 'Slug',
				expired: 'Expired',
			},
			filters: {
				expired: {
					title: 'Expired',
				},
			},
		},
		details: {
			sections: {
				actions: 'Actions',
				branding: 'Branding',
				creditManagement: 'Payment History',
				billingConfiguration: 'Billing Configuration',
				monitor: 'Monitor',
			},
			branding: {
				subtitle: 'Manage how your logo appears across the platform.',
				lightMode: 'Light mode',
				darkMode: 'Dark mode',
				defaultBadge: 'Default',
				customBadge: 'Custom',
				uploadTitle: 'Upload new logo',
				uploadHint: 'SVG only · recommended 600×200 px',
				dropTitle: 'Drag and drop your SVG here',
				dropOr: 'or',
				dropChoose: 'choose a file',
				removeFile: 'Remove selected file',
			},
			labels: {
				merchantId: 'Merchant ID',
				expiryDate: 'Expiry Date',
				billingType: 'Billing Type',
				paymentMethod: 'Payment Method',
				currency: 'Currency',
				creditsValidUntil: 'Credits Valid Until',
				noActiveCreditExpiry: 'No active credit expiry',
				billableUnits: 'Billing Overrides',
				userCount: 'No. of Users',
				roleCount: 'No. of Roles',
				nameScreenSearches: 'Name Screen search(es)',
				agent: 'Agent',
				credits: 'Credits',
				primaryOwner: 'Primary Owner',
				noPrimaryOwner: 'None',
			},
			tooltips: {
				credits:
					'Shows only active, spendable credits. Expired credits and fully consumed credit grants are not included here.',
				creditsValidUntil:
					"Shows the latest expiry among active, non-expired credits. This is the last valid date of the merchant's current active credit pool.",
			},
			billing: {
				statuses: {
					active: 'Active',
					suspended: 'Suspended',
					ongoingTrial: 'Ongoing Trial',
					trialExpired: 'Trial Expired',
				},
			},
			placeholders: {
				expiryDuration: 'Expiry duration',
			},
			actions: {
				impersonate: 'Impersonate',
				expireNow: 'Expire Now',
				setExpiration: 'Set Expiration',
				adjust: 'Adjust',
				proFormas: 'Pro Formas',
				enableMfaMandatory: 'Enable Organisation MFA',
				disableMfaMandatory: 'Disable Organisation MFA',
				enable: 'Enable',
				disable: 'Disable',
				uploadNewSvg: 'Upload new SVG',
				resetToDefault: 'Reset to default',
			},
			proForma: {
				labels: {
					amount: 'Amount',
				},
				actions: {
					generate: 'Generate',
					generateAndSend: 'Generate and Send',
				},
				messages: {
					created: 'Pro forma {number} generated.',
					createdAndSent: 'Pro forma {number} generated and sent.',
					sent: 'Pro forma sent.',
				},
				errors: {
					amountRequired: 'Amount must be greater than 0.',
					createFailed: 'Unable to generate pro forma. Please try again.',
					sendFailed: 'Unable to send pro forma. Please try again.',
				},
			},
			validation: {
				merchantNameTooLong:
					'Merchant name too long by {excess} characters (max {max})',
			},
			dialogs: {
				deleteMerchant: {
					title: 'Delete Merchant!',
					body: 'Are you sure you want to delete the Merchant? If you press Yes, all data related to this Merchant will be deleted and cannot be recovered.',
				},
				enableMfaMandatory: {
					title: 'Enable Mandatory MFA',
					body: 'Are you sure you want to enable mandatory MFA for this merchant? All users will be required to set up multi-factor authentication on their next login.',
				},
				disableMfaMandatory: {
					title: 'Disable Mandatory MFA',
					body: 'Are you sure you want to disable mandatory MFA for this merchant? Users will no longer be required to set up multi-factor authentication.',
				},
			},
			messages: {
				nameUpdated: 'Merchant name updated successfully.',
				billingConfigMissing:
					"This merchant doesn't have billing settings yet. Save the billing configuration below before creating a top up, changing package or managing credits.",
				billingConfigSaved: 'Billing configuration updated successfully.',
				manualCreditManagement:
					'Credit balances, top-ups and packages do not apply to this billing type.',
				topUpCreated: 'Top up created successfully.',
				debitCreated: 'Debit adjustment applied successfully.',
				agentNotificationsEnabled:
					'The notifications are now enabled for this agent',
				agentNotificationsDisabled:
					'The notifications are now disabled for this agent',
				deleted: 'Merchant deleted successfully',
				blocked: 'Merchant blocked successfully',
				expirySet: 'Merchant expiry duration set successfully',
				mfaEnabled: 'MFA is now mandatory for this merchant',
				mfaDisabled: 'MFA is no longer mandatory for this merchant',
				logoSaved: 'Merchant logo saved successfully.',
				logoRemoved: 'Merchant logo removed successfully.',
			},
			errors: {
				saveName: 'Error while saving the name',
				loadLogo: 'Failed to load merchant logo.',
				invalidLogoFile: 'Please select an SVG logo file.',
				saveLogo: 'Failed to save merchant logo.',
				removeLogo: 'Failed to remove merchant logo.',
				loadBillingConfig: 'Failed to load billing configuration.',
				loadCreditData: 'Failed to load merchant credit data.',
				saveBillingConfig: 'Failed to save billing configuration.',
				topUpMissingBillingConfig:
					'Billing configuration must exist before creating a top up.',
				createTopUp: 'Failed to create top up.',
				impersonate: 'Failed to impersonate merchant.',
				delete: 'Failed to delete merchant.',
				block: 'Failed to block merchant.',
				selectExpiryDuration: 'Please select expiry duration',
				setExpiryDuration: 'Failed to set expiry duration.',
				enableMfaMandatory: 'Failed to enable mandatory MFA.',
				disableMfaMandatory: 'Failed to disable mandatory MFA.',
			},
			topUp: {
				actions: {
					submitCredit: 'Add Credit',
					submitDebit: 'Apply Debit',
				},
				labels: {
					amount: 'Amount',
					type: 'Type',
					details: 'Details',
					creditExpiryDate: 'New Extended Expiry',
				},
				directions: {
					credit: 'Credit',
					debit: 'Debit',
				},
				descriptions: {
					credit: 'This will add balance to the merchant account.',
					debit:
						'This will remove balance from the longest-valid active credit first.',
				},
				types: {
					card: 'Card Payment',
					bankTransfer: 'Bank Transfer',
					refund: 'Refund',
					bonus: 'Bonus',
					trial: 'Trial',
					manualAdjustment: 'Manual Adjustment',
				},
				shortcuts: {
					oneMonthFromNow: 'In 1 month',
					sixMonthsFromNow: 'In 6 months',
					twelveMonthsFromNow: 'In 12 months',
				},
				confirmBankTransfer: {
					title: 'Confirm bank transfer',
					message:
						"You're marking this transaction as paid. This will credit the merchant immediately.",
					actions: {
						confirm: 'Yes, mark as paid',
					},
				},
			},
			creditExpiry: {
				detailsTitle: 'Top Up Details',
				debitDetailsTitle: 'Debit Details',
				actions: {
					close: 'Close',
				},
				sections: {
					creditInfo: 'Credit Info',
					debitInfo: 'Debit Info',
					audit: 'Audit',
				},
				summary: {
					amountCaption: 'Credit Entry',
					debitEntry: 'Debit Entry',
					validUntil: 'Valid Until',
					noExpiry: 'No expiry',
				},
				fields: {
					amount: 'Amount',
					remainingAmount: 'Remaining Amount',
					details: 'Details',
					currentExpiry: 'Current Expiry Date',
					createdOn: 'Created On',
					createdBy: 'Created By',
				},
			},
			topUpActivity: {
				empty: 'No credit activity found.',
				status: {
					expired: 'Expired',
					expiringSoon: 'Expiring Soon',
				},
				actions: {
					markAsPaid: 'Mark as Paid',
					download: 'Download',
					delete: 'Delete',
					send: 'Send',
				},
				errors: {
					downloadFailed: 'Unable to download the invoice. Please try again.',
				},
				columns: {
					amount: 'Amount',
					date: 'Date',
					type: 'Type',
					details: 'Details',
					validUntil: 'Valid Until',
					invoice: 'Invoice',
				},
			},
			proFormas: {
				modal: {
					title: 'Pro Formas',
					empty: 'No unpaid pro formas.',
					columns: {
						date: 'Date',
						number: 'Number',
						amount: 'Amount',
						validUntil: 'Valid Until',
						status: 'Status',
					},
					errors: {
						load: 'Unable to load pro formas. Please try again.',
					},
				},
			},
			invoices: {
				empty: 'No invoices found.',
				filters: {
					all: 'All',
					unpaid: 'Unpaid',
					paid: 'Paid',
				},
				statuses: {
					issued: 'Unpaid',
					paid: 'Paid',
					expired: 'Expired',
				},
				columns: {
					date: 'Date',
					number: 'Number',
					amount: 'Amount',
					dueDate: 'Due Date',
					status: 'Status',
				},
				errors: {
					load: 'Unable to load invoices. Please try again.',
				},
			},
			markPaid: {
				title: 'Mark as Paid',
				confirmDefault:
					'Mark this transaction as paid? A settlement invoice will be issued and credits granted.',
				confirmMessage:
					'Confirm that {reference} for {currency} {amount} has been paid. A settlement invoice will be issued and credits granted.',
				actions: {
					confirm: 'Confirm',
				},
				messages: {
					settled: 'Marked as paid. Settlement invoice {number} issued.',
					paid: 'Invoice marked as paid.',
				},
				errors: {
					failed: 'Unable to mark this invoice as paid. Please try again.',
				},
			},
			deleteProForma: {
				title: 'Delete Pro Forma',
				confirmDefault: 'Delete this pro forma? This cannot be undone.',
				confirmMessage: 'Delete pro forma {reference}? This cannot be undone.',
				actions: {
					confirm: 'Delete',
				},
				messages: {
					deleted: 'Pro forma deleted.',
				},
				errors: {
					failed: 'Unable to delete this pro forma. Please try again.',
				},
			},
			usageHistory: {
				columns: {
					date: 'Date',
					amount: 'Amount',
					type: 'Type',
					details: 'Details',
					reference: 'Reference',
				},
				types: {
					usageDebit: 'Usage Debit',
				},
			},
		},
		reports: {
			title: 'Merchant Reports',
			columns: {
				merchant: 'Merchant',
				aml: 'AML',
				cases: 'Cases',
			},
			errors: {
				loadStats: 'Failed to load merchant stats.',
			},
		},
		notificationPrefs: {
			title: 'Organization Preferences',
			intro:
				'Choose which notifications the members in your organization may turn off for themselves.',
			ownPreferences:
				'Looking for your own notification settings? They live in {profileLink}.',
			profileLink: 'your profile',
			generalCategory: 'General',
			updated: 'Notification preference updated.',
			columns: {
				notification: 'Notification',
				recipients: 'Recipients',
				channel: 'Channel',
				allowOverride: 'Users can change',
			},
			channels: {
				email: 'Email',
				inApp: 'In-app',
				sms: 'SMS',
			},
			recipients: {
				actor: 'The user who triggered it',
				contextUser: 'The user it concerns',
				usersWithRole: 'Users whose role grants {role}',
				usersWithRoleUnknown: 'Users with a specific permission',
				merchantUsers: 'All your users',
				merchantAdmins: 'Your administrators',
				merchantPrimaryOwner: 'Your account owner',
				merchantLinkedAgents: 'Your linked agents',
				platformUsers: 'Platform team',
				explicitRecipients: 'Set per notification',
				externalContact: 'External contact',
				billingContacts: 'Your billing contacts',
				unknown: 'Not specified',
			},
		},
	},
	billing: {
		suConfig: {
			organization: {
				picker: {
					label: 'Organization',
					placeholder: 'Search for an organization',
				},
			},
		},
		overview: {
			title: 'Overview',
			strip: {
				creditsRemaining: 'credits remaining',
				validUntil: 'Valid until {date}',
				manageBilling: 'Manage Billing',
				postpaidPrefix: 'Billed monthly in arrears · Current period',
			},
		},
		paymentHistory: {
			title: 'Payment History',
			description:
				'Credit added to your balance. Card charges include VAT where applicable — see the invoice PDF for the full breakdown.',
			download: 'Invoice',
			downloading: 'Preparing…',
			downloadError: 'Unable to open the invoice. Please try again.',
			empty: 'No payment history yet.',
			validUntil: 'Valid until',
			type: {
				card: 'Card Payment',
				bank_transfer: 'Bank Transfer',
				bonus: 'Bonus',
				trial: 'Trial credit',
				manual_adjustment: 'Manual adjustment',
				refund: 'Refund',
			},
		},
		usageHistory: {
			title: 'Usage History',
			description:
				'Billable actions consumed by this account, filtered by period and metric.',
			empty: 'No usage history found for this period.',
		},
		subscribe: {
			postpaid: {
				title: "You're on postpaid billing",
				body: 'Subscription plans do not apply to your account.',
			},
			vatDisclaimer:
				'Prices are not inclusive of VAT or any additional Sales Tax. Those are calculated at checkout.',
		},
		checkoutStatus: {
			close: 'Dismiss',
			top_up: {
				processing: {
					title: 'Processing top-up…',
					message:
						'Confirming your top-up with the payment provider. Your credits will show up on this page as soon as we hear back.',
				},
				completed: {
					title: 'Top-up successful',
					message: 'Your credits have been added to your account.',
				},
				failed: {
					title: 'Top-up failed',
					message: 'The payment did not go through. You have not been charged.',
				},
				canceled: {
					title: 'Top-up canceled',
					message: 'You closed the checkout. You have not been charged.',
				},
				stillProcessing: {
					title: 'Still processing…',
					message:
						'It is taking longer than usual. Refresh the page in a moment to see the latest status.',
				},
			},
			subscription: {
				processing: {
					title: 'Processing subscription…',
					message:
						'Confirming your subscription with the payment provider. Your plan will show as active on this page as soon as we hear back.',
				},
				completed: {
					title: 'Subscription activated',
					message: 'Your plan is now active.',
				},
				failed: {
					title: 'Subscription failed',
					message: 'The payment did not go through. You have not been charged.',
				},
				canceled: {
					title: 'Subscription canceled',
					message: 'You closed the checkout. You have not been charged.',
				},
				stillProcessing: {
					title: 'Still processing…',
					message:
						'It is taking longer than usual. Refresh the page in a moment to see the latest status.',
				},
			},
		},
		manage: {
			title: 'Manage account',
			hero: {
				description: 'Company details, billing, and payment for your account.',
				descriptionWithMerchant:
					'Company details, billing, and payment for {merchantName}.',
			},
			dangerZone: {
				title: 'Danger zone',
				description: 'Irreversible and high-impact actions.',
				downgrade: {
					title: 'Downgrade subscription',
					description:
						'Move to a lower plan. New rates apply from your next renewal.',
					action: 'Downgrade',
					opening: 'Opening…',
				},
				closeAccount: {
					title: 'Close account',
					description:
						"Permanently close {merchantName}'s account and revoke all access. This cannot be undone.",
					action: 'Close account',
					submitting: 'Submitting…',
					confirmTitle: 'Close account?',
					confirmDescription:
						"This sends a closure request to {merchantName}'s account team. Our team will contact you to finalise the process. Continue?",
					confirmAction: 'Request account closure',
					cancelAction: 'Keep account',
					confirmInstruction: 'Type {phrase} to confirm.',
					successMessage:
						"We've received your request. Our team will contact you shortly.",
					requested: 'Close requested on {date}',
					requestedNote:
						'Our team has been notified and will reach out to you shortly.',
					error: 'Unable to submit the close request. Please try again.',
				},
				transferOwnership: {
					title: 'Transfer ownership',
					description:
						'Hand primary ownership of this workspace to another Global Admin. The new owner gains full account control; you lose primary-owner-only actions.',
					newOwnerLabel: 'Owner',
					newOwnerPlaceholder: 'Select a Global Admin',
					noEligibleUsers:
						'No eligible users yet — the new owner must already hold the Global Admin role.',
					action: 'Transfer ownership',
					submitting: 'Transferring…',
					confirmTitle: 'Transfer ownership?',
					confirmDescription:
						'This moves primary ownership from {currentOwner} to {newOwner}. This cannot be undone by anyone but the new owner. Continue?',
					confirmAction: 'Transfer ownership',
					cancelAction: 'Cancel',
					confirmInstruction: 'Type {phrase} to confirm.',
					successMessage: 'Primary ownership transferred successfully.',
					loadingOwner: 'Loading…',
					unknownOwner: 'Unknown',
					loadOwnerError: 'Unable to load the current owner. Please try again.',
					loadUsersError: 'Unable to load eligible users. Please try again.',
					error: 'Unable to transfer ownership. Please try again.',
				},
			},
			paymentMethod: {
				title: 'Payment method',
				portalError: 'Unable to open the Stripe portal. Please try again.',
			},
			credits: {
				label: 'Credit balance',
				topUp: 'Top up',
				validUntil: 'Valid until {date}',
				bankTransfer: {
					topUp:
						'Your account is billed by bank transfer; contact us to add credits.',
				},
			},
			currentPlan: {
				label: 'Current plan',
				changePlan: 'Change Plan / Update Billing',
				opening: 'Opening…',
				pill: {
					active: 'Active',
					postpaid: 'Postpaid',
					manual: 'Manual',
				},
				meta: {
					billingCycle: 'Billing cycle',
					renewsOn: 'Renews on',
					paymentMethod: 'Payment method',
					paymentMethodCard: 'Card',
					paymentMethodBankTransfer: 'Bank transfer',
					paymentMethodUnconfigured: 'Not configured',
				},
				interval: {
					monthly: 'Monthly',
					annual: 'Annual',
				},
				intervalShort: {
					monthly: 'month',
					annual: 'year',
				},
				empty: {
					line: 'Pay-per-use',
					hint: 'Subscribe to a plan for predictable monthly pricing.',
				},
				subscribe: 'Subscribe to plan',
				bankTransfer: {
					subscribe:
						'Your account is billed by bank transfer; contact us to set up a subscription.',
					changePlan:
						'Your account is billed by bank transfer; contact us to change your plan.',
				},
				postpaid: {
					line: 'Postpaid',
					nextInvoice: 'Next invoice on {date}',
				},
				package: {
					changePlan: 'Contact us to change your plan.',
				},
				manual: {
					line: 'Manual billing',
					hint: 'Custom billing arrangement — contact your account manager for details.',
				},
				pendingChange: {
					planChange: 'Scheduled to switch to {targetPlan} on {date}.',
					cancellation: 'Cancellation scheduled for {date}.',
					cancellationPayPerUse:
						'After that date, your account will move to pay-per-use pricing.',
				},
			},
			pricing: {
				title: 'Service prices',
				trigger: 'View prices',
				empty: 'No prices are configured for your account yet.',
				status: {
					notAvailable: 'Not available',
					notPriced: 'Not priced',
					disabled: 'Disabled',
				},
				errors: {
					loadFailed: 'Unable to load prices. Please try again.',
				},
				vatDisclaimer:
					'Prices are not inclusive of VAT or any additional Sales Tax. Those are calculated at checkout.',
			},
			customerDetails: {
				title: 'Customer details',
				description: 'Appears on every invoice issued to your company.',
				info: "Invoices and billing alerts (low balance & renewals) are sent to the billing email above and to all Platform Owners. Anyone who'd rather not receive them can switch them off under Notifications in their own profile.",
				cancel: 'Cancel',
				businessName: {
					label: 'Business name',
					placeholder: 'Legal business name',
				},
				addressLine1: {
					label: 'Address line 1',
					placeholder: 'Street and number',
				},
				addressLine2: {
					label: 'Address line 2 (optional)',
					placeholder: 'Suite, building, etc.',
				},
				city: {
					label: 'City',
					placeholder: 'City',
				},
				state: {
					label: 'State (optional)',
					placeholder: 'State or region',
				},
				postalCode: {
					label: 'Postal code',
					placeholder: 'e.g. SLM 1024',
				},
				country: {
					label: 'Country',
					placeholder: 'Select a country',
				},
				vatNumber: {
					label: 'VAT number',
					placeholder: 'e.g. MT12345678',
				},
				vatVerify: {
					invalid: 'The VAT registry reports this VAT number is invalid.',
					lastValidated: 'Verified at {date}',
					pending:
						"We tried to verify this VAT number on {date}, but the VAT registry was unavailable. We'll retry automatically.",
					unknown: 'Not verified yet.',
				},
				billingEmail: {
					label: 'Billing email (optional)',
					placeholder: "billing{'@'}example.com",
				},
				save: 'Save changes',
				saving: 'Saving…',
				requiredField: 'This field is required.',
				saveSuccess: 'Customer details saved.',
				loadError: 'Unable to load billing details. Please try again.',
				saveError: 'Unable to save billing details. Please try again.',
			},
		},
		dashboard: {
			description: 'Track current billable usage and spend.',
			descriptionWithMerchant:
				'Track current billable usage and spend for {merchantName}.',
			filters: {
				billableUnits: 'Billable units',
				current: 'Current',
				currentMonth: 'Current month',
				dateRange: 'Date range',
				otherMonths: 'Other months',
				rangeHint: 'Change month above to widen the range.',
			},
			summary: {
				acrossMetrics: 'Across {count} metrics',
				consumedCredits: 'Consumed credits',
				currentInvoiceEstimate: 'Current spend',
				billingStatus: 'Billing status',
				notBilled: 'Not billed',
				elapsedDays: '{elapsed} of {total} days elapsed',
				totalBillableActions: 'Total billable actions',
				totalSpend: 'Total spend',
				projectedThisMonth: 'Projected this month',
				vsPreviousMonth: 'Vs previous month',
				vsPeriod: 'vs',
				thisPeriod: 'this period',
				inPeriod: 'in',
				finalPeriod: 'Final',
			},
			accountTypes: {
				prepaid: 'Prepaid',
				postpaid: 'Postpaid',
				trial: 'Trial',
				manual: 'Manual',
				unconfigured: 'Not configured',
			},
			cards: {
				usageByMetric: 'Usage by Metric',
				dailyUsageTrend: 'Daily Usage Trend',
			},
			actions: {
				clearAll: 'Clear all',
				done: 'Done',
				exportCsv: 'Export CSV',
				exporting: 'Preparing…',
				filterByComponent: 'Filter by component',
			},
			csv: {
				metric: 'Metric',
				amount: 'Amount',
			},
			placeholders: {
				searchUsage: 'Search by reference or metric',
			},
			labels: {
				costView: '€ Cost',
				exportDefaultedRange:
					'No date range selected. Exporting the most recent 12 months.',
				free: 'FREE',
				metrics: 'metrics',
				records: '{count} records',
				reference: 'Reference',
				unitsView: 'Units',
				units: '{quantity} units',
			},
			empty: {
				noBillableUsage: 'No billable usage found for this period.',
				noDailyUsage: 'No daily usage found for this period.',
			},
			errors: {
				exportFailed: 'Unable to export usage history. Please try again.',
				exportRangeTooWide:
					'Export is limited to 12 months. Please choose a narrower date range.',
				loadAnalytics: 'Failed to load billing analytics.',
			},
			topUp: {
				title: 'Top up credits',
				amountLabel: 'Amount to add',
				currentBalance: 'Current balance',
				newBalance: 'New balance:',
				confirm: 'Continue to payment',
				confirmLoading: 'Redirecting…',
				cancel: 'Cancel',
				vatDisclaimer:
					'Prices are not inclusive of VAT or any additional Sales Tax. Those are calculated at checkout.',
				errors: {
					generic: 'Could not start the top-up. Please try again.',
				},
			},
			subscription: {
				pickPlan: {
					includedTitle: "What's included",
					monthly: 'Monthly',
					annual: 'Annual',
					perMonthShort: '/ month',
					perYearShort: '/ year',
					free: 'Free',
					bonusOnAnnual: 'Includes {amount} bonus credits',
					subscribe: 'Subscribe',
					subscribeLoading: 'Redirecting…',
					empty: 'No plans are configured yet.',
					errors: {
						loadFailed: 'Could not load plans. Please refresh the page.',
						startFailed: 'Could not start the subscription. Please try again.',
					},
				},
			},
		},
	},
	formTemplates: {
		view: {
			breadcrumb: {
				view: 'View Template',
			},
			title: 'View Template',
		},
		edit: {
			breadcrumb: {
				edit: 'Edit Template',
			},
			title: 'Edit Template',
			actions: {
				backToForms: 'Back to Forms',
			},
			empty: {
				notFoundOrLoadFailed: 'Form not found or failed to load.',
			},
			errors: {
				notFound: 'Form not found.',
				loadForm: 'Failed to load form.',
			},
		},
		formHistoryTable: {
			advancedSearch: 'Advanced Search',
			filters: {
				search: 'Search',
				searchPlaceholder: 'Search',
				completedOn: 'Completed on',
				startDate: 'Start date',
				endDate: 'End date',
				riskLevel: 'Risk Level',
				selectRiskLevels: 'Select risk levels',
				type: 'Type',
				selectType: 'Select type',
				status: 'Status',
				selectStatus: 'Select status',
				name: 'Name',
				entityId: 'Entity ID',
				submissionId: 'Submission ID',
			},
			actions: {
				clearFilters: 'Clear Filters',
				newSubmission: 'New Submission',
				resubmit: 'Resubmit',
				exportSelected: 'Export as PDF',
			},
			empty: {
				noSubmissions: 'No form submissions found',
			},
			riskTiers: {
				lowRisk: 'Low Risk',
				mediumRisk: 'Medium Risk',
				highRisk: 'High Risk',
			},
			types: {
				riskAssessment: 'Risk Assessment',
				questionnaire: 'Questionnaire',
			},
			statuses: {
				submitted: 'Submitted',
				draft: 'Draft',
			},
			shortcuts: {
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				lastThreeMonths: 'Last 3 months',
			},
			columns: {
				formTitle: 'Form Title',
				type: 'Type',
				submissionName: 'Submission Name',
				entityName: 'Entity Name',
				riskLevel: 'Risk Level',
				status: 'Status',
				submissionId: 'Submission ID',
				sessionId: 'Session ID',
			},
			templatePicker: {
				title: 'Select a Form Template',
				empty: 'No form templates available.',
			},
			dialogs: {
				deleteDraft: {
					title: 'Delete Draft',
					body: 'Are you sure you want to delete this draft submission?',
				},
				delete: {
					title: 'Delete Submission',
					body: 'Are you sure you want to delete this submission?',
				},
			},
			messages: {
				deleted: 'Submission deleted.',
				noExportableSubmissions:
					'None of the selected submissions can be exported. Only submitted submissions can be exported as PDF.',
				bulkExportSkipped:
					'{count} selected submission(s) were skipped because they are not submitted.',
			},
			errors: {
				loadSubmissions: 'Failed to load form submissions.',
				loadTemplates: 'Failed to load form templates.',
				deleteDraft: 'Failed to delete draft submission.',
				delete: 'Failed to delete submission.',
				invalidSubmissionId: 'Submission ID must be a valid BSON ObjectId.',
				invalidEntityId: 'Entity ID must be a valid BSON ObjectId.',
				bulkExport: 'Failed to export {count} submission(s) as PDF.',
			},
		},
		formCompletion: {
			notApplicable: 'Not Applicable',
			title: 'Form Submission',
			labels: {
				submissionName: 'Submission Name',
				entityName: 'Entity Name',
				estimatedTime: 'Estimated time: {minutes} min',
				stepOf: 'Step {current} of {total}',
				overallScore: 'Overall Score',
			},
			signature: {
				tapToSign: 'Tap to sign',
				signHere: 'Sign here',
				done: 'Done',
				clear: 'Clear',
				help: 'Draw your signature in the box above.',
			},
			placeholders: {
				submissionName: 'Enter submission name',
				selectOption: 'Select an option',
				selectCountries: 'Select countrie(s)',
			},
			actions: {
				cancel: 'Cancel',
				saveDraft: 'Save Draft',
				submit: 'Submit',
				next: 'Next',
				previous: 'Previous',
				repeatSection: 'Repeat this section',
				removeInstance: 'Remove this section',
			},
			score: {
				overallScore: 'Overall Score',
				rawScore: 'Raw Score',
				weightedScore: 'Weighted Score',
			},
			errors: {
				loadTemplate: 'Failed to load form template.',
				loadSubmission: 'Failed to load submission.',
				saveDraft: 'Failed to save draft.',
				submit: 'Failed to submit form.',
				submissionNameRequired: 'Submission name is required.',
				fieldRequired: 'This field is required.',
				minSelections: 'Please select at least {min} option(s).',
				maxSelections: 'Please select at most {max} option(s).',
			},
			dialogs: {
				resubmitLink: {
					title: 'Keep submission linked to case?',
					message:
						'The original submission was linked to a case or an entity.\nWould you like this resubmission to be linked to the original case or entity.',
					keep: 'Yes',
					standalone: 'No',
				},
				repeatSection: {
					prompt: 'Would you like to repeat this section?',
					yes: 'Yes',
					no: 'No',
				},
			},
		},
		formsList: {
			title: 'Templates',
			actions: {
				newForm: 'New Template',
				importTemplate: 'Import Template',
			},
			columns: {
				type: 'Type',
				questions: 'Questions',
				lowRisk: 'Low Risk',
				highRisk: 'High Risk',
			},
			dialogs: {
				deleteForm: {
					title: 'Delete Form',
					body: 'Are you sure you want to delete this form?',
				},
			},
			messages: {
				deleted: 'Form deleted successfully.',
				importSuccess: 'Template imported successfully.',
			},
			errors: {
				loadForms: 'Failed to load forms.',
				deleteForm: 'Failed to delete form.',
				importMissingFields: 'Template must contain title and sections.',
				importInvalidTemplate: 'Invalid template file.',
				importFailed: 'Failed to import template.',
			},
		},
		submissionDetails: {
			notApplicable: 'Not Applicable',
			entity: 'Entity',
			breadcrumb: {
				submissionDetails: 'Submission Details',
			},
			title: 'Submission Details',
			actions: {
				exportPdf: 'Export as PDF',
				overrideScore: 'Override Score',
				saveOverride: 'Override',
				delete: 'Delete',
			},
			dialogs: {
				delete: {
					title: 'Delete Submission',
					body: 'Are you sure you want to delete this submission?',
				},
			},
			sections: {
				breakdown: 'Sections Breakdown',
			},
			labels: {
				finalScore: 'Final Score',
				redFlags: 'Red Flags',
				submissionName: 'Submission Name',
				entityName: 'Entity Name',
				entityId: 'Entity ID',
				caseId: 'Case ID',
				formId: 'Form ID',
				submissionId: 'Submission ID',
				sessionId: 'Session ID',
				answer: 'Answer',
				score: 'Score',
				weightedScore: 'Weighted Score',
				overrideTitle: 'Score Override',
				overrideFinalScore: 'Final Score',
				overrideRiskTier: 'Risk Level',
				overrideReason: 'Override Reason:',
				overriddenBy: 'Overridden By:',
				overriddenRiskLevel: 'Overridden Risk Level',
				overriddenFinalScore: 'Overridden Final Score',
			},
			empty: {
				submissionNotFound: 'Submission not found.',
			},
			messages: {
				deleted: 'Submission deleted.',
			},
			errors: {
				loadSubmission: 'Failed to load submission.',
				exportPdf: 'Failed to export PDF.',
				overrideScore: 'Failed to save score override.',
				overrideReasonRequired: 'Reason is required.',
				overrideScoreExceedsMax: 'Score cannot exceed max score ({max}).',
				delete: 'Failed to delete submission.',
			},
		},
		create: {
			title: 'Create Template',
			tooltips: {
				aiImporter:
					'Experimental AI import: Results may vary, please review and verify the imported questions before publishing or using them in a flow.',
			},
			actions: {
				aiPdfImporter: 'AI PDF Importer',
				cancelling: 'Cancelling...',
				retrying: 'Retrying...',
			},
			jobStatus: {
				processing: 'We are creating your form. This may take several minutes…',
				completed:
					'Form template created successfully. Please review it before use.',
				failedWithReason: 'Creating form failed: {reason}',
				failedWithRetries:
					'Creating form failed. You have {count} retry attempt{suffix} remaining.',
				failedNoRetries: 'Creating form failed. No retry attempts remaining.',
				cancelledWithRetries:
					'Import was cancelled. You have {count} retry attempt{suffix} remaining.',
				cancelledNoRetries:
					'Import was cancelled. No retry attempts remaining.',
			},
			dialogs: {
				delete: {
					title: 'Confirm Delete',
					body: 'Are you sure you want to delete this extraction? This will permanently remove it.',
					confirm: 'Yes, Delete',
				},
			},
			messages: {
				cancelled: 'PDF import has been cancelled. You can retry or delete it.',
				retrying: 'Retrying PDF import...',
				retryUnavailable:
					'Unable to retry. Maximum attempts reached or job is no longer retryable.',
				deleted:
					'Extraction deleted successfully. You can now upload a new file.',
			},
			errors: {
				pdfOnly: 'Please upload a PDF file only.',
				fileTooLarge: 'File size must be less than 10MB.',
				jobCreationTitle: 'Job Creation Failed',
				jobCreation: 'Failed to create extraction job. Please try again.',
				cancelTitle: 'Cancel Failed',
				cancel: 'Failed to cancel extraction. Please try again.',
				retryTitle: 'Retry Failed',
				retry: 'Failed to retry extraction. Please try again.',
				deleteTitle: 'Delete Failed',
				delete: 'Failed to delete extraction. Please try again.',
			},
		},
	},
	forms: {
		labels: {
			email: 'Email',
			password: 'Password',
			newPassword: 'New Password',
			confirmPassword: 'Confirm Password',
			currentPassword: 'Current Password',
		},
		placeholders: {
			email: "example{'@'}domain.com",
			password: 'Type your password',
			required: 'Required',
		},
		validation: {
			emailMissingTitle: 'Enter email',
			emailMissingBody: 'Please enter an email address',
		},
		passwordChecklist: {
			title: 'Password requirements',
			minLength: 'At least 10 characters',
			maxLength: 'No more than 20 characters',
			uppercase: 'At least one uppercase letter',
			lowercase: 'At least one lowercase letter',
			number: 'At least one number',
			specialCharacter: 'At least one special character',
		},
		errors: {
			required: 'This field is required',
			requiredField: '{field} is required',
			invalidField: '{field} is invalid',
			email: 'Please enter a valid email address',
			invalidPhoneNumber: 'Invalid phone number',
			max: 'Must be at most {max}',
			sameAs: '{field1} must be the same as {field2}',
			password:
				'Password must be at least 10 characters and include uppercase, lowercase, number, and special character.',
		},
	},
	profile: {
		tabs: {
			personalDetails: 'Personal',
			security: 'Security',
			notifications: 'Notifications',
			formatPreferences: 'Preferences',
			permissions: 'Permissions',
		},
	},
	auth: {
		sessionExpiring: {
			title: 'Session Expiring Soon',
			countdownLead: 'Your session will expire in',
			question: 'Would you like to stay logged in?',
			stayLoggedIn: 'Stay Logged In',
			extendedSuccess: 'Session extended successfully.',
			extendSessionError: 'An error occurred while extending the session.',
			tabTitleAlert: 'Session Expiring!',
		},
		sessionExpired: {
			message:
				'Session expired. For security reasons, you were logged out automatically. Please login again.',
		},
		login: {
			heading: 'Welcome to QGen Online',
			visualDescription:
				'Streamline your compliance process and drive efficiency.',
			forgotPassword: "Can't remember your password?",
			button: 'Login',
			noAccountLabel: "Don't have an account?",
			errorTitle: 'Failed to log you in',
			errorBody: 'Please check your email and password.',
			accessErrorTitle: 'Access Error',
			accessErrorBody: 'You do not have permission to view the page.',
		},
		forgotPassword: {
			title: 'Reset Your Password',
			description:
				'Please enter your email address to receive a password recovery link',
			visualTitle: 'Reset Your Password',
			visualDescription: 'Enter your email to receive a recovery link.',
			visualAlt: 'Password recovery',
			cta: 'Reset Password',
			successTitle: 'Successful',
			successBody:
				'If {email} belongs to a known account, a recovery link was sent. Please check your spam/junk email folders',
			errorTitle: 'Error',
			errorBody: 'Failed to reset password',
		},
		resetPassword: {
			title: 'Change Password',
			cta: 'Change Password',
			successTitle: 'Successful',
			successBody: 'Password changed successfully',
			errorTitle: 'Error',
			errorBody: 'Failed to reset password',
			invalidTokenTitle: 'Invalid Token',
			invalidTokenBody: 'The token provided is not valid or correctly encoded.',
			visualDescription: 'Choose a strong password to secure your account.',
		},
		// An invited user reaches the same form through the same one-time link, but has
		// never had a password to reset — so the wording sets one rather than replacing one.
		setPassword: {
			title: 'Set Your Password',
			cta: 'Set Password',
			successTitle: 'Welcome aboard',
			successBody: 'Your password is set. Sign in to get started.',
			errorTitle: 'Error',
			errorBody: 'Failed to set password',
			invalidTokenTitle: 'Invalid Invitation Link',
			invalidTokenBody:
				'This invitation link is not valid or has already been used. Ask for a new invitation, or use “Forgot password” on the sign-in page.',
			visualDescription:
				'Choose a strong password to finish setting up your account.',
		},
		// Landing page for the link in an email-change verification email. There is no
		// form: the token in the link is the whole request, so the page only reports how
		// it went and points at sign-in, which the change makes necessary.
		confirmEmailChange: {
			title: 'Confirm Your New Email Address',
			visualDescription:
				'One more step to update the address you sign in with.',
			pendingBody: 'Confirming your new email address…',
			successTitle: 'Email address updated',
			successBody:
				'Your new address is now the one you sign in with. For security, you have been signed out everywhere; sign in again with the new address.',
			errorTitle: 'Something went wrong',
			errorBody:
				'We could not confirm the change right now. Try the link again in a moment.',
			invalidTokenTitle: 'This link is no longer valid',
			invalidTokenBody:
				'The confirmation link has expired or was already used. Sign in and request the change again from your profile.',
			cta: 'Go to sign-in',
		},
		twoFactor: {
			title: 'MFA Authentication',
			visualDescription: 'Secure access verification',
			visualAlt: 'Multi-factor authentication',
			placeholderVerification: 'Enter the verification code',
			placeholderRecovery: 'Enter one of your recovery codes',
			useRecovery: 'Use a recovery code',
			useVerification: 'Use a verification code',
			resend: 'Resend verification code',
			alternativeToggle: 'Receive the code via alternative channel?',
			alternativePlaceholder: 'Select an alternative channel',
			sendAlternative: 'Send code via alternative channel',
			stillTrouble: 'Still having trouble?',
			sendSupportEmail: 'Send email to support',
			recoveryNote:
				'Please note that the used recovery code cannot be used again',
			invalidCode: 'Invalid verification code',
			missingCode: 'Please enter the verification code',
			alternativeSent: 'Verification code sent via alternative channel',
		},
		twoFactorSetupRequired: {
			title: 'MFA Authentication Setup Required',
			message:
				'Your organization requires MFA Authentication to be enabled. Please complete the setup below to continue.',
			visualAlt: 'MFA setup required',
		},
		updatePassword: {
			title: 'Change password',
			mismatch: 'Passwords do not match.',
			success: 'Password is successfully updated',
			errorTitle: 'Error',
			errorBody: 'Failed to update user.',
		},
	},
	aml: {
		common: {
			labels: {
				searchTerm: 'Search Term',
				reference: 'Reference',
				birthYear: 'Birth Year',
				country: 'Country',
				updates: 'Updates',
				source: 'Source',
				tag1: 'Tag 1',
				tag2: 'Tag 2',
				tag3: 'Tag 3',
				user: 'User',
				pendingUpdates: 'Pending Updates',
				batchId: 'Batch ID',
				defaultCheckCategories: 'Default Check Categories',
				enableOngoingMonitoring: 'Ongoing Monitoring',
			},
			placeholders: {
				select: 'Select',
				y4Optional: 'YYYY (optional)',
				selectColumn: 'Select column',
				selectIdColumn: 'Select ID Column',
				selectOrTypeCountries: 'Select or type countries',
			},
			atLeastOneCheckCategory: 'At least one check category must be selected',
		},
		search: {
			breadcrumb: {
				root: 'Dashboard',
				aml: 'Name Screening (AML)',
				search: 'Search',
			},
			title: 'Name Screening (AML) Search',
			form: {
				submit: 'Search',
				cancel: 'Cancel',
				nameLabel: 'Name',
				nameRequiredError: 'The name field is required',
				yearOfBirth: 'Year Of Birth',
				country: 'Country',
				referenceNo: 'Reference No.',
				fuzzinessInterval: 'Fuzziness Interval',
				notes: 'Notes',
				entityType: 'Entity Type',
				tagsTitle: 'Tags',
				checkCategoriesTitle: 'Search Check Categories',
				optional: 'optional',
				optionalYyyy: 'optional(yyyy)',
				required: 'required',
				fuzzinessHelp:
					'Level of flexibility of search (0% will check for exact matches only; 100% will look for results with even the slightest match in spelling and phonetics).',
				errors: {
					birthYearRange: 'Year must be between 1900 and {max}',
					noCheckCategory: 'At least one check category must be selected',
				},
			},
		},
		results: {
			breadcrumb: {
				root: 'Dashboard',
				aml: 'Name Screening (AML)',
				search: 'Search',
				history: 'History',
				results: 'Search Results',
			},
			searchCriteria: 'Search Criteria',
			searchResultsTitle: 'Search Results',
			providerUnavailable:
				"Connection Error: We're currently unable to connect to the provider. You can retry the search.",
			criteria: {
				name: 'Name',
				country: 'Country',
				yearOfBirth: 'Year of Birth',
				fuzziness: 'Fuzziness Interval',
				exactMatch: 'Exact Match',
				id: 'ID',
				batchId: 'Batch ID',
				clientRef: 'Client Ref.',
				entityType: 'Entity Type',
				entityTypeAll: 'All',
				entityId: 'Entity ID',
				caseId: 'Case ID',
				updated: 'Updated',
				monitoredSearch: 'Monitored search',
			},
			goToCase: 'Go to Case Entity',
			linkToCaseEntity: 'Link to existing case entity',
			link: {
				popupTitle: 'Link search to case entity',
				popupDescription:
					'Search for a case or entity, then select the entity this screening result belongs to.',
				success: 'AML search linked to the case entity.',
				error: 'Failed to link the search to the case entity.',
			},
			monitoring: 'Ongoing Monitoring',
			monitoringInfo:
				'Ongoing AML monitoring re-screens customers against updated watchlists and flags new matches. Renewal fee charged at 12 months if still enabled.',
			statusUpdated: 'Status updated successfully',
			updatedSuccess: 'Updated successfully',
			noteAddedSuccess: 'Note added successfully',
			monitorUpdated: 'Monitor updated successfully',
			sources: 'Sources',
			noTagsFound: 'No tags found',
			note: 'Note',
			notesHistory: 'Notes History',
			showEntityNotes: 'Show Entity Notes',
			empty: {
				noNotes: 'There are no notes yet.',
				noNotesWithAction: 'There are no notes yet. Click Add Note to add one.',
				addNoteAction: 'Add Note',
			},
			createdBy: 'Created by',
			createdAt: 'Created at',
			searchStatus: 'Search Status:',
			retry: 'Retry',
			matchesSortedByRelevance: 'Matches {count} sorted by relevance',
			maximumResultsWarning:
				'Showing maximum 500 results - refine your search to see more specific matches.',
			downloadSearchResultsXlsx: 'Search Results (xlsx)',
			downloadPdf: 'PDF',
			downloadAuditLogs: 'Audit Logs',
			acknowledgeUpdates: 'Acknowledge Updates',
			refreshSearch: 'Refresh Search',
			newlyMonitoredChanges: {
				title: 'Newly monitored changes',
				added: 'Added',
				updated: 'Updated',
				removed: 'Removed',
				helperText:
					'To see these changes reflected in the search results please click the acknowledge button.',
			},
			addNoteDialogTitle: 'Add Note',
			noteHistoryDialogTitle: 'Note History',
			selectedSourcesDialogTitle: 'Selected Sources',
			discardChangesTitle: 'Discard changes?',
			discardChangesBody:
				'You have unsaved data. It will be lost if you go to another page.',
			deleteSearchNoPermission:
				'You do not have permission to delete search results.',
			confirmAllClearDialogTitle: 'Confirm All Clear',
			confirmAllClearDialogBody:
				'This will mark all hits on this search as whitelisted and set the status to "All Clear." This action can be changed later, but any hits currently under review will no longer be flagged. Are you sure you want to continue?',
			confirmAllClearConfirm: 'Confirm All Clear',
			allClearBlockedByUpdates:
				'Acknowledge the monitored changes before setting All Clear, so the new hits are reviewed before they are whitelisted.',
			deleteSearchDialogTitle: 'Delete Search',
			deleteSearchDialogBody:
				'Are you sure you want to permanently delete this search result? This action cannot be undone.',
			deleteSearchSuccess: 'Search result "{searchTerm}" deleted successfully.',
			errors: {
				fetchAllEntities: 'Failed to fetch all entities',
				allClearNotApplied:
					'The hits could not be whitelisted, so the status was left unchanged. Try again.',
			},
		},
		history: {
			breadcrumb: {
				root: 'Dashboard',
				aml: 'Name Screening (AML)',
				search: 'Search',
				history: 'History',
			},
			title: 'Name Screenings{suffix}',
			newScreening: 'New Screening',
			searchMinLength: 'Needs to be at least 3 characters long to match.',
			advancedSearch: 'Advanced Search',
			showApiSearches: 'Show API Searches',
			clearFilters: 'Clear Filters',
			actions: {
				sidebarLayout: 'Sidebar view',
				topLayout: 'Top to bottom view',
			},
			shortcuts: {
				lastWeek: 'Last week',
				lastMonth: 'Last month',
				lastThreeMonths: 'Last 3 months',
			},
			bulkActions: {
				monitoringOn: 'Ongoing Monitoring: On',
				monitoringOff: 'Ongoing Monitoring: Off',
				download: 'Download Results',
				downloadCertificates: 'Download Certificates',
				deleteSelectedSearches: 'Delete Searches',
			},
			rowActions: {
				downloadResult: 'Download Result',
				downloadCertificate: 'Download Certificate',
			},
			bulk: {
				errors: {
					selectAtLeastOneRow: 'Please select at least one row',
					selectSearchToDelete: 'Please select at least one search to delete.',
					selectSearchToDownload:
						'Please select at least one search to download.',
				},
				messages: {
					monitoringUpdated: 'Monitoring status updated successfully',
				},
				delete: {
					confirmTitle: 'Delete Searches',
					confirmBody:
						'You are about to permanently delete {count} selected search results. This action cannot be undone. Do you wish to continue?',
					processingMessage:
						'Your request to delete {count} search results is being processed. You will receive an email notification when the job has been completed.',
				},
				downloadCertificates: {
					title: 'Download Certificates',
					start: 'Start',
					confirmBody:
						"You are about to generate a ZIP file for {count} certificate{suffix}. This background task may take time, and you'll receive an email when it's ready. Do you want to continue?",
					processingMessage:
						'Your request to download {count} certificates is being processed with batch id {batchId}. You will receive an email notification when the ZIP is ready for download.',
				},
			},
			table: {
				headers: {
					searchTerm: 'Search Term',
					entityType: 'Entity Type',
					id: 'ID',
					batchId: 'Batch ID',
					createdBy: 'Created By',
					createdOn: 'Created On',
					reference: 'Reference',
					updates: 'Updates',
					monitored: 'Ongoing Monitoring',
					apiKey: 'API Key',
					tags: 'Tags',
					hits: 'Hits',
				},
				empty: 'No previous searches found',
			},
		},
		batch: {
			title: 'Batch Operations',
			tabs: {
				searches: 'Search',
				downloads: 'Certificate Download',
				delete: 'Delete',
			},
			newBatchSearch: 'New Batch Search',
			certificatePrepStarted:
				'Certificate preparation for batch {batchId} has started.',
			downloadLinkMissing: 'Could not retrieve download link.',
			delete: {
				intro: 'Upload a file with search IDs to delete them in bulk.',
				maxIdsPerFile: 'Maximum {limit} IDs per file.',
				startDelete: 'Start Delete',
				previewTitle: 'Preview of Search IDs to be Deleted',
				tooManyIds:
					'The file contains {count} IDs. Please upload a file with {limit} IDs or less.',
				confirmPrompt:
					'You are about to permanently delete {count} selected search results. This action cannot be undone. Do you wish to continue?',
				confirmTitle: 'Warning',
				confirmButton: 'Confirm',
				inProgressMessage:
					'Your request to delete {count} search results is being processed. You will receive an email when the job has completed.',
				startAnother: 'Start another delete',
			},
			statuses: {
				unknown: 'Unknown',
				completed: 'Completed',
				processing: 'Processing',
				pending: 'Pending',
				failed: 'Failed',
				expired: 'Expired',
				completedWithWarnings: 'Completed with warnings',
			},
			checkTypeGroups: {
				sanctions: 'Sanctions',
				pep: 'PEP',
				adverseMedia: 'Adverse Media',
				warnings: 'Warnings',
				fitnessProbity: 'Fitness & Probity',
			},
			searchPage: {
				title: 'New AML Batch Search',
				removeFile: 'Remove file',
				uploadTitle: 'Upload Batch File',
				uploadDescription:
					'Upload an Excel (.xlsx, .xls) or CSV file containing the records to search. The file should contain columns for name, reference, birth year, country, etc.',
				dropFileText:
					'Drop your .xlsx, .xls or .csv file here or click to upload',
				startBatchSearch: 'Start Batch Search',
				processing: 'Processing batch search...',
				recordsPreviewTitle: 'Records Preview ({count} records)',
				loadingData: 'Loading data...',
				recordsPreviewDescription:
					'Review and edit the record data before starting the batch search. Global settings below apply to all records. You can modify individual names, references, birth years, and countries in the table.',
				defaultMonitoring: 'Ongoing Monitoring',
				defaultFuzziness: 'Default Fuzziness',
				firstRowHeaders: 'First row contains headers',
				sanctionsGroupLabel: 'Sanctions, Warnings, Fitness & Probity Check',
				pepGroupLabel: 'PEP Check',
				adverseMediaGroupLabel: 'Adverse Media V2',
				exactMatch: 'Exact Match',
				broadMatch100: '100% Broad Match',
				validationErrorsTitle: 'Validation Errors',
				goToFirstError: 'Go to First Error',
				fileReadError:
					"Error reading file. Please ensure it's a valid Excel or CSV file.",
				fileEmpty: 'File appears to be empty.',
				columnPrompt: 'Please select the column for {columnName}',
				removeAllColumns: 'Remove all {columnName}',
				columnLabel: '{field} Column',
				columnLabelRequired: '{field} Column*',
				columnNames: {
					searchTerm: 'search term',
					reference: 'client references',
					birthYear: 'date of birth',
					country: 'country',
				},
				validationSummary:
					'{count} record(s) have validation errors that need to be fixed before starting the batch search:',
				validationRow: 'Row {row}:',
				validation: {
					searchTermRequired: 'Search term is required',
					birthYearInvalidNumber: 'Birth year must be a valid number',
					birthYearInvalidFormat: 'Birth year must be a 4-digit year (YYYY)',
					birthYearBeforeMin: 'Birth year cannot be before {year}',
					birthYearInFuture: 'Birth year cannot be in the future',
					invalidCountryCodes: 'Invalid country code(s): {codes}',
				},
				submittedSuccess: 'Batch search submitted successfully!',
			},
			downloadDetails: {
				breadcrumbBatchHistory: 'Batch History',
				breadcrumbDownloadDetails: 'Download Details',
				title: 'Certificate Download Details - ID: {id}',
				backToHistory: 'Back to History',
				preparingMessage:
					'Your certificates are being prepared. This may take time, you can close this page. We will notify you once the download is ready.',
				loadingStatus: 'Loading download status...',
				notPreparedTitle: 'Certificates Are Not Prepared',
				notPreparedBody:
					'The downloadable ZIP file for this batch has not been generated yet.',
				starting: 'Starting...',
				startPreparation: 'Start Preparation',
				downloadExpiredTitle: 'Download Link Expired',
				downloadExpiredBody:
					'This download link has expired. Downloads are available for 14 days after creation.',
				readyTitle: 'Your Download is Ready!',
				readySummary:
					'{completed} of {total} certificates were successfully generated.',
				failedCount: '({count} failed)',
				generatingLink: 'Generating Link...',
				downloadZip: 'Download ZIP',
				passwordHelp:
					'The download password has been sent to {email}. Please use an AES-256 compatible application such as WinRAR, 7-Zip, or WinZip to extract the encrypted files.',
				preparationFailedTitle: 'Download Preparation Failed',
				preparationFailedBody:
					'All certificate generation attempts failed for this batch.',
				retrying: 'Retrying...',
				tryAgain: 'Try Again',
				searchId: 'AML Search ID',
				searchResultsLinkTooltip: 'View Search Results in new tab',
				details: 'Details',
				pending: 'Pending',
				success: 'Success',
				failed: 'Failed',
				includedSearchesTitle: 'Included Searches in this Download ({count})',
				includedSearchesSubtitle:
					'A total of {count} search results are included in the generated ZIP file.',
				pendingSearchesTitle: 'Searches to be Included ({count})',
				pendingSearchesSubtitle:
					'A total of {count} search results will be included in the ZIP file upon completion.',
			},
			history: {
				emptySearches: 'No batch searches found',
			},
			details: {
				breadcrumbBatchHistory: 'Batch History',
				breadcrumbBatchDetails: 'Batch Details',
				title: 'Batch Details',
				retryFailedSearches: 'Retry Failed Searches',
				restartedSuccess: 'Batch search has been restarted successfully!',
				backToHistory: 'Back to History',
				batchRecordsTitle: 'Batch Records ({count} records)',
				noRecords: 'No records found for this batch',
				selectedCheckTypes: 'Selected Check Types',
				batchIdRequired: 'Batch ID is required',
				downloadCertificates: {
					noCompletedSelected:
						'None of the selected records has a completed search, so there is no certificate to download.',
					skippedNote:
						'{skipped} selected record(s) without a completed search will be left out.',
				},
			},
			table: {
				searches: {
					batchId: 'Batch ID',
					status: 'Status',
					checkTypes: 'Check Types',
					monitored: 'Ongoing Monitoring',
					fuzziness: 'Fuzziness',
					createdAt: 'Created At',
					createdBy: 'Created By',
				},
				downloads: {
					downloadId: 'Download ID',
					status: 'Status',
					totalFiles: 'Total Files',
					completed: 'Completed',
					failed: 'Failed',
					createdAt: 'Created At',
					createdBy: 'Created By',
					empty: {
						message:
							'No certificate batch downloads yet. To download multiple certificates at once, go to the AML Overview screen, select the searches you need, and choose Download Certificates from the Actions menu.',
						action: 'Go to AML Overview',
					},
				},
			},
		},
		reports: {
			billing: {
				common: {
					placeholders: {
						selectPeriod: 'Select Period',
					},
					errors: {
						loadPeriods: 'Failed to load billing periods.',
					},
				},
				list: {
					actions: {
						downloadCsv: 'Download Reports (csv)',
					},
					columns: {
						merchant: 'Merchant',
						period: 'Period',
						cases: 'Cases',
						users: 'Users',
						docChecks: 'Doc Checks',
						faceChecks: 'Face Checks',
						nameScreening: 'Name Screening',
						initialScreenings: 'Initial Screenings',
						monitoringRenewals: 'Monitoring Renewals',
						formSubmissions: 'Form Subs',
					},
					empty: {
						noPeriods: 'No billing periods found',
					},
					messages: {
						noRowsSelected: 'No rows selected for download',
					},
					errors: {
						fetchRowData: 'Failed to fetch data for {merchantName}',
						downloadReports: 'Failed to download reports',
						loadPeriodReports: 'Failed to load period reports.',
					},
					csvHeaders: {
						merchantName: 'Merchant Name',
						period: 'Period',
						month: 'Month',
						year: 'Year',
						totalCases: 'Total Cases',
						totalOtherDocs: 'Total Other Docs',
						totalFaceComparisons: 'Total Face Comparisons',
						drivingLicense: 'Driving License',
						identityCard: 'Identity Card',
						otherDocument: 'Other Document',
						passport: 'Passport',
						selfie: 'Selfie',
						totalUsers: 'Total Users',
						blockedUsers: 'Blocked Users',
						totalDocChecks: 'Total Doc Checks',
						successfulDocChecks: 'Successful Doc Checks',
						failedDocChecks: 'Failed Doc Checks',
						docTypeDrivingLicense: 'Doc Type: Driving License',
						docTypeIdentityCard: 'Doc Type: Identity Card',
						docTypePassport: 'Doc Type: Passport',
						totalFaceChecks: 'Total Face Checks',
						successfulFaceChecks: 'Successful Face Checks',
						failedFaceChecks: 'Failed Face Checks',
						totalNameScreenings: 'Total Name Screenings',
						monitoredNameScreenings: 'Monitored Name Screenings',
						initialScreenings: 'Initial Screenings',
						monitoringRenewals: 'Monitoring Renewals',
						totalEmails: 'Total Emails',
						deliveredEmails: 'Delivered Emails',
						totalSms: 'Total SMS',
						deliveredSms: 'Delivered SMS',
						formSubmissions: 'Form Submissions',
					},
				},
				tabs: {
					organization: 'Organization',
					global: 'Global',
					periods: 'Periods',
				},
				packages: {
					title: 'Pricing Packages',
					description:
						'Manage commercial package templates used when a merchant is assigned to structured pricing.',
					empty: 'No pricing packages found yet.',
					labels: {
						metrics: 'metrics',
						serviceEnabled: 'Service enabled',
						serviceDisabled: 'Service disabled',
					},
					catalogCard: {
						name: 'Pay-per-use',
					},
					fields: {
						packageCode: 'Package code',
						displayName: 'Display name',
						monthlyMinimum: 'Monthly minimum',
						annualCommitment: 'Annual commitment',
						annualPaidAmount: 'Annual paid amount',
					},
					placeholders: {
						packageCode: 'starter',
						displayName: 'Starter',
						optionalAmount: 'Optional amount',
						catalogFallback: 'Catalog price',
					},
					actions: {
						newPackage: 'New Package',
						save: 'Save Package',
						deprecate: 'Deprecate',
						setToPpu: 'Set to PPU',
						clearFollowPpu: 'Set a custom price',
					},
					editor: {
						createTitle: 'Create package',
						editTitle: 'Edit package',
						catalogTitle: 'Pay-per-use package',
						description:
							'Leave a metric price empty to inherit the global catalog price. Disable a metric to make it unavailable in this package.',
						catalogDescription:
							'Pay-per-use package is the Global Catalog defaults. Changes here update the default prices and availability applied to merchants without an active pricing package.',
						addOnHintTooltip:
							'Need an add-on for a specific merchant only? Keep the package as-is and set a merchant-level metric override from Billing Configuration.',
					},
					confirm: {
						title: 'Deprecate package?',
						message:
							'{packageName} will no longer be available for new assignments. Existing historical billing remains unchanged.',
						confirmLabel: 'Deprecate Package',
					},
					messages: {
						saved: 'Pricing package saved successfully.',
						deprecated: 'Pricing package deprecated successfully.',
					},
					errors: {
						load: 'Failed to load pricing packages.',
						save: 'Failed to save pricing package.',
						deprecate: 'Failed to deprecate pricing package.',
					},
				},
				catalog: {
					confirm: {
						title: 'Save catalog price changes?',
						message:
							'These changes will affect the default prices used across merchants that do not have an override.',
						confirmLabel: 'Save Changes',
					},
					placeholders: {
						defaultPrice: 'Default price',
					},
					messages: {
						saved: 'Catalog prices updated successfully.',
					},
					errors: {
						save: 'Failed to save billing catalog prices.',
					},
				},
				detail: {
					title: 'Billing Report Details',
					loading: 'Loading...',
					breadcrumb: {
						dashboard: 'Dashboard',
						billing: 'Billing',
						details: 'Details',
					},
					tabs: {
						general: 'General',
						ai: 'AI',
						comply: 'AML',
						notifications: 'Notifications',
						forms: 'Forms',
						dashboard: 'Dashboard',
					},
					actions: {
						backToBilling: 'Back to Billing',
					},
					headings: {
						formSubmissions: 'Form Submissions',
						formSubmissionsDistribution: 'Form Submissions Distribution',
					},
					cards: {
						overview: 'Overview',
						cases: 'Cases',
						users: 'Users',
						fileStorageSummary: 'File Storage Summary',
						documentChecksDistribution: 'Document Checks Distribution',
						userStatistics: 'User Statistics',
						documentChecks: 'Document Checks',
						faceChecks: 'Face checks',
						documentChecksSuccessRate: 'Document Checks Success Rate',
						faceLivenessSuccessRate: 'Face Liveness Success Rate',
						documentTypesDistribution: 'Document Types Distribution',
						complyInformation: 'AML Information',
						nameScreeningStatistics: 'Name Screening Statistics',
						emailNotifications: 'Email Notifications',
						smsNotifications: 'SMS Notifications',
						emailStatusDistribution: 'Email Status Distribution',
						emailVsSms: 'Email vs SMS',
						smsStatusDistribution: 'SMS Status Distribution',
						aiStats: 'AI Stats',
					},
					labels: {
						merchantId: 'Merchant ID',
						period: 'Period',
						dateRange: 'Date Range',
						created: 'Created',
						lastUpdated: 'Last Updated',
						totalCases: 'Total Cases',
						faceComparisons: 'Face Comparisons',
						otherDocs: 'Other Docs',
						documentChecks: 'Document Checks',
						identityCard: 'Identity Card',
						drivingLicense: 'Driving License',
						passport: 'Passport',
						selfie: 'Selfie',
						totalUsers: 'Total Users',
						blockedUsers: 'Blocked Users',
						totalFileStorageUpToLastMonth:
							'Total File Storage (Up to Last Month)',
						fileStorageAddedThisMonth: 'File Storage Added This Month',
						totalFileStorageIncludingThisMonth:
							'Total File Storage (Including This Month)',
						totalChecks: 'Total Checks',
						successfullyProcessed: 'Successfully Processed',
						unprocessed: 'Unprocessed',
						documentTypes: 'Document Types',
						totalSubmitted: 'Total Submitted',
						totalSearches: 'Total Searches',
						monitoredSearches: 'Monitored Searches',
						initialScreenings: 'Initial Screenings',
						monitoringRenewals: 'Monitoring Renewals',
						nameScreening: 'Name Screening',
						total: 'Total',
						email: 'Email',
						sms: 'SMS',
						totalSubmissions: 'Total Submissions',
						submissionsByForm: 'Submissions by Form',
						faceChecks: 'Face Checks',
					},
					documentTypes: {
						identityCard: 'Identity Card',
						drivingLicense: 'Driving License',
						passport: 'Passport',
						selfie: 'Selfie',
						otherDocument: 'Other Document',
					},
					statuses: {
						delivered: 'Delivered',
						failed: 'Failed',
						pending: 'Pending',
						sent: 'Sent',
						queued: 'Queued',
						bounced: 'Bounced',
						opened: 'Opened',
						clicked: 'Clicked',
						rejected: 'Rejected',
						accepted: 'Accepted',
						undelivered: 'Undelivered',
					},
					messages: {
						missingPeriodOrMerchantId: 'Missing period or merchant ID',
					},
					errors: {
						loadReportDetails: 'Failed to load report details.',
					},
					charts: {
						titles: {
							documentChecks: 'Document Checks',
							documentChecksNoData: 'Document Checks (No Data)',
							userDistribution: 'User Distribution',
							userDistributionNoData: 'User Distribution (No Data)',
							documentChecksResults: 'Document Checks Results',
							documentChecksResultsNoData: 'Document Checks Results (No Data)',
							faceLivenessResults: 'Face Liveness Results',
							faceLivenessResultsNoData: 'Face Liveness Results (No Data)',
							documentTypesDistribution: 'Document Types Distribution',
							documentTypesDistributionNoData:
								'Document Types Distribution (No Data)',
							nameScreeningMonitoringStatus: 'Name Screening Monitoring Status',
							nameScreeningMonitoringStatusNoData:
								'Name Screening Monitoring Status (No Data)',
							emailStatusDistribution: 'Email Status Distribution',
							emailStatusDistributionNoData:
								'Email Status Distribution (No Data)',
							emailVsSmsDistribution: 'Email vs SMS Distribution',
							emailVsSmsDistributionNoData:
								'Email vs SMS Distribution (No Data)',
							smsStatusDistribution: 'SMS Status Distribution',
							smsStatusDistributionNoData: 'SMS Status Distribution (No Data)',
							formSubmissionsDistribution: 'Form Submissions Distribution',
							formSubmissionsDistributionNoData:
								'Form Submissions Distribution (No Data)',
						},
						labels: {
							total: 'Total',
							activeUsers: 'Active Users',
							blockedUsers: 'Blocked Users',
							successfulChecks: 'Successful Checks',
							failedChecks: 'Failed Checks',
							monitoredSearches: 'Monitored Searches',
							nonMonitoredSearches: 'Non-Monitored Searches',
						},
					},
				},
			},
		},
		searchDetails: {
			whitelistStatusChanged:
				"Whitelist status successfully changed to '{status}'",
			checkCount: '{count} out of {total}',
			criteria: {
				name: 'Name',
				country: 'Country',
				yearOfBirth: 'Year of Birth',
				// Typo kept so the migration changes nothing on screen.
				fuzziness: 'Fuziness Interval',
				exactMatch: 'Exact Match',
				id: 'ID',
				clientRef: 'Client Ref.',
				entityId: 'Entity ID',
				caseId: 'Case ID',
				whitelisted: 'Whitelisted',
			},
			noteAddedSuccess: 'Note added successfully',
			breadcrumb: {
				details: 'Search Details',
			},
			headings: {
				searchCriteria: 'Search Criteria',
				keyInformation: 'Key Information',
				listing: 'Listing',
				media: 'Media',
			},
			labels: {
				pepCheck: 'PEP Check',
				adverseMediaCheck: 'Adverse Media Check',
				sanctionsWarningsFitnessProbity:
					'Sanctions, Warnings, Fitness & Probity Check',
				image: 'Image',
				fullName: 'Full Name',
				entityType: 'Entity Type',
				aka: 'AKA',
				countries: 'Countries',
				dob: 'DOB',
				associates: 'Associates',
				listingStarted: 'Listing Started',
				listingRemoved: 'Listing Removed',
				listingEnds: 'Listing Ends',
				url: 'Url',
				snippet: 'Snippet',
				removedFrom: 'REMOVED FROM',
				note: 'Note:',
			},
			listings: {
				pep: 'PEP listing',
				adverseMedia: 'Adverse Media listing',
				sanction: 'Sanction listing',
			},
			actions: {
				addNote: 'Add Note',
				notesHistory: 'Notes History',
				downloadPdf: 'Download PDF',
			},
			empty: {
				noNotes: 'There are no notes yet.',
				noNotesWithAction: 'There are no notes yet. Click Add Note to add one.',
			},
			dialogs: {
				addNote: 'Add Note',
				noteHistory: 'Note History',
			},
		},
		tables: {
			whitelistUpdated: 'White list updated successfully',
			amlTable: {
				whitelistToggleOn: 'Whitelisted',
				whitelistToggleOff: 'Not Whitelisted',
				entityId: 'Entity ID',
				detectionDate: 'Last Updated',
				matched: 'Matched',
				matchTypes: 'Match Types',
				score: 'Score',
				countries: 'Countries',
				whitelisted: 'Whitelisted',
				notes: 'Notes',
				noMatchesFound: 'No matches found',
				categories: {
					sanctions: { short: 'S', full: 'Sanctions' },
					peps: { short: 'P', full: 'PEPs' },
					warnings: { short: 'W', full: 'Warnings' },
					adverseMedia: { short: 'A', full: 'Adverse Media' },
				},
			},
		},
	},
	settings: {
		common: {
			breadcrumbs: {
				settings: 'Settings',
			},
		},
		caseSettings: {
			title: 'Case Templates',
			tabs: {
				types: 'Types',
				statusSets: 'Status Sets',
				customFields: 'Custom Fields',
			},
			common: {
				labels: {
					group: 'Group',
					default: 'Default',
				},
				empty: {
					noSettingsForMerchant: 'No case settings for this merchant',
				},
				dialogs: {
					updateTitle: 'Update!',
					deleteTitle: 'Delete!',
				},
				validation: {
					inputAllFields: 'Please input all fields',
				},
				errors: {
					loadCaseStatusesAndTypes: 'Failed to load case statuses and types',
				},
				tooltips: {
					usedInCasesAndCaseTypes:
						'Used in {caseCount} case(s) across {typeCount} case type(s).',
					usedByUnusedCaseTypes:
						'Used by {count} case type(s), but those case types are not used in any cases yet.',
					openCaseTypes: 'View matching case types',
				},
			},
			statuses: {
				title: 'Case Status',
				setsTitle: 'Case Status Sets',
				notice: {
					title: 'Status Set Overview',
					body: 'This set defines which statuses a case can move through. Default statuses are always included, and you can add, edit, or remove custom statuses for this set.',
				},
				tooltips: {
					defaultStatus:
						'This is a default status and it is included in every status set.',
				},
				actions: {
					addStatus: 'Add Status',
					addExistingStatus: 'Add Status',
					addSet: 'Add Status Set',
					createStatus: 'Create Status',
					editSet: 'Edit Status Set',
					removeFromSet: 'Remove from Set',
					setDefault: 'Set Default',
				},
				dialogs: {
					setDefault: {
						body: 'Are you sure you want to set this status as default status?',
					},
					delete: {
						body: 'Are you sure you want to delete the status(es)?',
						usedWarning:
							'{statuses} is used by {count} case(s). Deleting it can leave those cases with a status that no longer exists.',
					},
					removeFromSet: {
						body: '{statuses} is used by {count} case(s). Removing it from this status set can leave those cases with a status that is no longer selectable.',
					},
					deleteSet: {
						title: 'Delete Status Set?',
						body: 'Are you sure you want to delete this status set?',
					},
				},
				validation: {
					savePreviousSelected: 'Please save previous selected status',
				},
				messages: {
					defaultUpdated: 'Default status updated successfully',
					created: 'Status created successfully',
					setCreated: 'Status set created successfully',
					setSaved: 'Status set saved successfully',
					setDeleted: 'Status set deleted successfully',
					saved: 'Status saved successfully',
					deleted: 'Status deleted successfully',
				},
				errors: {
					setDefault: 'Failed to set default status',
					checkUsage: 'Failed to check case status usage',
					create: 'Failed to create status',
					createSet: 'Failed to create status set',
					update: 'Failed to update status',
					updateSet: 'Failed to update status set',
					delete: 'Failed to delete status',
					deleteSet: 'Failed to delete status set',
				},
			},
			types: {
				labels: {
					usage: 'Usage',
				},
				actions: {
					add: 'Add Type',
				},
				dialogs: {
					delete: {
						body: 'Are you sure you want to delete the case type(s)?',
					},
				},
				messages: {
					created: 'Case type created successfully',
					saved: 'Case type saved successfully',
					deleted: 'Case type deleted successfully',
				},
				errors: {
					create: 'Failed to create case type',
					update: 'Failed to update case type',
					delete: 'Failed to delete case type',
				},
				tooltips: {
					usedInSingleCase: 'Used by {count} case.',
					usedInCases: 'Used by {count} cases.',
					openCases: 'View matching cases',
				},
				editor: {
					titleCreate: 'Add Type',
					titleEdit: 'Edit Case Type',
					info: {
						title: 'About Case Types',
						body: 'Case types define how cases are organized and processed. A type combines a status workflow and optional custom fields, so each case follows the right lifecycle and captures the right data.',
					},
					notice: {
						statusSet: {
							title: 'About Status Sets',
							body: 'Status sets define the workflow states available to this case type and which status is used by default when a case is created.',
						},
						customFields: {
							title: 'About Custom Fields',
							body: 'Custom fields add extra, type-specific data points to case, person, and company forms used in this case type.',
						},
						systemCaseType: {
							title: 'System Case Type',
							body: 'System case types are managed internally and cannot be modified.',
						},
					},
					labels: {
						fieldSet: 'Custom Fields',
						statusSet: 'Status Set',
						customFields: 'Custom Fields',
						usage: 'Used In',
					},
					actions: {
						restoreInfo: 'Show info',
					},
					usage: {
						notUsed: 'Not used',
						case: 'case',
						cases: 'cases',
						caseType: 'case type',
						caseTypes: 'case types',
					},
					tooltips: {
						lockedBecauseUsed:
							"You can't edit this item because the case type is already used.",
					},
				},
			},
			customFieldsManager: {
				title: 'Custom Fields',
				description:
					'Create and organize custom field sets for cases, persons, and companies.',
				labels: {
					name: 'Set name',
					description: 'Description',
					fieldLabel: 'Field Label',
					required: 'Required',
					noFields: 'No fields yet, please add fields below.',
				},
				fieldTypes: {
					string: 'Text',
					text: 'Text',
					textarea: 'Textarea',
					email: 'Email',
					phone: 'Phone',
					select: 'Select',
					date: 'Date',
					options: 'Options',
					cascader: 'Cascader',
				},
				tabs: {
					case: 'Case',
					person: 'Person',
					company: 'Company',
				},
				actions: {
					addField: 'Add Custom Field',
				},
				errors: {
					missingLabel: 'Please provide a label for the field',
					invalidLabel:
						'Label can only contain alphanumeric characters and spaces',
					missingName: 'Name is required',
					save: 'Failed to save custom fields',
				},
				dialogs: {
					overrideTitle: 'Recreate custom fields?',
					overrideBody:
						'Changing this set will override the existing custom field data for cases, persons, and companies.',
				},
				messages: {
					saved: 'Custom fields saved successfully',
				},
			},
			fields: {
				labels: {
					fields: 'Fields',
					none: 'None',
				},
				actions: {
					addSet: 'Add Custom Fields',
					manageSet: 'Manage Field Set',
					deleteSet: 'Delete Field Set',
				},
				dialogs: {
					delete: {
						title: 'Delete Field Set?',
						body: 'Deleting this set will remove it from every case type that uses it.',
					},
				},
				messages: {
					deleted: 'Field set deleted successfully',
				},
				errors: {
					delete: 'Failed to delete field set',
					deleteUsedByCases:
						'This field set is used by existing cases and cannot be deleted.',
				},
			},
		},
		cfmSettings: {
			common: {
				override: {
					useDefaultValues: 'Use default values',
					overrideDefaultValues: 'Override default values',
				},
				ageRestrictions: {
					title: 'Age Restrictions',
					labels: {
						minimumAge: 'Minimum Age',
						maximumAge: 'Maximum Age',
					},
				},
				idDocumentValidity: {
					title: 'Minimum remaining validity of ID document',
					options: {
						requireMinimumValidity: 'Require minimum validity period',
					},
					labels: {
						minimumMonthsRemaining: 'Minimum months remaining',
					},
					placeholders: {
						select: 'Select',
					},
					months: {
						singular: '{count} month',
						plural: '{count} months',
					},
				},
			},
			globalSettings: {
				labels: {
					defaultLanguage: 'Default Language',
					maxFileSize: 'Max File size',
					termsAndConditionsUrl: 'T&C URL',
					termsAndConditionsDescription: 'T&C Description',
					cfmLinkExpiresInHours: 'CFM Link Expires in Hours',
					supportEmail: 'Support Email',
				},
				placeholders: {
					https: 'https://',
					expireInHours: '24...',
					termsAndConditionsDescription:
						'I declare that I am over 16 years old and I agree to the collection, processing and storing of my personal information by Arritech for the purposes of identity verification and that the information I provide is accurate and true. I understand that I remain responsible in case I provide wrong information or any documents I provide are counterfeits or fake.',
				},
				actions: {
					saveSettings: 'Save Settings',
				},
				validation: {
					minCfmLinkExpiry: 'CFM link expiry should be at least 24 hours',
					minAgeLessThanMaxAge: 'Minimum age must be less than maximum age',
				},
				messages: {
					saved: 'Global settings saved successfully',
				},
				errors: {
					loadCfmConstants: 'Failed to load cfm constants.',
					loadSettings: 'Failed to load cfm global settings.',
					save: 'Global settings can not be saved',
				},
			},
			globalDocuments: {
				sections: {
					documents: 'Documents',
					idRequirements: 'Age & Validity Requirements',
				},
				labels: {
					automated: 'Automated',
					manual: 'Manual',
					unknownCountry: 'Unknown Country',
				},
				documents: {
					identityCard: 'Identity Card',
					passport: 'Passport',
					drivingLicense: 'Driving License',
				},
				pageSides: {
					onlyFront: 'Only Front',
					bothSides: 'Both Sides',
				},
				placeholders: {
					searchCountry: 'Search',
				},
				actions: {
					restoreDefaults: 'Restore Default Configuration',
					restoreSystemDefaults: 'Restore System Default Configuration',
				},
				confirm: {
					resetTitle: 'Restore default configuration?',
					resetMessage:
						'This will overwrite your current Documents configuration with the system default values and save the change immediately.',
					resetSystemTitle: 'Restore system default configuration?',
					resetSystemMessage:
						'This will overwrite the system-wide Documents configuration with the built-in default values and save the change immediately. Every merchant without their own customization will start seeing these values.',
				},
				empty: {
					permissionsRequired:
						'To access this page, appropriate permissions are required.',
				},
				messages: {
					personalizedConfigEnabled:
						'You are now able to configure your own settings.',
					updated: 'Documents updated successfully',
					reset: 'The global documents have been successfully reset.',
					systemReset: 'System has been reset successfully.',
				},
				errors: {
					load: 'Cannot load global documents',
					save: 'Failed to update/create documents.',
					reset: 'Failed to reset global documents. Please try again.',
					resetSystem: 'Failed to reset the system. Please try again.',
				},
			},
			themeCustomizer: {
				labels: {
					palette: 'Palette',
					colorMode: 'Color Mode',
					darkColor: 'Dark Color',
					lightColor: 'Light Color',
					primaryColor: 'Primary Color',
					secondaryColor: 'Secondary Color',
					selectBorderRadius: 'Select Border Radius',
				},
				placeholders: {
					palette: 'Select a palette',
				},
				palettes: {
					standard: 'Standard',
					dark: 'Dark',
					light: 'Light',
					custom: 'Custom',
				},
				colorModes: {
					auto: 'Auto',
					dark: 'Dark',
					light: 'Light',
				},
				borderRadius: {
					square: 'Square',
					small: 'Rounded',
					medium: 'Rounded (Large)',
					large: 'Rounded (Extra Large)',
					shaped: 'Shaped',
				},
				actions: {
					saveStyles: 'Save Styles',
				},
				messages: {
					stylesSaved: 'Styles saved successfully',
				},
				errors: {
					loadTheme: 'Failed to get theme',
					saveStyles: 'Styles could not be saved',
				},
				warnings: {
					darkColorTooLight: 'This color may be too light for a dark color',
					lightColorTooDark: 'This color may be too dark for a light color',
					accentColorContrast:
						'This color may lack contrast on light or dark backgrounds',
				},
				preview: {
					eyebrow: 'Live preview',
					title: 'Select document',
					country: 'Malta',
					status: 'Secure capture ready',
					mobileAction: 'Continue on smartphone',
					mobileDescription: 'Receive a link and finish capture on your phone',
					guidelinesTitle: 'Photo guidelines',
					loaderTitle: 'Preparing your verification journey',
					loaderSubtitle: 'This can take a few seconds',
					buttons: {
						passport: 'Passport',
						idCard: 'ID Card',
						drivingLicense: 'Driving License',
					},
					descriptions: {
						passport: 'Photo page',
						idCard: 'Front and back',
						drivingLicense: 'Front and back',
					},
					instructions: {
						fillArea: 'Fill up the area with your face',
						lookStraight: 'Look straight ahead',
						noSunglasses: 'No sunglasses',
					},
				},
			},
			supportedChecks: {
				common: {
					decisionActions: {
						reject: 'Reject',
						refer: 'Refer',
						approve: 'Approve',
					},
					messages: {
						checkSaved: 'Check saved successfully',
					},
					errors: {
						checkSave: 'Check can not be saved',
					},
				},
				list: {
					title: 'Supported Checks',
					empty: {
						noChecks: 'No check type found',
					},
					dialogs: {
						delete: {
							title: 'Delete!',
							body: 'Are you sure you want to delete the check?',
						},
					},
					messages: {
						deleted: 'Check deleted successfully.',
					},
					errors: {
						delete: 'Failed to delete the check.',
					},
				},
				detail: {
					labels: {
						checkName: 'Check Name',
						checkType: 'Check Type',
					},
					errors: {
						loadCheck: 'Failed to check.',
					},
				},
				selfie: {
					labels: {
						offerMobileContinuation: 'Offer mobile continuation on desktop',
					},
					blocks: {
						faceMatch: 'Document vs face match',
						liveness: 'Liveness confidence',
					},
					descriptions: {
						faceMatch:
							'Decide the outcome by how closely the selfie matches the face on the identity document.',
						liveness:
							'Decide the outcome by the confidence that the selfie is a live person.',
					},
					tiers: {
						high: 'High confidence',
						medium: 'Medium confidence',
						low: 'Low confidence',
					},
					messages: {
						saved: 'Selfie settings saved successfully',
					},
					errors: {
						save: 'Selfie settings can not be saved',
					},
				},
				smsCheck: {
					labels: {
						numberOfRetries: 'Number of Retries',
						allowOverridingEntityNumber: 'Allow Overriding Entity Number',
					},
					placeholders: {
						numberOfRetries: 'Number of retries',
					},
					tooltips: {
						allowOverridingEntityNumber:
							'When enabled, the user can submit a phone number different from the one on the entity record. The verified number replaces the entity’s on successful SMS verification.',
					},
					actions: {
						save: 'Save SMS Check',
					},
					messages: {
						saved: 'SMS settings saved successfully',
					},
					errors: {
						save: 'SMS settings can not be saved',
					},
				},
				basicForm: {
					labels: {
						override: 'Override Entity Fields',
					},
					tooltips: {
						override:
							'When enabled, the submitted form values will override the entity fields directly. When disabled, a reviewer can edit the submitted values before applying them.',
					},
					actions: {
						save: 'Save Basic Form',
					},
					messages: {
						saved: 'Basic Form settings saved successfully',
					},
					errors: {
						save: 'Basic Form settings can not be saved',
					},
				},
				amlScreening: {
					labels: {
						fuzzinessLevel: 'Fuzziness Level',
						monitoring: 'Ongoing Monitoring',
						onExactMatch: 'On Exact Match',
						onPotentialMatch: 'On Potential Match',
					},
					placeholders: {
						fuzzinessLevel: 'Select fuzziness level',
						action: 'Select action',
					},
					tooltips: {
						monitoring:
							'Ongoing AML monitoring re-screens customers against updated watchlists and flags new matches. Renewal fee charged at 12 months if still enabled.',
					},
					decisionActions: {
						reject: 'Reject',
						refer: 'Refer',
						approve: 'Approve',
					},
					actions: {
						save: 'Save AML Screening',
					},
					messages: {
						saved: 'AML Settings saved successfully',
					},
					errors: {
						save: 'AML Settings can not be saved',
					},
				},
				proofOfAddress: {
					blocks: {
						crossCheck: 'Cross-check and extraction',
						genuineness: 'Genuineness check',
						issuerLegitimacy: 'Issuer legitimacy check',
						issueValidity: 'Document issue validity',
					},
					descriptions: {
						crossCheck:
							'Always extract proof of address fields and compare the name and address against the entity.',
						genuineness:
							'Analyze document metadata, signatures, and editing signals for fraud indicators.',
						issuerLegitimacy:
							'Check whether the issuer exists online and whether the issuer address is credible.',
						issueValidity:
							'Reject or refer proof of address documents issued more than the configured time ago.',
					},
					rules: {
						nameCrossCheck: 'Name cross-check',
						addressCrossCheck: 'Address cross-check',
						extractions: 'Extractions',
						genuineness: 'Genuineness',
						issuerLegitimacy: 'Issuer legitimacy',
					},
					tiers: {
						high: 'High confidence',
						medium: 'Medium confidence',
						low: 'Low confidence',
					},
					decisions: {
						approved: 'Approved',
						referred: 'Referred',
						rejected: 'Rejected',
					},
					issueValidity: {
						thresholdLabel: 'Maximum document age',
						thresholdError: 'Enter a whole number between 1 and {max}.',
						unitLabel: 'Unit',
						outcomeLabel: 'Outcome when older than the threshold',
						units: {
							months: 'Months',
							days: 'Days',
						},
					},
					actions: {
						save: 'Save proof of address',
					},
					messages: {
						saved: 'Proof of address settings saved successfully.',
					},
					errors: {
						save: 'Proof of address settings can not be saved.',
					},
				},
				identityDocuments: {
					labels: {
						supportedDocuments: 'Supported documents',
						supportedCountries: 'Supported Countries',
						onOutcome: 'Automated verification during capture',
						maxAttempts: 'Maximum Attempts',
						offerMobileContinuation: 'Offer mobile continuation on desktop',
						allowUpload: 'Allow Upload',
						overrideEntityDetails: 'Override Entity Details from Document',
						crossCheckingFields: 'Cross-checking Fields',
						crossCheckFieldToValidate: 'Field to Validate',
						crossCheckReferenceField: 'Reference Field',
						crossCheckRejectIfNull: 'Reject if null',
					},
					placeholders: {
						selectDocuments: 'Select documents',
						selectCountries: 'Select countrie(s)',
						maxAttempts: 'Maximum Attempts',
					},
					outcomes: {
						rejectOnFail: {
							label: 'Reject after failed attempts',
							description:
								'The document is verified automatically while it is captured. If every attempt fails, the session is rejected.',
						},
						referOnFail: {
							label: 'Continue manually after failed attempts',
							description:
								'The document is verified automatically while it is captured. If every attempt fails, the user continues with a manual upload and the document is evaluated afterwards.',
						},
						alwaysRefer: {
							label: 'No automated check during capture',
							description:
								'The document is uploaded without being verified while it is captured, and is evaluated by the verification rules afterwards.',
						},
					},
					tooltips: {
						maxAttempts:
							'Total number of automated verification attempts a user gets, including the first one.',
						maxAttemptsLocked:
							'A single attempt applies when there is no automated check during capture.',
						overrideEntityDetails:
							"When enabled, data extracted from a successfully verified document (e.g. name, DOB, address) updates the Case Details. Cross-checking will be disabled as the user's document values become the source of truth. Any AML Screening or Form step must follow this ID check in the flow.",
						overrideEntityDetailsLocked:
							'Overriding entity details needs an automated check during capture.',
						crossCheckingDisabledByOverride:
							'Cross-checking is disabled while Override Entity Details from Document is on — the document values are treated as the source of truth.',
					},
					crossChecking: {
						fields: {
							names: 'Names',
							gender: 'Gender',
							dateOfBirth: 'Date of Birth',
							nationality: 'Nationality',
							countryOfResidence: 'Country of Residence',
						},
						options: {
							rejectIfMismatch: 'Reject If Mismatch',
							referIfMismatch: 'Refer If Mismatch',
							ignoreCheck: 'Ignore Check',
						},
					},
					actions: {
						save: 'Save Identity Documents',
					},
					validation: {
						crossCheckingRequired:
							'You must enable at least one cross-checking field with an active verification setting. Please review your configuration.',
					},
					messages: {
						saved: 'Identity documents saved successfully',
					},
					errors: {
						loadGlobalSettings: 'Failed to load global settings.',
						save: 'Identity documents can not be saved',
					},
				},
				uploadDocument: {
					labels: {
						offerMobileContinuation: 'Offer mobile continuation on desktop',
						pageTitle: 'Page Title',
						documentLabel: 'Document {number}',
						helpText: 'Help Text',
						allowedFileTypes: 'Allowed File Types',
						required: 'Required',
						namedDocumentsTitle: 'Named Documents',
						namedDocumentsDescription:
							'Request specific documents by name. The client sees a labelled upload slot for each one.',
						noNamedDocuments: 'No named documents added yet.',
						openUploadTitle: 'Open Upload',
						openUploadEnable: 'Allow the client to upload additional files',
						openUploadHint:
							'The client can add as many extra files as they need, with no fixed limit and no document names required.',
						openUploadLabel: 'Instruction for the client (optional)',
						openUploadLabelPlaceholder:
							'e.g. Please upload any supporting documents',
					},
					placeholders: {
						selectDocuments: 'Select Documents',
					},
					actions: {
						addDocument: 'Add Document',
						clearAllDocuments: 'Clear All Documents',
						createDocumentCheck: 'Create Document Check',
						updateDocumentCheck: 'Update Document Check',
					},
					validation: {
						requireAtLeastOneDocument:
							'Add at least one required named document or enable open upload before saving.',
						maxFilesRequired:
							'Set a maximum number of files (at least 1) for documents that allow multiple files',
					},
				},
				form: {
					common: {
						labels: {
							label: 'Label',
							description: 'Description',
						},
					},
					select: {
						labels: {
							form: 'Select Form',
							mediumRisk: 'Medium Risk',
							highRisk: 'High Risk',
							hasRedFlags: 'Has Red Flags',
							allowMobileContinuation: 'Allow mobile continuation',
							showLiveScore: 'Show live score during form completion',
						},
						placeholders: {
							form: 'Select an existing form',
							action: 'Select action',
						},
						actions: {
							addNew: 'Add New',
						},
						hints: {
							severityOrder:
								'The most severe outcome will be applied. Severity order: Approve < Refer < Reject.',
						},
						errors: {
							loadForms: 'Failed to load forms.',
						},
					},
					builder: {
						sections: {
							formSections: 'Sections',
							riskScoring: 'Risk Scoring',
						},
						labels: {
							type: 'Type',
							formTitle: 'Form Title',
							formDescription: 'Form Description',
							redFlags: 'Red Flags',
							lowRiskThreshold: 'Low Risk (score less than or equal to)',
							highRiskThreshold: 'High Risk (score greater than or equal to)',
							maxPossibleScore: 'Max possible score: {score}',
						},
						types: {
							riskAssessment: 'Risk Assessment',
							questionnaire: 'Questionnaire',
						},
						placeholders: {
							formTitle: 'Enter form title',
							formDescription: 'Enter form description',
							redFlags: 'Type flag name and press Enter',
							lowRiskExample: 'e.g., 100',
							highRiskExample: 'e.g., 500',
						},
						tooltips: {
							redFlags:
								'A Red Flag marks a submission when a specific answer is given, regardless of score. Define your flags here, then assign them to rules on individual questions — so multiple questions can all trigger the same flag.',
						},
						actions: {
							addQuestion: 'Add Question',
							addSection: 'Add Section',
							createForm: 'Create Form',
							updateForm: 'Update Form',
							export: 'Export',
						},
						scoringGrid: {
							headers: {
								section: 'Section',
								weight: 'Weight (%)',
								lowRisk: 'Low Risk (<=)',
								highRisk: 'High Risk (>=)',
							},
							untitledSection: 'Untitled Section',
							totalWeight: 'Total Weight: {total}%',
						},
						dialogs: {
							switchToQuestionnaire: {
								title: 'Switch to Questionnaire?',
								message:
									'Switching to Questionnaire will permanently remove all scoring rules, red flags, and thresholds configured for this template. This cannot be undone. Are you sure you want to continue?',
							},
							removeSection: {
								title: 'Confirm',
								body: 'Are you sure you want to remove this section?',
								bodyWithQuestions:
									'Are you sure you want to remove this section? It contains {count} question(s) that will be deleted.',
								confirm: 'Remove',
							},
							removeFlag: {
								title: 'Confirm',
								message:
									'Removing flag "{flag}" will delete {count} rule(s) across your questions.',
								confirm: 'Remove',
							},
						},
						validation: {
							formTitleRequired: 'Form title is required',
							atLeastOneSection: 'At least one section is required',
							weightsMustSumTo100: 'Section weights must sum to 100%',
							sectionTitleRequired: 'Section title is required',
							lowRiskRequiredWhenScoring:
								'Low Risk is required when scoring rules exist',
							lowRiskLessThanHighRisk: 'Low Risk must be less than High Risk',
							highRiskRequiredWhenScoring:
								'High Risk is required when scoring rules exist',
							highRiskMaxPossibleScore:
								'High Risk ({highRisk}) cannot exceed max possible score ({maxPossibleScore})',
							highRiskMaxSectionScore: 'Cannot exceed max score ({maxScore})',
							atLeastOneQuestion: 'At least one question is required',
							questionTextRequired: 'Question text is required',
							questionTypeRequired: 'Question type is required',
							atLeastOneOption: 'At least one option is required',
							optionCannotBeEmpty: 'Option {number} cannot be empty',
							duplicateOptions: 'Duplicate options are not allowed',
							referencesMissingQuestion: 'References non-existent question',
							singleRunningEntity:
								'Only one Auto Fill question can overwrite the running entity per entity type',
							flagSingleWord: 'Flag must be a single word (no spaces)',
							flagAlreadyExists: 'Flag already exists',
						},
						messages: {
							saved: 'Form saved successfully',
							created: 'Form created successfully',
							templateLocked: 'This template is locked and cannot be edited.',
							viewOnlyRoute:
								'View only — open this template from the list to make changes.',
						},
						errors: {
							generic: 'An error occurred',
							save: 'Failed to save form.',
							fixValidation: 'Please fix the validation errors',
						},
					},
					booleanQuestion: {
						headers: {
							yesOption: 'Yes - Option',
							noOption: 'No - Option',
						},
						placeholders: {
							yesLabel: 'Yes label',
							yesDescription: 'Yes description',
							noLabel: 'No label',
							noDescription: 'No description',
						},
						defaults: {
							yes: 'Yes',
							no: 'No',
						},
					},
					choiceQuestion: {
						placeholders: {
							option: 'Option',
							newOption: 'New option',
						},
						errors: {
							duplicateOption: 'Duplicate option',
						},
						actions: {
							addOption: 'Add Option',
						},
					},
					valueInput: {
						labels: {
							value: 'Value',
							from: 'From',
							to: 'to',
						},
						placeholders: {
							startDate: 'Start date',
							endDate: 'End date',
							selectDate: 'Select date',
							selectValues: 'Select values',
							selectValue: 'Select value',
							min: 'Min',
							max: 'Max',
							enterNumber: 'Enter number',
							enterValue: 'Enter value',
							selectOperatorFirst: 'Select operator first',
						},
					},
					extractionIssues: {
						labels: {
							suggestion: 'Suggestion',
						},
						actions: {
							dismiss: 'Dismiss',
						},
						types: {
							complexStructure: 'Complex Structure',
							missingInformation: 'Missing Information',
							uncertainFieldType: 'Uncertain Field Type',
							unclearOptions: 'Unclear Options',
						},
					},
					importDetails: {
						title: 'Import Details',
						labels: {
							issues: 'Extraction issues',
							successRate: 'Success rate: {rate}%',
						},
						actions: {
							neverShowAgain: 'Never show me this again',
						},
						dialog: {
							title: 'Hide import details?',
							message:
								'This will permanently hide the AI import details for this template. This cannot be undone. Are you sure?',
							confirm: 'Hide permanently',
							cancel: 'Cancel',
						},
						messages: {
							dismissed: 'Import details hidden',
						},
					},
					advancedOptions: {
						sections: {
							scoringRules: 'Scoring Rules',
							conditionalLogic: 'Conditional Logic',
							redFlags: 'Red Flags',
						},
						tooltips: {
							scoringRulesHelp:
								'If multiple scoring rules match, the one with the highest score will be applied.',
							conditionalLogicHelp:
								'This will apply if any of the conditions are matched.',
							redFlagsHelp:
								'Flag rules trigger red flags when conditions are met. Multiple rules can trigger simultaneously.',
						},
					},
					section: {
						defaults: {
							untitledSection: 'Untitled Section',
						},
						dialogs: {
							removeQuestion: {
								title: 'Confirm',
								body: 'Are you sure you want to remove this question?',
								bodyWithRelated:
									'Are you sure you want to remove this question?\n\nThe following questions have conditional logic related to this question that will be updated:\n{questionListItems}',
								confirm: 'Remove',
							},
							reorder: {
								title: 'Confirm Reorder',
								message:
									'This reorder will remove conditional logic from the following questions:\n{questionListItems}',
								confirm: 'Reorder',
							},
						},
						labels: {
							repeatable: 'Repeatable',
						},
						tooltips: {
							repeatableRiskAssessment:
								"Lets the respondent submit multiple copies of this section. Only the highest-scoring copy counts toward the overall Risk Level — other copies won't add to or lower it.",
							repeatableQuestionnaire:
								'Lets the respondent submit multiple copies of this section.',
						},
						placeholders: {
							sectionTitle: 'Enter section title',
							sectionDescription: 'Optional section description',
						},
						actions: {
							removeSection: 'Remove section',
						},
						summary: {
							questions: '{count} question | {count} questions',
							weight: 'Weight: {weight}%',
							lowRisk: 'Low Risk: <= {value}',
							highRisk: 'High Risk: >= {value}',
							maxScore: 'Max Score: {score}',
						},
					},
					question: {
						headers: {
							active: 'QUESTION {number}',
							compact: 'Q{number}{suffix}',
						},
						summary: {
							scoringRules: 'Scoring Rules: {count}',
							redFlags: 'Red Flags: {count}',
							conditionals: 'Conditionals',
						},
					},
					conditionalLogic: {
						tab: {
							validation: {
								questionRequired: 'Please select a question first',
								duplicateCondition: 'This condition already exists',
							},
							labels: {
								operator: 'Operator',
							},
							placeholders: {
								operator: 'Operator',
								selectQuestionFirst: 'Select question first',
							},
							actions: {
								addCondition: 'Add Condition',
								showQuestionWhenToggle:
									'Show this question when (click to toggle)',
								hideQuestionWhenToggle:
									'Hide this question when (click to toggle)',
							},
						},
						modal: {
							placeholders: {
								question: 'Select question',
							},
							validation: {
								atLeastOneValue: 'At least one value is required',
							},
						},
					},
					redFlagRules: {
						tab: {
							validation: {
								duplicateRule: 'Duplicate rule already exists',
							},
							labels: {
								operator: 'Operator',
								flag: 'Flag',
							},
							placeholders: {
								operator: 'Operator',
								flag: 'Flag',
							},
							actions: {
								addRule: 'Add Rule',
							},
						},
					},
					scoringRules: {
						tab: {
							validation: {
								duplicateValue: 'Rule for this value already exists',
							},
							labels: {
								operator: 'Operator',
								score: 'Score',
							},
							placeholders: {
								operator: 'Operator',
								score: '+/-',
							},
							actions: {
								addRule: 'Add Rule',
							},
						},
						question: {
							labels: {
								questionText: 'Question Text',
								questionType: 'Question Type',
								minSelections: 'Min Selections',
								maxSelections: 'Max Selections',
								placeholder: 'Placeholder',
								allowPastDates: 'Allow Past Dates',
							},
							placeholders: {
								questionText: 'Enter your question',
								description: 'Optional description or help text',
								questionType: 'Select type',
								placeholder: 'Enter placeholder text',
							},
							types: {
								text: 'Text',
								number: 'Number',
								date: 'Date',
								boolean: 'Yes / No',
								singleChoice: 'Single Choice',
								multipleChoice: 'Multiple Choice',
								country: 'Country',
								signature: 'Signature',
								entityAutofill: 'Auto Fill Entity Details',
							},
							entityAutofill: {
								info: 'This question collects a person or company’s details and saves them onto the case entity when the flow is completed. It only runs inside a CFM flow and cannot be used in a standalone form.',
								entityTypeLabel: 'Entity type',
								entityTargetLabel: 'Entity target',
								allowMultipleLabel: 'Allow Multiple',
								allowMultipleTrue: 'True',
								allowMultipleFalse: 'False',
								allowMultipleDisabled:
									'Available only when the entity target is “New entity” — a running entity is always a single entity.',
								hint: '“Update running entity” saves the collected details onto the entity already going through this flow. “Allow Multiple” lets the applicant add more than one entity, and is available only with the “New entity” target.',
								person: 'Person',
								company: 'Company',
								running: 'Update running entity',
								new: 'New entity',
							},
							actions: {
								addQuestionBefore: 'Add Question Before',
								addQuestionAfter: 'Add Question After',
							},
							tooltips: {
								removeQuestion: 'Remove question',
							},
							dialogs: {
								changeType: {
									title: 'Confirm',
									confirm: 'Change',
									body: 'Are you sure you want to change the question type?<br>{warnings}',
									warningScoringRules:
										'This question has <strong>{count}</strong> scoring rule(s) that will be deleted.',
									warningRedFlagRules:
										'This question has <strong>{count}</strong> flag rule(s) that will be deleted.',
									warningConditionalLogic:
										'The following questions have conditional logic related to this question that will be deleted:<ul>{questionListItems}</ul>',
								},
							},
							errors: {
								maxSelectionsAtLeastOne: 'Max selections must be at least 1.',
							},
						},
					},
				},
			},
			riskLevels: {
				list: {
					title: 'Risk Levels',
					columns: {
						caseTypes: 'Case Types',
						steps: 'Steps',
					},
					tooltips: {
						duplicate: 'Duplicate risk level',
					},
					empty: {
						noRiskLevels: 'No risk level found',
					},
					dialogs: {
						delete: {
							body: 'Are you sure you want to delete the risk Level?',
						},
					},
					messages: {
						deleted: 'Risk level deleted successfully.',
						duplicated: 'Risk level duplicated successfully.',
					},
					errors: {
						delete: 'Failed to delete the risk level.',
						duplicate: 'Failed to duplicate the risk level.',
						loadChecks: 'Failed to load checks.',
						loadCaseTypes: 'Failed to load case types',
						loadCfmConstants: 'Failed to load cfm constants.',
						loadRiskLevels: 'Failed to load risk levels.',
					},
				},
				detail: {
					stepTitle: 'Step {number}',
					labels: {
						riskLevelName: 'Risk Level Name',
						riskLevelId: 'Risk Level ID',
						description: 'Description',
						caseType: 'Case Type',
						caseTypeNone: 'None',
						entityType: 'Entity Type',
						entityTypes: {
							person: 'Person',
							company: 'Company',
						},
						steps: 'Steps',
						geographicalAccessControl: 'Geographical Access Control',
						returnUrl: 'Return URL',
						termsAcceptedRequired: 'Terms Accepted Required',
						termsVersion: 'Terms version',
						blockedCountries: 'Blocked countries',
						allowedCountries: 'Allowed countries',
					},
					geoModes: {
						allowAll: 'Allow from all countries',
						allowSpecific: 'Allow from specific countries only',
						blockSpecific: 'Block specific countries',
					},
					placeholders: {
						riskLevelName: 'Enter risk level name',
						description: 'Enter description',
						caseTypes: 'Select case types',
						returnUrl: 'Enter a valid URL',
						check: 'Select a check',
						blockedCountries: 'Select countries to block',
						allowedCountries: 'Select countries to allow',
					},
					actions: {
						goToSelectedCheck: 'Go to Selected Check',
						reorderStep: 'Reorder step {number}',
						addStep: 'Add Step',
						removeStep: 'Remove Step',
						clearAllSteps: 'Clear All Steps',
						createRiskLevel: 'Create Risk Level',
						updateRiskLevel: 'Update Risk Level',
					},
					hints: {
						reorderSteps: 'Drag steps to change the order before saving.',
						caseType:
							"CaseType is only needed if you're going to initiate a session via the Integration API. Once set, it cannot be changed.",
					},
					empty: {
						noSteps: 'No steps configured.',
					},
					validation: {
						selectCheckFirst:
							'Please select a check for the current step before adding a new one',
						returnUrl: 'Requires valid URL',
						termsVersion: 'Requires a terms version',
						autoFillAmlScreeningOrder:
							'AML Screening must come after the Identity step because it has Override Entity Details from Document enabled.',
						autoFillFormOrder:
							'Form must come after the Identity step because it has Override Entity Details from Document enabled.',
						sourceOfTruthOrder:
							'The {stepType} step must come after the {sourceType} step.',
						disallowedChecks:
							'{entityType} risk levels cannot include the following check types: {checks}. Remove them before saving.',
					},
					messages: {
						created: 'Risk level created successfully.',
						updated: 'Risk level updated successfully.',
					},
					errors: {
						create: 'Failed to create risk level.',
						update: 'Failed to update risk level.',
						loadRiskLevel: 'Failed to load risk level.',
					},
				},
			},
		},
		archive: {
			title: 'Archive',
			tabs: {
				snapshots: 'Snapshots',
				merchantRemoval: 'Merchant removal',
			},
			common: {
				columns: {
					requesterEmail: 'Requester Email',
					requesterName: 'Requester Name',
					hardDelete: 'Hard Delete',
					completed: 'Completed',
					totalCollected: 'Total Collected',
					totalDeleted: 'Total Deleted',
				},
				empty: {
					noRequests: 'No archive requests found',
				},
			},
			history: {
				actions: {
					createSnapshot: 'Create Snapshot',
					createSnapshotTooltip:
						'This will take a snapshot of all your merchant data across our services.',
					confirmCreate: 'Yes, Create',
				},
				dialogs: {
					snapshotConfirm: {
						title: 'Confirmation',
						body: 'Are you sure you want to create a new snapshot? This can take up to 3 hours to complete.',
					},
				},
				alerts: {
					snapshotStarted: {
						title: 'Info',
						body: 'Snapshot capture process is initiated and it might take up to 3 hours. Once finished, you will be notified via an email including the zip password and download link.',
					},
				},
			},
			merchantRemoval: {
				actions: {
					removeMerchant: 'Remove Merchant',
				},
				columns: {
					merchantName: 'Merchant Name',
				},
				dialogs: {
					removeMerchant: {
						title: 'Remove Merchant',
						warning: 'Warning! This operation is irreversible!!!',
						instructions:
							'All data related with the selected merchant will be removed permanently. Please type <strong>permanently delete</strong> in the text box below to initiate the delete process.',
						selectLabel: 'Select a Merchant to Delete',
						selectPlaceholder: 'Choose Merchant',
						confirmLabel: "Type 'permanently delete' to confirm",
						confirmPlaceholder: 'permanently delete',
						confirmPhrase: 'permanently delete',
					},
				},
				validation: {
					selectMerchantRequired: 'Please select a merchant!',
					confirmPhraseMismatch:
						'You must type "permanently delete" to confirm.',
				},
				messages: {
					removalInProgress:
						'The removal is in progress you will be notified when completed by email',
				},
				errors: {
					deleteMerchant: 'Error deleting merchant',
				},
			},
		},
		triggerSettings: {
			common: {
				breadcrumbs: {
					triggers: 'Triggers',
					history: 'History',
				},
				placeholders: {
					required: 'required',
				},
				columns: {
					segment: 'Segment',
					operator: 'Operator',
					value: 'Value',
				},
				status: {
					enabled: 'Enabled',
					disabled: 'Disabled',
				},
				tooltips: {
					deleteTrigger: 'Delete trigger',
				},
				empty: {
					noTriggers: 'No trigger found',
				},
				dialogs: {
					updateStatus: {
						title: 'Update!',
						body: 'Are you sure you want to update the status?',
					},
					deleteTrigger: {
						title: 'Delete!',
						body: 'Are you sure you want to delete the trigger?',
					},
				},
				messages: {
					statusUpdated: 'Trigger status updated successfully.',
					deleted: 'Trigger deleted successfully.',
				},
				errors: {
					updateTriggerStatus: 'Failed to update trigger status.',
					deleteTrigger: 'Failed to delete the Trigger.',
					loadTriggers: 'Failed to load triggers.',
				},
			},
			triggers: {
				title: 'Triggers',
			},
			createTrigger: {
				title: 'Create Trigger',
				actions: {
					submit: 'Submit',
				},
				wizard: {
					step1: '1. Create Trigger',
					step2: '2. Linked Template',
				},
				messages: {
					created: 'Trigger event created successfully.',
				},
				errors: {
					create: 'Failed to create trigger event.',
				},
			},
			createTriggerStep: {
				messages: {
					created: 'Trigger created successfully',
				},
				errors: {
					create: 'Failed to create trigger.',
				},
			},
			createScheduled: {
				labels: {
					triggerName: 'Trigger Name',
					merchant: 'Merchant',
				},
				errors: {
					loadSegments: 'Failed to load segments.',
					loadSegmentConstants: 'Failed to load segment constants.',
					loadCaseStatus: 'Failed to load case status',
				},
			},
			details: {
				title: 'Trigger Details',
				labels: {
					triggerType: 'Trigger Type',
					triggerValue: 'Trigger Value',
				},
				placeholders: {
					selectMerchant: 'Select merchant',
				},
				actions: {
					updateTrigger: 'Update Trigger',
				},
				messages: {
					updated: 'Trigger updated successfully.',
				},
				errors: {
					invalidTriggerValue: 'Not a valid trigger value',
					updateTrigger: 'Failed to update trigger.',
					loadDetails: 'Failed to load trigger details.',
				},
			},
			eventList: {
				title: 'Trigger Events',
				columns: {
					templateId: 'Template ID',
					eventType: 'Event Type',
					receivers: 'Receivers',
				},
				actions: {
					addTriggerEvent: 'Add Trigger Event',
				},
				tooltips: {
					deleteEvent: 'Delete event',
				},
				empty: {
					noEvents: 'No event found',
				},
				dialogs: {
					deleteEvent: {
						title: 'Delete!',
						body: 'Are you sure you want to delete the event?',
					},
				},
				messages: {
					created: 'Trigger event created successfully.',
					updated: 'Trigger event updated successfully.',
					deleted: 'Event deleted successfully.',
				},
				errors: {
					create: 'Failed to create trigger event.',
					update: 'Failed to update trigger event.',
					delete: 'Failed to delete the event.',
				},
			},
			eventEditor: {
				title: 'Event Details',
				labels: {
					channel: 'Channel',
					audience: 'Audience',
					templateFields: 'Template fields: ',
				},
				placeholders: {
					selectChannel: 'Select channel',
					selectAudience: 'Select audience',
				},
				actions: {
					addEvent: 'Add Event',
					updateEvent: 'Update Event',
				},
			},
			linkedTemplateStep: {
				labels: {
					merchantPrefix: 'Merchant: ',
					segmentPrefix: 'Segment: ',
				},
			},
			conditions: {
				messages: {
					linkedFields: 'Fields linked to the segment: {fields}',
				},
			},
		},
		templateSettings: {
			common: {
				breadcrumbs: {
					template: 'Template',
					history: 'History',
					details: 'Details',
				},
			},
			history: {
				title: 'Templates',
				columns: {
					relatedFields: 'Related Fields',
				},
				empty: {
					noTemplates: 'No previous templates found',
				},
				errors: {
					loadTemplates: 'Failed to load templates.',
				},
			},
			details: {
				title: 'Template Details',
				idPrefix: 'ID:',
				labels: {
					eventType: 'Event Type',
					templateType: 'Template Type',
					templateFields: 'Template fields',
					createdBy: 'Created By',
					createdOn: 'Created On',
					maxLength: 'Max length',
					remaining: 'Remaining',
				},
				placeholders: {
					required: 'required',
				},
				errors: {
					nameRequired: 'Name is required.',
					titleRequired: 'Title is required.',
					contentRequired: 'Content is required.',
					generatePreview: 'Failed to generate preview. Please try again.',
					sendTestEmail: 'Failed to send test email',
					sendTestEmailRetry: 'Failed to send test email. Please try again.',
					testEmailUnavailable:
						'Test email feature is not yet available. Please contact support.',
					testEmailPermission:
						'You do not have permission to send test emails.',
					updateTemplate: 'Failed to update template.',
					updateTemplateRetry: 'Failed to update template. Please try again.',
					loadTemplateDetails: 'Failed to load template details.',
				},
				messages: {
					testEmailSent: 'Test email sent successfully!',
					templateUpdated: 'Updated template successfully.',
					contentLimitExceeded:
						'Template content limit exceeded in {count} characters.',
				},
				actions: {
					switchToEditor: 'Switch to Editor',
					editHtml: 'Edit HTML',
					preview: 'Preview',
					test: 'Test',
					sending: 'Sending...',
				},
				htmlMode: {
					warningTitle: 'Warning',
					warningBody:
						'You are editing raw HTML. Incorrect syntax may break the template. Use with caution.',
					confirmTitle: 'Confirm HTML Update',
					confirmDialogWarning: 'You are updating a template in HTML mode.',
					confirmDialogEnsure: 'Please ensure:',
					checkSyntax: 'The HTML syntax is correct',
					checkFields: 'All template fields are properly formatted',
					checkRendering: 'The content renders correctly in email clients',
					breakWarning: 'Incorrect HTML may break the template for all users.',
					confirmButton: 'Yes, Update Template',
				},
				previewModal: {
					title: 'Template Preview',
				},
				defaultEmailTitle: 'Email Template',
			},
		},
		notificationsSettings: {
			title: 'Notifications',
			tabs: {
				configuration: 'Configuration',
				customization: 'Customization',
			},
			customization: {
				title: 'Customizable notifications',
				intro:
					'These are the messages sent to your customers in your name, so their wording is yours to change.',
				empty: 'No notification is customizable yet.',
				loadFailed: 'Failed to load the notification catalog.',
				template: 'Template',
				open: 'View template',
				openOn: 'View {channel} template',
				previewFrameTitle: 'Rendered preview of {notification}',
				previewFailed: 'Failed to render the preview.',
				subject: 'Subject',
				titleField: 'Title',
			},
		},
		logsSettings: {
			title: 'Logs',
			tabs: {
				system: 'System',
				webhooks: 'Webhooks',
			},
		},
	},
	userManagement: {
		common: {
			breadcrumbs: {
				userManagement: 'User Management',
				users: 'Members',
				roles: 'Roles',
				newUser: 'New Member',
				newRole: 'New Role',
				editRole: 'Edit Role',
				userProfile: 'User Profile',
			},
			titles: {
				users: 'Members',
				roles: 'Roles',
				permissions: 'Permissions',
			},
			labels: {
				surname: 'Surname',
				roles: 'Roles',
				isBlocked: 'Blocked',
				lastLogin: 'Last Login',
				twoFactorShort: 'MFA',
				systemRoles: 'System Roles',
				phoneNumber: 'Phone Number',
				designation: 'Description',
				createdAt: 'Created At',
				roleId: 'Role ID:',
				lastLoginAt: 'Last Login At',
			},
			placeholders: {
				enterPhoneNumber: 'Enter the phone number',
				roles: 'Select one or more roles',
				systemRoles: 'Select one or more system roles',
			},
			actions: {
				addNewUser: 'Add New Member',
				addNewRole: 'Add New Role',
				addUser: 'Add Member',
				update: 'Update',
				deleteRole: 'Delete Role',
			},
			tooltips: {
				addNewRole: 'Add new role',
			},
			chips: {
				blocked: 'Blocked',
				app: 'App',
			},
			empty: {},
			dialogs: {
				errorTitle: 'Error!',
				deleteTitle: 'Delete!',
			},
			messages: {
				invalidPhoneNumber: 'Invalid phone number',
			},
			errors: {
				loadRoles: 'Failed to load roles.',
				loadUsers: 'Failed to load users.',
				addUser: 'Failed to add member.',
				updateUser: 'Failed to update user.',
				updateGeneric: 'Failed to update.',
				loadNotifications: 'Failed to load notifications.',
				deleteUser: 'Failed to delete user',
				loadUser: 'Failed to load user.',
			},
		},
		users: {
			table: {
				name: 'Name',
				surname: 'Surname',
				noRows: 'No users found',
				primaryOwnerTooltip:
					'This member is the primary owner of the workspace.',
			},
			form: {
				title: 'New Member',
				requiredPlaceholder: 'required',
				addSuccess: 'Member added successfully',
				loadRolesError: 'Failed to load roles',
			},
			details: {
				noMatchesFound: 'No matches found',
				userUpdatedSuccess: 'User updated successfully',
				updatedSuccess: 'Successfully updated',
				userDeletedSuccess: 'User deleted successfully',
			},
			profile: {
				permissions: {
					systemClaimsHeading: 'System Claims',
					systemClaims: {
						root: 'Root',
						agent: 'Agent',
						serviceManagement: 'Service Management',
						twoFALogin: 'MFA Login',
						twoFASetup: 'MFA Setup',
					},
					moduleAccessHeading: 'Module Access',
				},
				sections: {
					personalDetails: 'Personal details',
					security: 'Security',
					userActivity: 'User activity',
					notifications: 'Notifications',
					formatPreferences: 'Format Preferences',
				},
				headings: {
					currentSession: 'Current Session',
					lastEntries: 'Last Entries',
				},
				labels: {
					firstName: 'First Name',
					lastName: 'Last Name',
					phone: 'Phone',
					passwordLastChanged: 'Password Last Changed',
					twoFactorAuthentication: 'MFA Authentication',
					timeZone: 'Time Zone',
					dateFormat: 'Date Format',
					clockFormat: 'Clock Format',
					nameFormat: 'Name Format',
					colorMode: 'Color Mode',
					splitView: 'Split View',
					newEmail: 'New email',
					city: 'City',
					country: 'Country',
					timezone: 'Timezone',
					ipAddress: 'IP address',
					deviceInfo: 'Device info',
					createdAt: 'Created at',
					failedLoginAttempt: 'Failed login attempt',
				},
				placeholders: {
					timeZone: 'Time Zone',
				},
				values: {
					noInfo: 'No info',
					never: 'Never',
					noFailedLoginAttemptRecorded: 'No failed login attempt was recorded',
					root: 'Root',
					browserDefault: 'Browser Default',
					light: 'Light',
					dark: 'Dark',
					enabled: 'Enabled',
					disabled: 'Disabled',
				},
				actions: {
					enableMfaMandatory: 'Enable Organisation MFA',
					disableMfaMandatory: 'Disable Organisation MFA',
					enable: 'Enable',
					disable: 'Disable',
					changePassword: 'Change Password',
					setup2fa: 'Setup MFA',
					edit2faSettings: 'Edit MFA Settings',
					changeEmail: 'Change email',
					sendVerificationLink: 'Send verification link',
					sendAgain: 'Send again',
				},
				dialogs: {
					changePasswordTitle: 'Change password',
					changeEmailTitle: 'Change email',
					changeEmailIntro:
						'We will send a confirmation link to the new address. Your sign-in email changes only after you follow it, and you will be asked to sign in again with the new address.',
					setup2faTitle: 'Setup MFA',
					edit2faTitle: 'Edit MFA Settings',
					deleteUserTitle: 'Delete!',
					deleteUserBody: 'Are you sure you want to delete the user?',
					updatePermissionsTitle: 'Update permissions',
					updatePermissionsBody:
						"You're about to change this user's permissions, this might sign them out. Are you sure?",
					enableMandatoryMfaTitle: 'Enable Mandatory MFA',
					enableMandatoryMfaBody:
						'Are you sure you want to enable mandatory MFA for your organisation? All users will be required to set up multi-factor authentication on their next login.',
					disableMandatoryMfaTitle: 'Disable Mandatory MFA',
					disableMandatoryMfaBody:
						'Are you sure you want to disable mandatory MFA for your organisation? Users will no longer be required to set up multi-factor authentication.',
					resetPreferencesTitle: 'Reset All Preferences',
					resetPreferencesBody:
						'This will reset ALL your preferences to default values, including:\n\n• Date, time, and name formats\n• Timezone settings\n• Color mode and split view\n• Table column widths and visibility\n• Filter layouts and panel sizes\n• All other saved UI customizations\n\nAre you sure you want to continue?',
				},
				messages: {
					notAllowedSetup2fa: 'You are not allowed to setup MFA for this user',
					notAllowedModify2fa:
						'You are not allowed to modify MFA for this user',
					userBlockedSuccess: 'User is blocked successfully',
					userUnblockedSuccess: 'User is unblocked successfully',
					roleUpdated: 'Role updated successfully',
					preferencesUpdated: 'Preferences updated successfully',
					verificationLinkSent:
						'We sent a confirmation link to {email}. Follow it to complete the change.',
					emailChangePendingTitle: 'Confirm your new email address',
					emailChangePendingBody:
						'A confirmation link was sent to {email}. Your sign-in email changes once you follow it; check your spam folder if it has not arrived.',
					unexpectedError: 'unexpected error happened, please try again',
					sessionsLoadFailed: 'Can not load sessions info for the user',
					organisationUndetermined: 'Unable to determine your organisation',
					mfaNowMandatory: 'MFA is now mandatory for your organisation',
					mfaNoLongerMandatory:
						'MFA is no longer mandatory for your organisation',
				},
				errors: {
					loadPreferences: 'Failed to load preferences.',
					updatePreferences: 'Failed to update preferences.',
					loadMfaMandatoryStatus: 'Failed to load MFA mandatory status.',
					enableMandatoryMfa: 'Failed to enable mandatory MFA.',
					disableMandatoryMfa: 'Failed to disable mandatory MFA.',
					unableDetermineUserProfile:
						'Unable to determine which user profile to load',
				},
				activity: {
					createdAtEntry: 'Created at:  {date}',
				},
				notificationsPrefs: {
					selfOnly: 'You can only manage your own notification preferences.',
					generalCategory: 'General',
					channels: {
						email: 'Email',
						inApp: 'In-app',
						sms: 'SMS',
					},
				},
			},
		},
		roles: {
			table: {
				noRows: 'No roles found',
				ceilingRole: 'Ceiling role',
			},
			details: {
				title: 'Role Details {suffix}',
				titleSuffix: 'for {name}',
				emptyDescription:
					'Select a role from the left panel to view its details and/or take actions on it.',
				deleteConfirm: 'Are you sure you want to delete this role?',
				deleteSuccess: 'Role deleted successfully',
				deleteError: 'Failed to delete roles',
				deleteErrorRequest: 'Failed to delete role',
			},
			form: {
				newTitle: 'New Role',
				editTitle: 'Edit Role',
				description:
					'Define what this role can access and the level of permissions they have.',
				roleNamePlaceholder: 'Enter role name (e.g. Case Manager)',
				newButton: 'Add Role',
				editButton: 'Update Role',
				updateWarningTitle: 'Update Role!',
				updateWarningBody:
					"Are you sure you want to update the role? Updating the role may affect user(s)'s access.",
				updateSuccess: 'Role updated successfully',
				updateError: 'Failed to update role',
				updateErrorRequest: 'Failed to update role.',
				addSuccess: 'Role added successfully',
				addError: 'Failed to add role',
				addErrorRequest: 'Failed to add role.',
				loadModuleRolesError: 'Failed to load module roles.',
				minOneRole:
					'At least one module role must be selected to create a role',
				notFound: 'That role no longer exists.',
				editNotAllowed: 'You are not allowed to edit that role.',
			},
			selector: {
				presetsLabel: 'Quick presets',
				custom: 'Custom',
				none: 'None',
				noModules: 'No modules are available to assign.',
				noRoles: 'No module roles assigned.',
				notDelegatableHint:
					'Some access here is above what you can grant. Those modules are read-only and are kept as they are when you save.',
				modules: {
					case: 'Case',
					aml: 'AML',
					cfm: 'Flows',
					forms: 'Forms',
					poa: 'Proof of Address',
					platform: 'Platform',
				},
				levels: {
					viewer: 'Viewer',
					operator: 'Operator',
					admin: 'Admin',
					user: 'User',
					owner: 'Owner',
					primaryOwner: 'Primary Owner',
				},
				grid: {
					areaHeader: 'Area',
					permissionsTitle: 'Permissions',
					permissionsSubtitle:
						'Set the access level for each area of the platform.',
					levelCaptions: {
						none: 'No access',
						viewer: 'View only',
						operator: 'Perform actions',
						admin: 'Full control',
					},
					moduleDescriptions: {
						case: 'Access and manage cases',
						aml: 'Access AML checks and records',
						cfm: 'Create and manage flows',
						forms: 'Create and manage forms',
						poa: 'Verify and manage documents',
						platform: 'Manage platform settings and users',
					},
				},
			},
			presets: {
				caseWorker: 'Case Worker',
				amlAnalyst: 'Auditor',
				cfmOperator: 'Developer',
				merchantAdmin: 'Organisation Admin',
				descriptions: {
					caseWorker: 'Work with cases and related data',
					amlAnalyst: 'Review and audit activities',
					cfmOperator: 'Build and integrate solutions',
					merchantAdmin: 'Manage organisation and settings',
					custom: 'Create a custom role from scratch',
				},
			},
		},
		twoFactor: {
			common: {
				step3ScanQrCode: 'Scan QR Code',
				qrCodeAlt: 'QR Code',
				noPhoneNumber:
					'No phone number found. Please add a phone number in your profile.',
				enterCodeFromApp: 'Enter the code from your app',
				dontHaveAuthenticatorApp: "Don't you have an authenticator app?",
				android: 'Android',
				ios: 'iOS',
				next: 'Next',
				enable: 'Enable',
				validateYourCode: 'Validate Your Code',
				changeVerificationMethod: 'Change Verification Method',
				successTitle: 'Success',
				errorTitle: 'Error',
				codeValidatedSuccess:
					'Code validated successfully, click Enable to proceed.',
				selectVerificationMethod: 'Please select a verification method.',
				saveBackupCodes: 'Please ensure to save your backup codes.',
				recoveryCodesCopied: 'Recovery codes copied to clipboard.',
				recoveryCodesCopyFailed:
					'Failed to copy recovery codes. Please try again.',
				verificationCodeSentAlternative:
					'Verification code sent via alternative channel',
				stepTitle: 'Step {step} - {title}',
				printTitles: {
					dev: 'QgenOnline Development MFA Recovery Codes',
					prod: 'QgenOnline MFA Recovery Codes',
				},
				errors: {
					loadVerificationMethods: 'Failed to load verification methods.',
					prepare: 'Failed to prepare MFA.',
					validateCode: 'Failed to validate code.',
					enable: 'Failed to enable MFA.',
					disable: 'Failed to disable MFA.',
					regenerateBackupCodes: 'Failed to re-generate backup codes.',
					loadMfaMandatoryStatus: 'Failed to load MFA mandatory status.',
				},
			},
			setup: {
				description:
					'Choose a verification method to enable MFA Authentication.',
				stepHeaders: {
					selectMethod: 'Select a Verification Method',
					recoveryCodes: 'Recovery Codes',
					scanQrCode: 'Scan QR Code',
				},
				recoveryCodesDescription:
					'Download, print, or copy your recovery codes before continuing.',
				step3Description: 'Scan the QR code with your authenticator app.',
				preValidateSuccess:
					'Code validated successfully, click Enable to proceed.',
				enableSuccess: 'MFA Authentication enabled successfully.',
				downloadOrCopyRequired:
					'Please download, print, or copy your recovery codes before continuing.',
			},
			edit: {
				currentMethodTitle: 'Current Method',
				currentMethod: 'Your current verification method is: {method}',
				manageTitle: 'Manage Current Setup',
				reRegister: 'Re-register MFA App',
				reRegisterDescription:
					'Re-scan the QR code to re-link your authenticator device.',
				reGenerateBackupCodes: 'Regenerate Backup Codes',
				reGenerateDescription:
					'Generate a new set of one-time emergency codes (invalidates old ones).',
				disable2fa: 'Disable MFA',
				disableDescription: 'Remove MFA from this account.',
				newBackupCodesTitle: 'New Backup Codes',
				newBackupCodesWarning:
					'Note that your old backup codes are invalidated and you are under the risk of losing access to your account if you lose your backup codes. So please make sure to save your new backup codes.',
				switchToDifferent: 'Switch to a different method',
				step2Title: 'New Backup Codes',
				step2Description:
					'Your verification method will be changed from {currentMethod} to {newMethod}, and old backup codes will be invalidated. Please note that you are under the risk of losing access to your account if you lose your backup codes. So please make sure to save your new backup codes.',
				step3Description: 'Scan the QR code with your authenticator app.',
				step4Title: 'Disable MFA',
				step4Confirm: 'Are you sure you want to disable MFA Authentication?',
				step4SmsInfo: 'You will receive a code via SMS to disable MFA.',
				step4EmailInfo: 'You will receive a code via Email to disable MFA.',
				disableCodePlaceholder: 'Enter the MFA code.',
				alternativeChannelQuestion:
					'Receive the code via alternative channel ?',
				alternativeChannelPlaceholder: 'Select an alternative channel',
				sendCodeAlternative: 'Send Code via Alternative Channel',
				reGenerateConfirmTitle: 'Re-Generate Backup Codes',
				reGenerateConfirmText:
					'Are you sure you want to re-generate backup codes?',
				reGenerateSuccess:
					'Backup codes re-generated successfully, please save them via download, print or copy.',
				settingsUpdatedSuccess:
					'MFA Authentication settings have been updated successfully.',
				disabledSuccess: 'MFA Authentication disabled successfully.',
				validCodeRequired: 'Please enter a valid code.',
				step2ButtonChangeMethod: 'Change Verification Method',
			},
		},
	},
	proofOfAddress: {
		title: 'Proof of address',
		new: {
			title: 'New proof of address submission',
			description:
				'Upload a proof of address document, optionally specify the declared country, and run the combined analysis response.',
		},
		detail: {
			loadFailed: 'Failed to load the proof of address submission.',
		},
		list: {
			title: 'Proof of address submissions',
			empty: 'No proof of address submissions found.',
			loadFailed: 'Failed to load proof of address submissions.',
			dialogs: {
				deleteSubmissions: {
					title: 'Delete proof of address submissions',
					body: 'Are you sure you want to delete {count} proof of address submission(s)?',
				},
			},
			messages: {
				submissionsDeleted:
					'{count} proof of address submission(s) deleted successfully.',
			},
			errors: {
				deleteSubmissions: 'Failed to delete proof of address submissions.',
				deleteSubmissionsPartial:
					'Deleted {count} of {total} proof of address submission(s). {reason}',
			},
			columns: {
				status: 'Status',
				companyName: 'Company name',
				extractionScore: 'Extraction score',
				genuinenessScore: 'Genuineness score',
				issuerLegitimacyScore: 'Issuer legitimacy score',
				linkedEntity: 'Linked entity',
			},
			filters: {
				title: 'Advanced search',
				searchPlaceholder: 'Search by company, customer, or document type',
				dateRange: 'Submitted',
				clearFilters: 'Clear filters',
			},
			delete: {
				linkedToCase: 'Unlink from the case before deleting',
				sessionCaptured:
					'Captured in a verification session — cannot be deleted',
				bulkPartial: 'Delete {count} of {total} selected',
				bulkUnavailable: 'Delete — no eligible submissions selected',
			},
		},
		actions: {
			newSubmission: 'New Submission',
			downloadFile: 'Download File',
			viewDocument: 'View Document',
		},
		link: {
			action: 'Link to entity',
			notLinked: 'Not linked',
			linkedToEntity: 'Linked to entity',
			popupTitle: 'Link proof of address to entity',
			popupDescription:
				'Search for a case or entity, then select the entity that should receive this proof of address result.',
			viewLinkedEntity: 'View linked entity',
			success: 'Proof of address submission linked.',
			successGoToEntityPrompt:
				'Would you like to go to the entity now, or stay here?',
			error: 'Failed to link proof of address submission.',
		},
		preview: {
			unavailable: 'Preview is not available for this submission.',
			loadFailed: 'Failed to load the submission file preview.',
		},
		form: {
			fileLabel: 'Proof of address document',
			fileHint:
				'Upload a single PDF, PNG, or JPEG file up to 10 MB. You can drag and drop it here or use Browse Files.',
			filePlaceholder: 'Drop your file here',
			documentCountry: 'Declared country',
			documentCountryPlaceholder: 'Select a country',
			checksTitle: 'Checks to run',
			genuinenessCheck: 'Genuineness check',
			issuerLegitimacyCheck: 'Issuer legitimacy check',
			analyze: 'Analyze',
			analyzing: 'Analyzing...',
			clear: 'Clear',
			analyzeHint:
				'The analysis runs in the background and usually takes about a minute. You will be taken to the submission as soon as it is uploaded.',
		},
		states: {
			loadingCountries: 'Loading countries...',
			noResults: 'The request completed without returning a result.',
		},
		sections: {
			extractions: 'Extractions',
			extractionsSub: 'OCR & field extraction · always runs',
			genuineness: 'Genuineness',
			genuinenessSub: 'Tamper & forgery analysis',
			issuerLegitimacy: 'Issuer legitimacy',
			issuerSub: 'Online issuer verification',
			overallStatus: 'Overall status',
			submissionDetails: 'Submission details',
			submissionDetailsSub: 'Metadata for this POA submission',
			ocr: 'OCR',
			metadata: 'Metadata',
		},
		fields: {
			submissionId: 'Submission ID',
			fileName: 'File name',
			fileType: 'File type',
			documentCountry: 'Declared country',
			genuinenessCheck: 'Genuineness check',
			issuerLegitimacyCheck: 'Issuer legitimacy check',
			executionTime: 'Execution time',
			createdAt: 'Created at',
			createdBy: 'Created by',
			invoiceNo: 'Invoice number',
			customerName: 'Customer name',
			address: 'Address',
			issuingCompany: 'Issuing company',
			issuingCompanyAddress: 'Issuing company address',
			issueDate: 'Issue date',
			documentType: 'Document type',
			websites: 'Websites',
			confidence: 'Confidence',
			extractionConfidence: 'Extraction confidence',
			failureReason: 'Failure reason',
			evidence: 'Evidence',
			evidenceProducer: 'Producer',
			evidenceCreationModification: 'Creation / modification',
			evidenceSignatures: 'Signatures',
			evidenceEditingSignals: 'Editing signals',
			evidenceStructuralIntegrity: 'Structural integrity',
			evidenceRegistryEvidence: 'Registry evidence',
			evidenceAddressEvidence: 'Address evidence',
			verdict: 'Verdict',
			score: 'Score',
			summary: 'Summary',
			assessment: 'Assessment',
			riskLevel: 'Risk level',
			addressMatch: 'Address match',
			companyExistsOnline: 'Company exists online',
			officialCompanyName: 'Official company name',
			officialCompanyAddress: 'Official company address',
			officialWebsite: 'Official website',
			queriedAddress: 'Queried address',
			sources: 'Sources',
			languages: 'Languages',
			greenFlags: 'Green flags',
			redFlags: 'Red flags',
		},
		verdict: {
			likelyGenuine: 'Likely genuine',
			likelyLegit: 'Likely legitimate',
			suspicious: 'Suspicious',
			inconclusive: 'Inconclusive',
			lowRisk: 'Low risk',
			mediumRisk: 'Medium risk',
			highRisk: 'High risk',
		},
		status: {
			extracted: 'Extracted',
			extractedWithWarnings: 'Extracted with warnings',
			failed: 'Failed',
			unknown: 'No analysis',
		},
		submissionStatus: {
			pending: 'Analysing',
			completed: 'Completed',
			failed: 'Failed',
		},
		progress: {
			title: 'Analysing the document',
			description:
				'The proof of address analysis is running in the background. This page updates on its own as soon as it finishes.',
			elapsed: 'Running for {duration}',
			stillProcessing: 'Still analysing',
			stillProcessingDescription:
				'This is taking longer than usual. The analysis is still running — check back shortly or refresh now.',
			refresh: 'Refresh',
			failedTitle: 'The analysis could not be completed',
		},
		diagnostics: {
			stepFailed: 'This step failed.',
			stepSkipped: 'This step was skipped.',
			reason: 'Reason',
			message: 'Message',
			error: 'Error',
		},
		errors: {
			selectFile: 'Please select a file to analyze.',
			fileTooLarge: 'The selected file exceeds the 10 MB limit.',
			invalidFileType: 'Please upload a PDF, PNG, or JPEG file.',
			loadCountries: 'Failed to load country codes.',
			analyzeFailed: 'Failed to analyze proof of address.',
		},
	},
	countrySelectModal: {
		title: 'Select Countries',
		continentSelection: 'Country Selection',
		selectedCountries: 'Selected Countries',
		selectedCount: '{count} countries selected',
		selectAll: 'Select all',
		selectAllMatches: 'Select all matches',
		search: 'Search',
		save: 'Save',
		cancel: 'Cancel',
		noSelection: 'No countries selected',
		noResults: 'No countries found',
	},
	flows: {
		overview: {
			title: 'Overview',
			tabs: {
				flows: 'Flows',
				steps: 'Steps',
			},
		},
		settings: {
			title: 'Settings',
			tabs: {
				general: 'General',
				theme: 'Theme',
			},
		},
	},
};
